/**
 * © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED
 * Tinder Obsidian v10.18.0
 * Do not edit directly
 * Generated on Fri, 01 Nov 2024 18:19:22 GMT
 */

import { ThemeColor, ThemeGradient } from '../types';
import { alphaColor } from '@tinderapp/ui-utils';
import {
  COLOR_BLACK,
  COLOR_BLUE_05,
  COLOR_BLUE_10,
  COLOR_BLUE_15,
  COLOR_BLUE_20,
  COLOR_BLUE_30,
  COLOR_BLUE_40,
  COLOR_BLUE_50,
  COLOR_BLUE_60,
  COLOR_BLUE_70,
  COLOR_BLUE_80,
  COLOR_BLUE_90,
  COLOR_BLUE_95,
  COLOR_BRAND_GRADIENT_START,
  COLOR_BRAND_PRIMARY,
  COLOR_BRAND_PRIMARY_A11Y,
  COLOR_FUCHSIA_05,
  COLOR_FUCHSIA_10,
  COLOR_FUCHSIA_15,
  COLOR_FUCHSIA_20,
  COLOR_FUCHSIA_30,
  COLOR_FUCHSIA_40,
  COLOR_FUCHSIA_50,
  COLOR_FUCHSIA_60,
  COLOR_FUCHSIA_70,
  COLOR_FUCHSIA_80,
  COLOR_FUCHSIA_90,
  COLOR_FUCHSIA_95,
  COLOR_GOLD_05,
  COLOR_GOLD_10,
  COLOR_GOLD_15,
  COLOR_GOLD_20,
  COLOR_GOLD_30,
  COLOR_GOLD_40,
  COLOR_GOLD_50,
  COLOR_GOLD_60,
  COLOR_GOLD_70,
  COLOR_GOLD_80,
  COLOR_GOLD_90,
  COLOR_GOLD_95,
  COLOR_GRAY_05,
  COLOR_GRAY_10,
  COLOR_GRAY_15,
  COLOR_GRAY_20,
  COLOR_GRAY_30,
  COLOR_GRAY_40,
  COLOR_GRAY_50,
  COLOR_GRAY_60,
  COLOR_GRAY_70,
  COLOR_GRAY_80,
  COLOR_GRAY_90,
  COLOR_GRAY_95,
  COLOR_GREEN_05,
  COLOR_GREEN_10,
  COLOR_GREEN_15,
  COLOR_GREEN_20,
  COLOR_GREEN_30,
  COLOR_GREEN_40,
  COLOR_GREEN_50,
  COLOR_GREEN_60,
  COLOR_GREEN_70,
  COLOR_GREEN_80,
  COLOR_GREEN_90,
  COLOR_GREEN_95,
  COLOR_PURPLE_05,
  COLOR_PURPLE_10,
  COLOR_PURPLE_15,
  COLOR_PURPLE_20,
  COLOR_PURPLE_30,
  COLOR_PURPLE_40,
  COLOR_PURPLE_50,
  COLOR_PURPLE_60,
  COLOR_PURPLE_70,
  COLOR_PURPLE_80,
  COLOR_PURPLE_90,
  COLOR_PURPLE_95,
  COLOR_RED_05,
  COLOR_RED_10,
  COLOR_RED_15,
  COLOR_RED_20,
  COLOR_RED_30,
  COLOR_RED_40,
  COLOR_RED_50,
  COLOR_RED_60,
  COLOR_RED_70,
  COLOR_RED_80,
  COLOR_RED_90,
  COLOR_RED_95,
  COLOR_SPARKS_BLUE_50,
  COLOR_SPARKS_BLUE_70,
  COLOR_SPARKS_GRAY_BLUE_15,
  COLOR_SPARKS_GRAY_BLUE_30,
  COLOR_SPARKS_GRAY_BLUE_80,
  COLOR_SPARKS_GRAY_BLUE_90,
  COLOR_SPARKS_GREEN_40,
  COLOR_SPARKS_ORANGE_50,
  COLOR_SPARKS_PINK_45,
  COLOR_SPARKS_PURPLE_60,
  COLOR_SPARKS_RED_60,
  COLOR_SPARKS_TEAL_20,
  COLOR_SPARKS_YELLOW_20,
  COLOR_TEAL_05,
  COLOR_TEAL_10,
  COLOR_TEAL_15,
  COLOR_TEAL_20,
  COLOR_TEAL_30,
  COLOR_TEAL_40,
  COLOR_TEAL_50,
  COLOR_TEAL_60,
  COLOR_TEAL_70,
  COLOR_TEAL_80,
  COLOR_TEAL_90,
  COLOR_TEAL_95,
  COLOR_THIRD_PARTY_NOONLIGHT_PRIMARY,
  COLOR_THIRD_PARTY_NOONLIGHT_SECONDARY,
  COLOR_THIRD_PARTY_SPOTIFY_PRIMARY,
  COLOR_THIRD_PARTY_SPOTIFY_PRIMARY_INVERSE,
  COLOR_TRANSPARENT,
  COLOR_VAULT_PRIMARY,
  COLOR_VAULT_PRIMARY_LIGHT,
  COLOR_WHITE,
  COLOR_YELLOW_ORANGE_05,
  COLOR_YELLOW_ORANGE_10,
  COLOR_YELLOW_ORANGE_15,
  COLOR_YELLOW_ORANGE_20,
  COLOR_YELLOW_ORANGE_30,
  COLOR_YELLOW_ORANGE_40,
  COLOR_YELLOW_ORANGE_50,
  COLOR_YELLOW_ORANGE_60,
  COLOR_YELLOW_ORANGE_70,
  COLOR_YELLOW_ORANGE_80,
  COLOR_YELLOW_ORANGE_90,
  COLOR_YELLOW_ORANGE_95,
  GRADIENT_BRAND_GRADIENT,
  GRADIENT_BRAND_SUBTLE,
  GRADIENT_BRAND_SUBTLE_ON_DARK,
  GRADIENT_EXPLORE_ATTRIBUTION_GRADIENT,
  GRADIENT_FESTIVAL_MODE_GRADIENT,
  GRADIENT_GAMEPAD_BOOST,
  GRADIENT_GAMEPAD_BOOST_ON_DARK,
  GRADIENT_GAMEPAD_BOOST_SUBTLE,
  GRADIENT_GAMEPAD_BOOST_SUBTLE_ON_DARK,
  GRADIENT_GAMEPAD_LIKE,
  GRADIENT_GAMEPAD_LIKE_ON_DARK,
  GRADIENT_GAMEPAD_LIKE_ON_LIGHT,
  GRADIENT_GAMEPAD_LIKE_SUBTLE,
  GRADIENT_GAMEPAD_LIKE_SUBTLE_ON_DARK,
  GRADIENT_GAMEPAD_NOPE,
  GRADIENT_GAMEPAD_NOPE_ON_DARK,
  GRADIENT_GAMEPAD_REWIND,
  GRADIENT_GAMEPAD_REWIND_ON_DARK,
  GRADIENT_GAMEPAD_SPARKS_BOOST,
  GRADIENT_GAMEPAD_SPARKS_LIKE,
  GRADIENT_GAMEPAD_SPARKS_NOPE,
  GRADIENT_GAMEPAD_SPARKS_REWIND,
  GRADIENT_GAMEPAD_SPARKS_SUPER_LIKE,
  GRADIENT_GAMEPAD_SUPER_BOOST,
  GRADIENT_GAMEPAD_SUPER_BOOST_ON_DARK,
  GRADIENT_GAMEPAD_SUPER_BOOST_SUBTLE,
  GRADIENT_GAMEPAD_SUPER_BOOST_SUBTLE_ON_DARK,
  GRADIENT_GAMEPAD_SUPER_LIKE,
  GRADIENT_GAMEPAD_SUPER_LIKE_ON_DARK,
  GRADIENT_GAMEPAD_SUPER_LIKE_ON_LIGHT,
  GRADIENT_GAMEPAD_SUPER_LIKE_SUBTLE,
  GRADIENT_GAMEPAD_SUPER_LIKE_SUBTLE_ON_DARK,
  GRADIENT_HOT_TAKES_GRADIENT,
  GRADIENT_MATCH_EXPIRATION_GRADIENT,
  GRADIENT_MATCH_EXPIRATION_GRADIENT_ON_DARK,
  GRADIENT_PASSIONS_GRADIENT,
  GRADIENT_REVENUE_GOLD,
  GRADIENT_REVENUE_GOLD_ON_DARK,
  GRADIENT_REVENUE_GOLD_SHINE,
  GRADIENT_REVENUE_GOLD_SHINE_ANIMATION,
  GRADIENT_REVENUE_GOLD_SHINE_ANIMATION_ON_DARK,
  GRADIENT_REVENUE_GOLD_SHINE_ON_DARK,
  GRADIENT_REVENUE_GOLD_SUBTLE,
  GRADIENT_REVENUE_GOLD_SUBTLE_ON_DARK,
  GRADIENT_REVENUE_PLATINUM,
  GRADIENT_REVENUE_PLATINUM_ON_DARK,
  GRADIENT_REVENUE_PLATINUM_SHINE,
  GRADIENT_REVENUE_PLATINUM_SHINE_ANIMATION,
  GRADIENT_REVENUE_PLATINUM_SHINE_ANIMATION_ON_DARK,
  GRADIENT_REVENUE_PLATINUM_SHINE_ON_DARK,
  GRADIENT_REVENUE_PLATINUM_SUBTLE,
  GRADIENT_REVENUE_PLATINUM_SUBTLE_ON_DARK,
  GRADIENT_REVENUE_PLUS_SUBTLE,
  GRADIENT_REVENUE_PLUS_SUBTLE_ON_DARK,
  GRADIENT_SPARKS_BACKGROUND_GRADIENT,
  GRADIENT_SPARKS_BACKGROUND_GRADIENT_DARK,
  GRADIENT_SPARKS_MATCHMAKER_ATTRIBUTION,
  GRADIENT_SPOTIFY_MUSIC_MODE_GRADIENT,
  GRADIENT_VAULT_GRADIENT,
  GRADIENT_VAULT_SUBTLE_ON_DARK,
  GRADIENT_VAULT_SUBTLE_ON_LIGHT,
  GRADIENT_VIBES_GRADIENT,
} from './palette';

export const COLOR_DARK_INVERTIBLE_WHITE = COLOR_BLACK;
export const COLOR_DARK_INVERTIBLE_BLACK = COLOR_WHITE;
export const COLOR_DARK_INVERTIBLE_GRAY_10 = COLOR_GRAY_95;
export const COLOR_DARK_INVERTIBLE_GRAY_15 = COLOR_GRAY_90;
export const COLOR_DARK_INVERTIBLE_GRAY_20 = COLOR_GRAY_80;
export const COLOR_DARK_INVERTIBLE_GRAY_30 = COLOR_GRAY_80;
export const COLOR_DARK_INVERTIBLE_GRAY_40 = COLOR_GRAY_70;
export const COLOR_DARK_INVERTIBLE_GRAY_50 = COLOR_GRAY_60;
export const COLOR_DARK_INVERTIBLE_GRAY_60 = COLOR_GRAY_50;
export const COLOR_DARK_INVERTIBLE_GRAY_70 = COLOR_GRAY_40;
export const COLOR_DARK_INVERTIBLE_GRAY_80 = COLOR_GRAY_20;
export const COLOR_DARK_INVERTIBLE_GRAY_90 = COLOR_GRAY_15;
export const COLOR_DARK_INVERTIBLE_GRAY_95 = COLOR_GRAY_10;
export const COLOR_DARK_INVERTIBLE_GRAY_05 = COLOR_GRAY_95;
export const COLOR_DARK_INVERTIBLE_GREEN_10 = COLOR_GREEN_95;
export const COLOR_DARK_INVERTIBLE_GREEN_15 = COLOR_GREEN_90;
export const COLOR_DARK_INVERTIBLE_GREEN_20 = COLOR_GREEN_80;
export const COLOR_DARK_INVERTIBLE_GREEN_30 = COLOR_GREEN_80;
export const COLOR_DARK_INVERTIBLE_GREEN_40 = COLOR_GREEN_70;
export const COLOR_DARK_INVERTIBLE_GREEN_50 = COLOR_GREEN_60;
export const COLOR_DARK_INVERTIBLE_GREEN_60 = COLOR_GREEN_50;
export const COLOR_DARK_INVERTIBLE_GREEN_70 = COLOR_GREEN_40;
export const COLOR_DARK_INVERTIBLE_GREEN_80 = COLOR_GREEN_20;
export const COLOR_DARK_INVERTIBLE_GREEN_90 = COLOR_GREEN_15;
export const COLOR_DARK_INVERTIBLE_GREEN_95 = COLOR_GREEN_10;
export const COLOR_DARK_INVERTIBLE_GREEN_05 = COLOR_GREEN_95;
export const COLOR_DARK_INVERTIBLE_TEAL_10 = COLOR_TEAL_95;
export const COLOR_DARK_INVERTIBLE_TEAL_15 = COLOR_TEAL_90;
export const COLOR_DARK_INVERTIBLE_TEAL_20 = COLOR_TEAL_80;
export const COLOR_DARK_INVERTIBLE_TEAL_30 = COLOR_TEAL_80;
export const COLOR_DARK_INVERTIBLE_TEAL_40 = COLOR_TEAL_70;
export const COLOR_DARK_INVERTIBLE_TEAL_50 = COLOR_TEAL_60;
export const COLOR_DARK_INVERTIBLE_TEAL_60 = COLOR_TEAL_50;
export const COLOR_DARK_INVERTIBLE_TEAL_70 = COLOR_TEAL_40;
export const COLOR_DARK_INVERTIBLE_TEAL_80 = COLOR_TEAL_20;
export const COLOR_DARK_INVERTIBLE_TEAL_90 = COLOR_TEAL_15;
export const COLOR_DARK_INVERTIBLE_TEAL_95 = COLOR_TEAL_10;
export const COLOR_DARK_INVERTIBLE_TEAL_05 = COLOR_TEAL_95;
export const COLOR_DARK_INVERTIBLE_BLUE_10 = COLOR_BLUE_95;
export const COLOR_DARK_INVERTIBLE_BLUE_15 = COLOR_BLUE_90;
export const COLOR_DARK_INVERTIBLE_BLUE_20 = COLOR_BLUE_80;
export const COLOR_DARK_INVERTIBLE_BLUE_30 = COLOR_BLUE_80;
export const COLOR_DARK_INVERTIBLE_BLUE_40 = COLOR_BLUE_70;
export const COLOR_DARK_INVERTIBLE_BLUE_50 = COLOR_BLUE_60;
export const COLOR_DARK_INVERTIBLE_BLUE_60 = COLOR_BLUE_50;
export const COLOR_DARK_INVERTIBLE_BLUE_70 = COLOR_BLUE_40;
export const COLOR_DARK_INVERTIBLE_BLUE_80 = COLOR_BLUE_20;
export const COLOR_DARK_INVERTIBLE_BLUE_90 = COLOR_BLUE_15;
export const COLOR_DARK_INVERTIBLE_BLUE_95 = COLOR_BLUE_10;
export const COLOR_DARK_INVERTIBLE_BLUE_05 = COLOR_BLUE_95;
export const COLOR_DARK_INVERTIBLE_PURPLE_10 = COLOR_PURPLE_95;
export const COLOR_DARK_INVERTIBLE_PURPLE_15 = COLOR_PURPLE_90;
export const COLOR_DARK_INVERTIBLE_PURPLE_20 = COLOR_PURPLE_80;
export const COLOR_DARK_INVERTIBLE_PURPLE_30 = COLOR_PURPLE_80;
export const COLOR_DARK_INVERTIBLE_PURPLE_40 = COLOR_PURPLE_70;
export const COLOR_DARK_INVERTIBLE_PURPLE_50 = COLOR_PURPLE_60;
export const COLOR_DARK_INVERTIBLE_PURPLE_60 = COLOR_PURPLE_50;
export const COLOR_DARK_INVERTIBLE_PURPLE_70 = COLOR_PURPLE_40;
export const COLOR_DARK_INVERTIBLE_PURPLE_80 = COLOR_PURPLE_20;
export const COLOR_DARK_INVERTIBLE_PURPLE_90 = COLOR_PURPLE_15;
export const COLOR_DARK_INVERTIBLE_PURPLE_95 = COLOR_PURPLE_10;
export const COLOR_DARK_INVERTIBLE_PURPLE_05 = COLOR_PURPLE_95;
export const COLOR_DARK_INVERTIBLE_FUCHSIA_10 = COLOR_FUCHSIA_95;
export const COLOR_DARK_INVERTIBLE_FUCHSIA_15 = COLOR_FUCHSIA_90;
export const COLOR_DARK_INVERTIBLE_FUCHSIA_20 = COLOR_FUCHSIA_80;
export const COLOR_DARK_INVERTIBLE_FUCHSIA_30 = COLOR_FUCHSIA_80;
export const COLOR_DARK_INVERTIBLE_FUCHSIA_40 = COLOR_FUCHSIA_70;
export const COLOR_DARK_INVERTIBLE_FUCHSIA_50 = COLOR_FUCHSIA_60;
export const COLOR_DARK_INVERTIBLE_FUCHSIA_60 = COLOR_FUCHSIA_50;
export const COLOR_DARK_INVERTIBLE_FUCHSIA_70 = COLOR_FUCHSIA_40;
export const COLOR_DARK_INVERTIBLE_FUCHSIA_80 = COLOR_FUCHSIA_20;
export const COLOR_DARK_INVERTIBLE_FUCHSIA_90 = COLOR_FUCHSIA_15;
export const COLOR_DARK_INVERTIBLE_FUCHSIA_95 = COLOR_FUCHSIA_10;
export const COLOR_DARK_INVERTIBLE_FUCHSIA_05 = COLOR_FUCHSIA_95;
export const COLOR_DARK_INVERTIBLE_RED_10 = COLOR_RED_95;
export const COLOR_DARK_INVERTIBLE_RED_15 = COLOR_RED_90;
export const COLOR_DARK_INVERTIBLE_RED_20 = COLOR_RED_80;
export const COLOR_DARK_INVERTIBLE_RED_30 = COLOR_RED_80;
export const COLOR_DARK_INVERTIBLE_RED_40 = COLOR_RED_70;
export const COLOR_DARK_INVERTIBLE_RED_50 = COLOR_RED_60;
export const COLOR_DARK_INVERTIBLE_RED_60 = COLOR_RED_50;
export const COLOR_DARK_INVERTIBLE_RED_70 = COLOR_RED_40;
export const COLOR_DARK_INVERTIBLE_RED_80 = COLOR_RED_20;
export const COLOR_DARK_INVERTIBLE_RED_90 = COLOR_RED_15;
export const COLOR_DARK_INVERTIBLE_RED_95 = COLOR_RED_10;
export const COLOR_DARK_INVERTIBLE_RED_05 = COLOR_RED_95;
export const COLOR_DARK_INVERTIBLE_YELLOW_ORANGE_10 = COLOR_YELLOW_ORANGE_95;
export const COLOR_DARK_INVERTIBLE_YELLOW_ORANGE_15 = COLOR_YELLOW_ORANGE_90;
export const COLOR_DARK_INVERTIBLE_YELLOW_ORANGE_20 = COLOR_YELLOW_ORANGE_80;
export const COLOR_DARK_INVERTIBLE_YELLOW_ORANGE_30 = COLOR_YELLOW_ORANGE_80;
export const COLOR_DARK_INVERTIBLE_YELLOW_ORANGE_40 = COLOR_YELLOW_ORANGE_70;
export const COLOR_DARK_INVERTIBLE_YELLOW_ORANGE_50 = COLOR_YELLOW_ORANGE_60;
export const COLOR_DARK_INVERTIBLE_YELLOW_ORANGE_60 = COLOR_YELLOW_ORANGE_50;
export const COLOR_DARK_INVERTIBLE_YELLOW_ORANGE_70 = COLOR_YELLOW_ORANGE_40;
export const COLOR_DARK_INVERTIBLE_YELLOW_ORANGE_80 = COLOR_YELLOW_ORANGE_20;
export const COLOR_DARK_INVERTIBLE_YELLOW_ORANGE_90 = COLOR_YELLOW_ORANGE_15;
export const COLOR_DARK_INVERTIBLE_YELLOW_ORANGE_95 = COLOR_YELLOW_ORANGE_10;
export const COLOR_DARK_INVERTIBLE_YELLOW_ORANGE_05 = COLOR_YELLOW_ORANGE_95;
export const COLOR_DARK_INVERTIBLE_GOLD_10 = COLOR_GOLD_95;
export const COLOR_DARK_INVERTIBLE_GOLD_15 = COLOR_GOLD_90;
export const COLOR_DARK_INVERTIBLE_GOLD_20 = COLOR_GOLD_80;
export const COLOR_DARK_INVERTIBLE_GOLD_30 = COLOR_GOLD_80;
export const COLOR_DARK_INVERTIBLE_GOLD_40 = COLOR_GOLD_70;
export const COLOR_DARK_INVERTIBLE_GOLD_50 = COLOR_GOLD_60;
export const COLOR_DARK_INVERTIBLE_GOLD_60 = COLOR_GOLD_50;
export const COLOR_DARK_INVERTIBLE_GOLD_70 = COLOR_GOLD_40;
export const COLOR_DARK_INVERTIBLE_GOLD_80 = COLOR_GOLD_20;
export const COLOR_DARK_INVERTIBLE_GOLD_90 = COLOR_GOLD_15;
export const COLOR_DARK_INVERTIBLE_GOLD_95 = COLOR_GOLD_10;
export const COLOR_DARK_INVERTIBLE_GOLD_05 = COLOR_GOLD_95;
export const COLOR_DARK_BACKGROUND_BADGE_VERIFIED_DEFAULT = COLOR_BLUE_50;
export const COLOR_DARK_BACKGROUND_BADGE_ONLINE_NOW_DEFAULT = COLOR_GREEN_15;
export const COLOR_DARK_TEXT_BADGE_NOTIFICATION_DEFAULT = COLOR_WHITE;
export const COLOR_DARK_BACKGROUND_BUTTON_PRIMARY_SMALL = COLOR_BRAND_PRIMARY_A11Y;
export const COLOR_DARK_BACKGROUND_BUTTON_PRIMARY_OVERLAY = COLOR_WHITE;
export const COLOR_DARK_BACKGROUND_BUTTON_DISABLED = COLOR_GRAY_80;
export const COLOR_DARK_BACKGROUND_BUTTON_ELEVATED = COLOR_GRAY_90;
export const COLOR_DARK_BACKGROUND_BUTTON_SPARKS_NEUTRAL = COLOR_GRAY_80;
export const COLOR_DARK_BACKGROUND_BUTTON_SPARKS_EXPAND_PROFILE: ThemeColor = alphaColor(
  COLOR_BLACK,
  0.6
);
export const COLOR_DARK_BORDER_BUTTON_SECONDARY_OVERLAY = COLOR_WHITE;
export const COLOR_DARK_BORDER_BUTTON_SPARKS_EXPAND_PROFILE: ThemeColor = alphaColor(
  COLOR_WHITE,
  0.4
);
export const COLOR_DARK_FOREGROUND_BUTTON_PRIMARY = COLOR_WHITE;
export const COLOR_DARK_FOREGROUND_BUTTON_PRIMARY_OVERLAY = COLOR_GRAY_90;
export const COLOR_DARK_FOREGROUND_BUTTON_SECONDARY_OVERLAY = COLOR_WHITE;
export const COLOR_DARK_FOREGROUND_BUTTON_TERTIARY_OVERLAY = COLOR_WHITE;
export const COLOR_DARK_FOREGROUND_BUTTON_DISABLED = COLOR_GRAY_60;
export const COLOR_DARK_FOREGROUND_BUTTON_SPARKS_EXPAND_PROFILE = COLOR_WHITE;
export const COLOR_DARK_BACKGROUND_CHAT_BUBBLE_SEND = COLOR_BLUE_60;
export const COLOR_DARK_BACKGROUND_DATEPICKER_SELECTED = COLOR_GRAY_90;
export const COLOR_DARK_BACKGROUND_GAMEPAD_PRIMARY_DEFAULT: ThemeColor = alphaColor(
  COLOR_BLACK,
  0.8
);
export const COLOR_DARK_BACKGROUND_GAMEPAD_PRIMARY_DISABLED = COLOR_GRAY_90;
export const COLOR_DARK_BACKGROUND_GAMEPAD_PRIMARY_DISABLED_ON_SUPER_LIKE: ThemeColor = alphaColor(
  COLOR_BLACK,
  0.2
);
export const COLOR_DARK_BACKGROUND_GAMEPAD_SPARKS_REWIND_DEFAULT = COLOR_GRAY_90;
export const COLOR_DARK_BACKGROUND_GAMEPAD_SPARKS_NOPE_DEFAULT = COLOR_GRAY_90;
export const COLOR_DARK_BACKGROUND_GAMEPAD_SPARKS_SUPER_LIKE_DEFAULT = COLOR_GRAY_90;
export const COLOR_DARK_BACKGROUND_GAMEPAD_SPARKS_LIKE_DEFAULT = COLOR_GRAY_90;
export const COLOR_DARK_BACKGROUND_GAMEPAD_SPARKS_BOOST_DEFAULT = COLOR_GRAY_90;
export const COLOR_DARK_BORDER_GAMEPAD_PRIMARY_DISABLED = COLOR_GRAY_80;
export const COLOR_DARK_BORDER_GAMEPAD_PRIMARY_DISABLED_ON_SUPER_LIKE = COLOR_GRAY_40;
export const COLOR_DARK_BORDER_GAMEPAD_REWIND_DEFAULT = COLOR_YELLOW_ORANGE_50;
export const COLOR_DARK_BORDER_GAMEPAD_NOPE_DEFAULT = COLOR_BRAND_PRIMARY;
export const COLOR_DARK_BORDER_GAMEPAD_SUPER_LIKE_DEFAULT = COLOR_BLUE_50;
export const COLOR_DARK_BORDER_GAMEPAD_SUPER_LIKE_DISABLED = COLOR_GRAY_40;
export const COLOR_DARK_BORDER_GAMEPAD_LIKE_DEFAULT = COLOR_GREEN_50;
export const COLOR_DARK_BORDER_GAMEPAD_BOOST_DEFAULT = COLOR_PURPLE_50;
export const COLOR_DARK_ICON_GAMEPAD_PRIMARY_DISABLED = COLOR_GRAY_80;
export const COLOR_DARK_ICON_GAMEPAD_PRIMARY_DISABLED_ON_SUPER_LIKE = COLOR_GRAY_40;
export const COLOR_DARK_ICON_GAMEPAD_PRIMARY_SUPER_LIKE_DISABLED = COLOR_GRAY_40;
export const COLOR_DARK_LABEL_GAMEPAD_PRIMARY_COUNT_SUPER_LIKE = COLOR_BLUE_40;
export const COLOR_DARK_LABEL_GAMEPAD_PRIMARY_COUNT_BOOST = COLOR_PURPLE_40;
export const COLOR_DARK_BACKGROUND_ICON_BUTTON_OVERLAY_DEFAULT: ThemeColor = alphaColor(
  COLOR_GRAY_95,
  0.8
);
export const COLOR_DARK_BACKGROUND_ICON_BUTTON_OVERLAY_DISABLED = COLOR_GRAY_90;
export const COLOR_DARK_ICON_ICON_BUTTON_OVERLAY_DISABLED = COLOR_GRAY_80;
export const COLOR_DARK_BACKGROUND_MODAL_OVERLAY_DEFAULT: ThemeColor = alphaColor(
  COLOR_BLACK,
  0.5569
);
export const COLOR_DARK_BACKGROUND_MODAL_OVERLAY_RECS: ThemeColor = alphaColor(COLOR_BLACK, 0.8);
export const COLOR_DARK_ICON_NAVIGATION_PRIMARY_INACTIVE = COLOR_GRAY_60;
export const COLOR_DARK_ICON_NAVIGATION_SECONDARY_END = COLOR_BLUE_60;
export const COLOR_DARK_BACKGROUND_PASSIONS_EDIT = COLOR_GRAY_60;
export const COLOR_DARK_BACKGROUND_PASSIONS_INACTIVE_OVERLAY: ThemeColor = alphaColor(
  COLOR_GRAY_70,
  0.8
);
export const COLOR_DARK_BACKGROUND_PASSIONS_SHARED_OVERLAY: ThemeColor = alphaColor(
  COLOR_GRAY_80,
  0.8
);
export const COLOR_DARK_BACKGROUND_PASSIONS_SPARKS_INACTIVE_OVERLAY: ThemeColor = alphaColor(
  COLOR_BLACK,
  0.4
);
export const COLOR_DARK_BACKGROUND_PASSIONS_SPARKS_INACTIVE = COLOR_GRAY_90;
export const COLOR_DARK_BACKGROUND_RADIO_SELECTED_DISABLED = COLOR_GRAY_80;
export const COLOR_DARK_ICON_RADIO_SELECTED_DISABLED = COLOR_GRAY_90;
export const COLOR_DARK_BACKGROUND_REC_CARD_CONTENT_HIDDEN: ThemeColor = alphaColor(
  COLOR_WHITE,
  0.2471
);
export const COLOR_DARK_BACKGROUND_REC_CARD_BOTTOM_DEFAULT = COLOR_BLACK;
export const COLOR_DARK_BACKGROUND_REC_CARD_BOTTOM_SUPER_LIKE = COLOR_BLUE_60;
export const COLOR_DARK_SUB_CARD_REC_CARD_SPARKS = COLOR_GRAY_95;
export const COLOR_DARK_BACKGROUND_SLIDER_DEFAULT_KNOB_ENABLED = COLOR_WHITE;
export const COLOR_DARK_BACKGROUND_SLIDER_DEFAULT_KNOB_DISABLED = COLOR_GRAY_90;
export const COLOR_DARK_BACKGROUND_SWITCH_ALT_TRACK_SELECTED = COLOR_RED_95;
export const COLOR_DARK_BACKGROUND_SWITCH_ALT_TRACK_UNSELECTED = COLOR_GRAY_90;
export const COLOR_DARK_BACKGROUND_SWITCH_ALT_TRACK_DISABLED = COLOR_GRAY_90;
export const COLOR_DARK_BACKGROUND_SWITCH_ALT_KNOB_UNSELECTED = COLOR_GRAY_60;
export const COLOR_DARK_BACKGROUND_TAPPY_INDICATOR_ACTIVE = COLOR_WHITE;
export const COLOR_DARK_BACKGROUND_TAPPY_INDICATOR_INACTIVE = COLOR_GRAY_70;
export const COLOR_DARK_BACKGROUND_TAPPY_INDICATOR_SPARKS_ACTIVE = COLOR_WHITE;
export const COLOR_DARK_BACKGROUND_TAPPY_INDICATOR_SPARKS_INACTIVE: ThemeColor = alphaColor(
  COLOR_BLACK,
  0.5608
);
export const COLOR_DARK_BACKGROUND_TAPPY_CONTAINER_DEFAULT: ThemeColor = alphaColor(
  COLOR_GRAY_10,
  0.702
);
export const COLOR_DARK_BACKGROUND_TAPPY_SPARKS: ThemeColor = alphaColor(
  COLOR_SPARKS_GRAY_BLUE_80,
  0.702
);
export const COLOR_DARK_BORDER_TAPPY_INDICATOR_ACTIVE = COLOR_GRAY_70;
export const COLOR_DARK_BORDER_TAPPY_INDICATOR_SPARKS_ACTIVE = COLOR_GRAY_50;
export const COLOR_DARK_BORDER_TAPPY_INDICATOR_SPARKS_INACTIVE = COLOR_GRAY_50;
export const COLOR_DARK_DIVIDER_TAPPY_SPARKS: ThemeColor = alphaColor(COLOR_GRAY_15, 0.1216);
export const COLOR_DARK_BACKGROUND_TEXT_FIELD_QUIET_HIGHLIGHT = COLOR_BLUE_80;
export const COLOR_DARK_BACKGROUND_TEXT_FIELD_LOUD_HIGHLIGHT = COLOR_BLUE_80;
export const COLOR_DARK_BACKGROUND_TOOLTIP_DEFAULT = COLOR_GRAY_10;
export const COLOR_DARK_BACKGROUND_TOOLTIP_REVENUE_DEFAULT = COLOR_GRAY_10;
export const COLOR_DARK_BACKGROUND_TOOLTIP_TRUST_DEFAULT = COLOR_BLUE_60;
export const COLOR_DARK_BORDER_TOOLTIP_DEFAULT = COLOR_GRAY_10;
export const COLOR_DARK_BORDER_TOOLTIP_REVENUE_BOOST = COLOR_PURPLE_50;
export const COLOR_DARK_BORDER_TOOLTIP_REVENUE_NOPE = COLOR_RED_50;
export const COLOR_DARK_BORDER_TOOLTIP_REVENUE_LIKE = COLOR_GREEN_50;
export const COLOR_DARK_BORDER_TOOLTIP_REVENUE_SUPER_LIKE = COLOR_BLUE_50;
export const COLOR_DARK_BORDER_TOOLTIP_REVENUE_REWIND = COLOR_YELLOW_ORANGE_50;
export const COLOR_DARK_ACCENT_PRIMARY = COLOR_BRAND_PRIMARY;
export const COLOR_DARK_ACCENT_PRIMARY_A11Y = COLOR_BRAND_PRIMARY;
export const COLOR_DARK_ACCENT_BRAND = COLOR_BRAND_PRIMARY;
export const COLOR_DARK_ACCENT_LIKE = COLOR_GREEN_50;
export const COLOR_DARK_ACCENT_NOPE = COLOR_RED_50;
export const COLOR_DARK_ACCENT_SUPER_LIKE = COLOR_BLUE_50;
export const COLOR_DARK_ACCENT_BOOST = COLOR_PURPLE_50;
export const COLOR_DARK_ACCENT_REWIND = COLOR_YELLOW_ORANGE_50;
export const COLOR_DARK_ACCENT_GOLD = COLOR_GOLD_50;
export const COLOR_DARK_ACCENT_PLATINUM = COLOR_GRAY_10;
export const COLOR_DARK_ACCENT_SELECT = COLOR_VAULT_PRIMARY_LIGHT;
export const COLOR_DARK_ACCENT_ERROR = COLOR_RED_50;
export const COLOR_DARK_ACCENT_SUCCESS = COLOR_GREEN_50;
export const COLOR_DARK_ACCENT_ACTIVE = COLOR_BLUE_50;
export const COLOR_DARK_ACCENT_LINK = COLOR_BLUE_50;
export const COLOR_DARK_ACCENT_CHAT = COLOR_BLUE_60;
export const COLOR_DARK_ACCENT_TRUST = COLOR_BLUE_50;
export const COLOR_DARK_ACCENT_BLUE = COLOR_BLUE_50;
export const COLOR_DARK_ACCENT_FUCHSIA = COLOR_FUCHSIA_50;
export const COLOR_DARK_ACCENT_GREEN = COLOR_GREEN_50;
export const COLOR_DARK_ACCENT_PURPLE = COLOR_PURPLE_50;
export const COLOR_DARK_ACCENT_RED = COLOR_RED_50;
export const COLOR_DARK_ACCENT_TEAL = COLOR_TEAL_50;
export const COLOR_DARK_ACCENT_YELLOW_ORANGE = COLOR_YELLOW_ORANGE_50;
export const COLOR_DARK_BACKGROUND_PRIMARY = COLOR_GRAY_95;
export const COLOR_DARK_BACKGROUND_PRIMARY_INVERSE = COLOR_WHITE;
export const COLOR_DARK_BACKGROUND_SECONDARY = COLOR_BLACK;
export const COLOR_DARK_BACKGROUND_SECONDARY_INVERSE = COLOR_GRAY_10;
export const COLOR_DARK_BACKGROUND_TERTIARY = COLOR_GRAY_90;
export const COLOR_DARK_BACKGROUND_TERTIARY_INVERSE = COLOR_GRAY_15;
export const COLOR_DARK_BACKGROUND_INACTIVE = COLOR_GRAY_60;
export const COLOR_DARK_BACKGROUND_PRIMARY_STATIC_LIGHT = COLOR_WHITE;
export const COLOR_DARK_BACKGROUND_PRIMARY_STATIC_DARK = COLOR_GRAY_95;
export const COLOR_DARK_BACKGROUND_SECONDARY_STATIC_LIGHT = COLOR_GRAY_10;
export const COLOR_DARK_BACKGROUND_SECONDARY_STATIC_DARK = COLOR_GRAY_90;
export const COLOR_DARK_BACKGROUND_DISABLED = COLOR_GRAY_90;
export const COLOR_DARK_BACKGROUND_GREEN = COLOR_GREEN_95;
export const COLOR_DARK_BACKGROUND_TEAL = COLOR_TEAL_95;
export const COLOR_DARK_BACKGROUND_BLUE = COLOR_BLUE_95;
export const COLOR_DARK_BACKGROUND_PURPLE = COLOR_PURPLE_95;
export const COLOR_DARK_BACKGROUND_FUCHSIA = COLOR_FUCHSIA_95;
export const COLOR_DARK_BACKGROUND_RED = COLOR_RED_95;
export const COLOR_DARK_BACKGROUND_YELLOW_ORANGE = COLOR_YELLOW_ORANGE_95;
export const COLOR_DARK_BACKGROUND_RIPPLE_DEFAULT = COLOR_GRAY_80;
export const COLOR_DARK_BACKGROUND_SPARKS_PROFILE = COLOR_BLACK;
export const COLOR_DARK_BACKGROUND_SPARKS_BOTTOM_NAV = COLOR_BLACK;
export const COLOR_DARK_BACKGROUND_SPARKS_PROMPT = COLOR_SPARKS_GRAY_BLUE_90;
export const COLOR_DARK_BACKGROUND_TRUST = COLOR_BLUE_95;
export const COLOR_DARK_BORDER_SPARKS_LIKE = COLOR_SPARKS_GREEN_40;
export const COLOR_DARK_BORDER_SPARKS_NOPE = COLOR_SPARKS_RED_60;
export const COLOR_DARK_BORDER_SPARKS_SUPER_LIKE = COLOR_SPARKS_BLUE_50;
export const COLOR_DARK_BORDER_SPARKS_BOOST = COLOR_SPARKS_PURPLE_60;
export const COLOR_DARK_BORDER_SPARKS_REWIND = COLOR_SPARKS_ORANGE_50;
export const COLOR_DARK_FOREGROUND_PRIMARY = COLOR_GRAY_10;
export const COLOR_DARK_FOREGROUND_PRIMARY_INVERSE = COLOR_GRAY_90;
export const COLOR_DARK_FOREGROUND_SECONDARY = COLOR_GRAY_30;
export const COLOR_DARK_FOREGROUND_SECONDARY_INVERSE = COLOR_GRAY_60;
export const COLOR_DARK_FOREGROUND_INACTIVE = COLOR_GRAY_50;
export const COLOR_DARK_FOREGROUND_DISABLED = COLOR_GRAY_70;
export const COLOR_DARK_FOREGROUND_PRIMARY_STATIC_LIGHT = COLOR_WHITE;
export const COLOR_DARK_FOREGROUND_PRIMARY_STATIC_DARK = COLOR_GRAY_90;
export const COLOR_DARK_FOREGROUND_SECONDARY_STATIC_LIGHT = COLOR_GRAY_30;
export const COLOR_DARK_FOREGROUND_SECONDARY_STATIC_DARK = COLOR_GRAY_70;
export const COLOR_DARK_FOREGROUND_BORDER_PRIMARY = COLOR_GRAY_50;
export const COLOR_DARK_FOREGROUND_BORDER_SECONDARY = COLOR_GRAY_80;
export const COLOR_DARK_ICON_SECONDARY = COLOR_GRAY_50;
export const COLOR_DARK_ICON_CHAT_DRAWER_SPOTIFY_FOREGROUND_ACTIVE =
  COLOR_THIRD_PARTY_SPOTIFY_PRIMARY_INVERSE;
export const COLOR_DARK_ICON_CHAT_DRAWER_SPOTIFY_BACKGROUND_ACTIVE =
  COLOR_THIRD_PARTY_SPOTIFY_PRIMARY;
export const COLOR_DARK_ICON_CHAT_DRAWER_NOONLIGHT_FOREGROUND_ACTIVE =
  COLOR_THIRD_PARTY_NOONLIGHT_PRIMARY;
export const COLOR_DARK_ICON_CHAT_DRAWER_NOONLIGHT_BACKGROUND_ACTIVE =
  COLOR_THIRD_PARTY_NOONLIGHT_SECONDARY;
export const COLOR_DARK_INTERACTIVE_PRIMARY: ThemeColor = alphaColor(COLOR_GRAY_10, 0.1608);
export const COLOR_DARK_INTERACTIVE_SECONDARY: ThemeColor = alphaColor(COLOR_GRAY_10, 0.0784);
export const COLOR_DARK_INTERACTIVE_ON_LIGHT: ThemeColor = alphaColor(COLOR_GRAY_95, 0.1608);
export const COLOR_DARK_LOADER_SHIMMER_BASE_DEFAULT = COLOR_GRAY_90;
export const COLOR_DARK_LOADER_SHIMMER_HIGHLIGHT_DEFAULT = COLOR_GRAY_80;
export const COLOR_DARK_OVERLAY_DEFAULT: ThemeColor = alphaColor(COLOR_BLACK, 0.7804);
export const COLOR_DARK_SHADOW_CONTAINER_ELEVATED = COLOR_TRANSPARENT;
export const COLOR_LIGHT_INVERTIBLE_WHITE = COLOR_WHITE;
export const COLOR_LIGHT_INVERTIBLE_BLACK = COLOR_BLACK;
export const COLOR_LIGHT_INVERTIBLE_GRAY_10 = COLOR_GRAY_10;
export const COLOR_LIGHT_INVERTIBLE_GRAY_15 = COLOR_GRAY_15;
export const COLOR_LIGHT_INVERTIBLE_GRAY_20 = COLOR_GRAY_20;
export const COLOR_LIGHT_INVERTIBLE_GRAY_30 = COLOR_GRAY_30;
export const COLOR_LIGHT_INVERTIBLE_GRAY_40 = COLOR_GRAY_40;
export const COLOR_LIGHT_INVERTIBLE_GRAY_50 = COLOR_GRAY_50;
export const COLOR_LIGHT_INVERTIBLE_GRAY_60 = COLOR_GRAY_60;
export const COLOR_LIGHT_INVERTIBLE_GRAY_70 = COLOR_GRAY_70;
export const COLOR_LIGHT_INVERTIBLE_GRAY_80 = COLOR_GRAY_80;
export const COLOR_LIGHT_INVERTIBLE_GRAY_90 = COLOR_GRAY_90;
export const COLOR_LIGHT_INVERTIBLE_GRAY_95 = COLOR_GRAY_95;
export const COLOR_LIGHT_INVERTIBLE_GRAY_05 = COLOR_GRAY_05;
export const COLOR_LIGHT_INVERTIBLE_GREEN_10 = COLOR_GREEN_10;
export const COLOR_LIGHT_INVERTIBLE_GREEN_15 = COLOR_GREEN_15;
export const COLOR_LIGHT_INVERTIBLE_GREEN_20 = COLOR_GREEN_20;
export const COLOR_LIGHT_INVERTIBLE_GREEN_30 = COLOR_GREEN_30;
export const COLOR_LIGHT_INVERTIBLE_GREEN_40 = COLOR_GREEN_40;
export const COLOR_LIGHT_INVERTIBLE_GREEN_50 = COLOR_GREEN_50;
export const COLOR_LIGHT_INVERTIBLE_GREEN_60 = COLOR_GREEN_60;
export const COLOR_LIGHT_INVERTIBLE_GREEN_70 = COLOR_GREEN_70;
export const COLOR_LIGHT_INVERTIBLE_GREEN_80 = COLOR_GREEN_80;
export const COLOR_LIGHT_INVERTIBLE_GREEN_90 = COLOR_GREEN_90;
export const COLOR_LIGHT_INVERTIBLE_GREEN_95 = COLOR_GREEN_95;
export const COLOR_LIGHT_INVERTIBLE_GREEN_05 = COLOR_GREEN_05;
export const COLOR_LIGHT_INVERTIBLE_TEAL_10 = COLOR_TEAL_10;
export const COLOR_LIGHT_INVERTIBLE_TEAL_15 = COLOR_TEAL_15;
export const COLOR_LIGHT_INVERTIBLE_TEAL_20 = COLOR_TEAL_20;
export const COLOR_LIGHT_INVERTIBLE_TEAL_30 = COLOR_TEAL_30;
export const COLOR_LIGHT_INVERTIBLE_TEAL_40 = COLOR_TEAL_40;
export const COLOR_LIGHT_INVERTIBLE_TEAL_50 = COLOR_TEAL_50;
export const COLOR_LIGHT_INVERTIBLE_TEAL_60 = COLOR_TEAL_60;
export const COLOR_LIGHT_INVERTIBLE_TEAL_70 = COLOR_TEAL_70;
export const COLOR_LIGHT_INVERTIBLE_TEAL_80 = COLOR_TEAL_80;
export const COLOR_LIGHT_INVERTIBLE_TEAL_90 = COLOR_TEAL_90;
export const COLOR_LIGHT_INVERTIBLE_TEAL_95 = COLOR_TEAL_95;
export const COLOR_LIGHT_INVERTIBLE_TEAL_05 = COLOR_TEAL_05;
export const COLOR_LIGHT_INVERTIBLE_BLUE_10 = COLOR_BLUE_10;
export const COLOR_LIGHT_INVERTIBLE_BLUE_15 = COLOR_BLUE_15;
export const COLOR_LIGHT_INVERTIBLE_BLUE_20 = COLOR_BLUE_20;
export const COLOR_LIGHT_INVERTIBLE_BLUE_30 = COLOR_BLUE_30;
export const COLOR_LIGHT_INVERTIBLE_BLUE_40 = COLOR_BLUE_40;
export const COLOR_LIGHT_INVERTIBLE_BLUE_50 = COLOR_BLUE_50;
export const COLOR_LIGHT_INVERTIBLE_BLUE_60 = COLOR_BLUE_60;
export const COLOR_LIGHT_INVERTIBLE_BLUE_70 = COLOR_BLUE_70;
export const COLOR_LIGHT_INVERTIBLE_BLUE_80 = COLOR_BLUE_80;
export const COLOR_LIGHT_INVERTIBLE_BLUE_90 = COLOR_BLUE_90;
export const COLOR_LIGHT_INVERTIBLE_BLUE_95 = COLOR_BLUE_95;
export const COLOR_LIGHT_INVERTIBLE_BLUE_05 = COLOR_BLUE_05;
export const COLOR_LIGHT_INVERTIBLE_PURPLE_10 = COLOR_PURPLE_10;
export const COLOR_LIGHT_INVERTIBLE_PURPLE_15 = COLOR_PURPLE_15;
export const COLOR_LIGHT_INVERTIBLE_PURPLE_20 = COLOR_PURPLE_20;
export const COLOR_LIGHT_INVERTIBLE_PURPLE_30 = COLOR_PURPLE_30;
export const COLOR_LIGHT_INVERTIBLE_PURPLE_40 = COLOR_PURPLE_40;
export const COLOR_LIGHT_INVERTIBLE_PURPLE_50 = COLOR_PURPLE_50;
export const COLOR_LIGHT_INVERTIBLE_PURPLE_60 = COLOR_PURPLE_60;
export const COLOR_LIGHT_INVERTIBLE_PURPLE_70 = COLOR_PURPLE_70;
export const COLOR_LIGHT_INVERTIBLE_PURPLE_80 = COLOR_PURPLE_80;
export const COLOR_LIGHT_INVERTIBLE_PURPLE_90 = COLOR_PURPLE_90;
export const COLOR_LIGHT_INVERTIBLE_PURPLE_95 = COLOR_PURPLE_95;
export const COLOR_LIGHT_INVERTIBLE_PURPLE_05 = COLOR_PURPLE_05;
export const COLOR_LIGHT_INVERTIBLE_FUCHSIA_10 = COLOR_FUCHSIA_10;
export const COLOR_LIGHT_INVERTIBLE_FUCHSIA_15 = COLOR_FUCHSIA_15;
export const COLOR_LIGHT_INVERTIBLE_FUCHSIA_20 = COLOR_FUCHSIA_20;
export const COLOR_LIGHT_INVERTIBLE_FUCHSIA_30 = COLOR_FUCHSIA_30;
export const COLOR_LIGHT_INVERTIBLE_FUCHSIA_40 = COLOR_FUCHSIA_40;
export const COLOR_LIGHT_INVERTIBLE_FUCHSIA_50 = COLOR_FUCHSIA_50;
export const COLOR_LIGHT_INVERTIBLE_FUCHSIA_60 = COLOR_FUCHSIA_60;
export const COLOR_LIGHT_INVERTIBLE_FUCHSIA_70 = COLOR_FUCHSIA_70;
export const COLOR_LIGHT_INVERTIBLE_FUCHSIA_80 = COLOR_FUCHSIA_80;
export const COLOR_LIGHT_INVERTIBLE_FUCHSIA_90 = COLOR_FUCHSIA_90;
export const COLOR_LIGHT_INVERTIBLE_FUCHSIA_95 = COLOR_FUCHSIA_95;
export const COLOR_LIGHT_INVERTIBLE_FUCHSIA_05 = COLOR_FUCHSIA_05;
export const COLOR_LIGHT_INVERTIBLE_RED_10 = COLOR_RED_10;
export const COLOR_LIGHT_INVERTIBLE_RED_15 = COLOR_RED_15;
export const COLOR_LIGHT_INVERTIBLE_RED_20 = COLOR_RED_20;
export const COLOR_LIGHT_INVERTIBLE_RED_30 = COLOR_RED_30;
export const COLOR_LIGHT_INVERTIBLE_RED_40 = COLOR_RED_40;
export const COLOR_LIGHT_INVERTIBLE_RED_50 = COLOR_RED_50;
export const COLOR_LIGHT_INVERTIBLE_RED_60 = COLOR_RED_60;
export const COLOR_LIGHT_INVERTIBLE_RED_70 = COLOR_RED_70;
export const COLOR_LIGHT_INVERTIBLE_RED_80 = COLOR_RED_80;
export const COLOR_LIGHT_INVERTIBLE_RED_90 = COLOR_RED_90;
export const COLOR_LIGHT_INVERTIBLE_RED_95 = COLOR_RED_95;
export const COLOR_LIGHT_INVERTIBLE_RED_05 = COLOR_RED_05;
export const COLOR_LIGHT_INVERTIBLE_YELLOW_ORANGE_10 = COLOR_YELLOW_ORANGE_10;
export const COLOR_LIGHT_INVERTIBLE_YELLOW_ORANGE_15 = COLOR_YELLOW_ORANGE_15;
export const COLOR_LIGHT_INVERTIBLE_YELLOW_ORANGE_20 = COLOR_YELLOW_ORANGE_20;
export const COLOR_LIGHT_INVERTIBLE_YELLOW_ORANGE_30 = COLOR_YELLOW_ORANGE_30;
export const COLOR_LIGHT_INVERTIBLE_YELLOW_ORANGE_40 = COLOR_YELLOW_ORANGE_40;
export const COLOR_LIGHT_INVERTIBLE_YELLOW_ORANGE_50 = COLOR_YELLOW_ORANGE_50;
export const COLOR_LIGHT_INVERTIBLE_YELLOW_ORANGE_60 = COLOR_YELLOW_ORANGE_60;
export const COLOR_LIGHT_INVERTIBLE_YELLOW_ORANGE_70 = COLOR_YELLOW_ORANGE_70;
export const COLOR_LIGHT_INVERTIBLE_YELLOW_ORANGE_80 = COLOR_YELLOW_ORANGE_80;
export const COLOR_LIGHT_INVERTIBLE_YELLOW_ORANGE_90 = COLOR_YELLOW_ORANGE_90;
export const COLOR_LIGHT_INVERTIBLE_YELLOW_ORANGE_95 = COLOR_YELLOW_ORANGE_95;
export const COLOR_LIGHT_INVERTIBLE_YELLOW_ORANGE_05 = COLOR_YELLOW_ORANGE_05;
export const COLOR_LIGHT_INVERTIBLE_GOLD_10 = COLOR_GOLD_10;
export const COLOR_LIGHT_INVERTIBLE_GOLD_15 = COLOR_GOLD_15;
export const COLOR_LIGHT_INVERTIBLE_GOLD_20 = COLOR_GOLD_20;
export const COLOR_LIGHT_INVERTIBLE_GOLD_30 = COLOR_GOLD_30;
export const COLOR_LIGHT_INVERTIBLE_GOLD_40 = COLOR_GOLD_40;
export const COLOR_LIGHT_INVERTIBLE_GOLD_50 = COLOR_GOLD_50;
export const COLOR_LIGHT_INVERTIBLE_GOLD_60 = COLOR_GOLD_60;
export const COLOR_LIGHT_INVERTIBLE_GOLD_70 = COLOR_GOLD_70;
export const COLOR_LIGHT_INVERTIBLE_GOLD_80 = COLOR_GOLD_80;
export const COLOR_LIGHT_INVERTIBLE_GOLD_90 = COLOR_GOLD_90;
export const COLOR_LIGHT_INVERTIBLE_GOLD_95 = COLOR_GOLD_95;
export const COLOR_LIGHT_INVERTIBLE_GOLD_05 = COLOR_GOLD_05;
export const COLOR_LIGHT_BACKGROUND_BADGE_VERIFIED_DEFAULT = COLOR_BLUE_60;
export const COLOR_LIGHT_BACKGROUND_BADGE_ONLINE_NOW_DEFAULT = COLOR_GREEN_15;
export const COLOR_LIGHT_TEXT_BADGE_NOTIFICATION_DEFAULT = COLOR_WHITE;
export const COLOR_LIGHT_BACKGROUND_BUTTON_PRIMARY_SMALL = COLOR_BRAND_PRIMARY_A11Y;
export const COLOR_LIGHT_BACKGROUND_BUTTON_PRIMARY_OVERLAY = COLOR_WHITE;
export const COLOR_LIGHT_BACKGROUND_BUTTON_ELEVATED = COLOR_WHITE;
export const COLOR_LIGHT_BACKGROUND_BUTTON_SPARKS_NEUTRAL = COLOR_GRAY_80;
export const COLOR_LIGHT_BACKGROUND_BUTTON_SPARKS_EXPAND_PROFILE: ThemeColor = alphaColor(
  COLOR_BLACK,
  0.6
);
export const COLOR_LIGHT_BORDER_BUTTON_SECONDARY_OVERLAY = COLOR_WHITE;
export const COLOR_LIGHT_BORDER_BUTTON_SPARKS_EXPAND_PROFILE: ThemeColor = alphaColor(
  COLOR_WHITE,
  0.4
);
export const COLOR_LIGHT_FOREGROUND_BUTTON_PRIMARY = COLOR_WHITE;
export const COLOR_LIGHT_FOREGROUND_BUTTON_PRIMARY_OVERLAY = COLOR_GRAY_90;
export const COLOR_LIGHT_FOREGROUND_BUTTON_SECONDARY_OVERLAY = COLOR_WHITE;
export const COLOR_LIGHT_FOREGROUND_BUTTON_TERTIARY_OVERLAY = COLOR_WHITE;
export const COLOR_LIGHT_FOREGROUND_BUTTON_DISABLED = COLOR_GRAY_50;
export const COLOR_LIGHT_FOREGROUND_BUTTON_SPARKS_EXPAND_PROFILE = COLOR_WHITE;
export const COLOR_LIGHT_BACKGROUND_CHAT_BUBBLE_SEND = COLOR_BLUE_60;
export const COLOR_LIGHT_BACKGROUND_CHECKBOX_DISABLED = COLOR_GRAY_15;
export const COLOR_LIGHT_BACKGROUND_GAMEPAD_PRIMARY_DEFAULT: ThemeColor = alphaColor(
  COLOR_BLACK,
  0.8
);
export const COLOR_LIGHT_BACKGROUND_GAMEPAD_PRIMARY_DISABLED = COLOR_GRAY_90;
export const COLOR_LIGHT_BACKGROUND_GAMEPAD_PRIMARY_DISABLED_ON_SUPER_LIKE: ThemeColor = alphaColor(
  COLOR_BLACK,
  0.2
);
export const COLOR_LIGHT_BACKGROUND_GAMEPAD_SPARKS_REWIND_DEFAULT = COLOR_WHITE;
export const COLOR_LIGHT_BACKGROUND_GAMEPAD_SPARKS_NOPE_DEFAULT = COLOR_WHITE;
export const COLOR_LIGHT_BACKGROUND_GAMEPAD_SPARKS_SUPER_LIKE_DEFAULT = COLOR_WHITE;
export const COLOR_LIGHT_BACKGROUND_GAMEPAD_SPARKS_LIKE_DEFAULT = COLOR_WHITE;
export const COLOR_LIGHT_BACKGROUND_GAMEPAD_SPARKS_BOOST_DEFAULT = COLOR_WHITE;
export const COLOR_LIGHT_BORDER_GAMEPAD_PRIMARY_DISABLED = COLOR_GRAY_80;
export const COLOR_LIGHT_BORDER_GAMEPAD_PRIMARY_DISABLED_ON_SUPER_LIKE = COLOR_GRAY_40;
export const COLOR_LIGHT_BORDER_GAMEPAD_REWIND_DEFAULT = COLOR_YELLOW_ORANGE_50;
export const COLOR_LIGHT_BORDER_GAMEPAD_NOPE_DEFAULT = COLOR_BRAND_PRIMARY;
export const COLOR_LIGHT_BORDER_GAMEPAD_SUPER_LIKE_DEFAULT = COLOR_BLUE_50;
export const COLOR_LIGHT_BORDER_GAMEPAD_SUPER_LIKE_DISABLED = COLOR_GRAY_40;
export const COLOR_LIGHT_BORDER_GAMEPAD_LIKE_DEFAULT = COLOR_GREEN_50;
export const COLOR_LIGHT_BORDER_GAMEPAD_BOOST_DEFAULT = COLOR_PURPLE_50;
export const COLOR_LIGHT_ICON_GAMEPAD_PRIMARY_DISABLED = COLOR_GRAY_80;
export const COLOR_LIGHT_ICON_GAMEPAD_PRIMARY_DISABLED_ON_SUPER_LIKE = COLOR_GRAY_40;
export const COLOR_LIGHT_ICON_GAMEPAD_PRIMARY_SUPER_LIKE_DISABLED = COLOR_GRAY_40;
export const COLOR_LIGHT_LABEL_GAMEPAD_PRIMARY_COUNT_SUPER_LIKE = COLOR_BLUE_40;
export const COLOR_LIGHT_LABEL_GAMEPAD_PRIMARY_COUNT_BOOST = COLOR_PURPLE_40;
export const COLOR_LIGHT_BACKGROUND_ICON_BUTTON_OVERLAY_DEFAULT: ThemeColor = alphaColor(
  COLOR_GRAY_95,
  0.8
);
export const COLOR_LIGHT_BACKGROUND_ICON_BUTTON_OVERLAY_DISABLED = COLOR_GRAY_90;
export const COLOR_LIGHT_ICON_ICON_BUTTON_OVERLAY_DISABLED = COLOR_GRAY_80;
export const COLOR_LIGHT_BACKGROUND_MODAL_OVERLAY_DEFAULT: ThemeColor = alphaColor(
  COLOR_BLACK,
  0.5569
);
export const COLOR_LIGHT_BACKGROUND_MODAL_OVERLAY_RECS: ThemeColor = alphaColor(COLOR_BLACK, 0.8);
export const COLOR_LIGHT_ICON_NAVIGATION_PRIMARY_INACTIVE = COLOR_GRAY_50;
export const COLOR_LIGHT_ICON_NAVIGATION_SECONDARY_END = COLOR_BLUE_50;
export const COLOR_LIGHT_BACKGROUND_PASSIONS_EDIT = COLOR_GRAY_70;
export const COLOR_LIGHT_BACKGROUND_PASSIONS_INACTIVE_OVERLAY: ThemeColor = alphaColor(
  COLOR_GRAY_70,
  0.8
);
export const COLOR_LIGHT_BACKGROUND_PASSIONS_SHARED_OVERLAY: ThemeColor = alphaColor(
  COLOR_GRAY_80,
  0.8
);
export const COLOR_LIGHT_BACKGROUND_PASSIONS_SPARKS_INACTIVE_OVERLAY: ThemeColor = alphaColor(
  COLOR_BLACK,
  0.4
);
export const COLOR_LIGHT_BACKGROUND_PASSIONS_SPARKS_INACTIVE = COLOR_GRAY_10;
export const COLOR_LIGHT_BACKGROUND_RADIO_SELECTED_DISABLED = COLOR_GRAY_30;
export const COLOR_LIGHT_ICON_RADIO_SELECTED_DISABLED = COLOR_GRAY_15;
export const COLOR_LIGHT_BACKGROUND_REC_CARD_CONTENT_HIDDEN: ThemeColor = alphaColor(
  COLOR_WHITE,
  0.2471
);
export const COLOR_LIGHT_BACKGROUND_REC_CARD_BOTTOM_DEFAULT = COLOR_BLACK;
export const COLOR_LIGHT_BACKGROUND_REC_CARD_BOTTOM_SUPER_LIKE = COLOR_SPARKS_BLUE_50;
export const COLOR_LIGHT_SUB_CARD_REC_CARD_SPARKS = COLOR_SPARKS_GRAY_BLUE_30;
export const COLOR_LIGHT_BACKGROUND_SLIDER_DEFAULT_KNOB_ENABLED = COLOR_WHITE;
export const COLOR_LIGHT_BACKGROUND_SLIDER_DEFAULT_KNOB_DISABLED = COLOR_WHITE;
export const COLOR_LIGHT_BACKGROUND_SWITCH_ALT_TRACK_SELECTED = COLOR_RED_10;
export const COLOR_LIGHT_BACKGROUND_SWITCH_ALT_KNOB_UNSELECTED = COLOR_GRAY_50;
export const COLOR_LIGHT_BACKGROUND_SWITCH_ALT_KNOB_DISABLED = COLOR_GRAY_30;
export const COLOR_LIGHT_BACKGROUND_SWITCH_DEFAULT_KNOB_UNSELECTED = COLOR_WHITE;
export const COLOR_LIGHT_BORDER_SWITCH_ALT_KNOB_DISABLED = COLOR_GRAY_30;
export const COLOR_LIGHT_BACKGROUND_TAPPY_INDICATOR_ACTIVE = COLOR_WHITE;
export const COLOR_LIGHT_BACKGROUND_TAPPY_INDICATOR_INACTIVE = COLOR_GRAY_70;
export const COLOR_LIGHT_BACKGROUND_TAPPY_INDICATOR_SPARKS_ACTIVE = COLOR_WHITE;
export const COLOR_LIGHT_BACKGROUND_TAPPY_INDICATOR_SPARKS_INACTIVE: ThemeColor = alphaColor(
  COLOR_BLACK,
  0.5608
);
export const COLOR_LIGHT_BACKGROUND_TAPPY_CONTAINER_DEFAULT: ThemeColor = alphaColor(
  COLOR_GRAY_10,
  0.702
);
export const COLOR_LIGHT_BACKGROUND_TAPPY_SPARKS: ThemeColor = alphaColor(
  COLOR_SPARKS_GRAY_BLUE_80,
  0.702
);
export const COLOR_LIGHT_BORDER_TAPPY_INDICATOR_ACTIVE = COLOR_GRAY_70;
export const COLOR_LIGHT_BORDER_TAPPY_INDICATOR_SPARKS_ACTIVE = COLOR_GRAY_50;
export const COLOR_LIGHT_BORDER_TAPPY_INDICATOR_SPARKS_INACTIVE = COLOR_GRAY_50;
export const COLOR_LIGHT_DIVIDER_TAPPY_SPARKS: ThemeColor = alphaColor(COLOR_GRAY_15, 0.1216);
export const COLOR_LIGHT_BACKGROUND_TEXT_FIELD_QUIET_HIGHLIGHT = COLOR_BLUE_10;
export const COLOR_LIGHT_BACKGROUND_TEXT_FIELD_LOUD_HIGHLIGHT = COLOR_BLUE_10;
export const COLOR_LIGHT_BORDER_TEXT_FIELD_LOUD_DEFAULT = COLOR_GRAY_50;
export const COLOR_LIGHT_BACKGROUND_TOOLTIP_DEFAULT = COLOR_GRAY_80;
export const COLOR_LIGHT_BACKGROUND_TOOLTIP_REVENUE_DEFAULT = COLOR_GRAY_80;
export const COLOR_LIGHT_BACKGROUND_TOOLTIP_TRUST_DEFAULT = COLOR_BLUE_60;
export const COLOR_LIGHT_BORDER_TOOLTIP_DEFAULT = COLOR_GRAY_80;
export const COLOR_LIGHT_BORDER_TOOLTIP_REVENUE_BOOST = COLOR_PURPLE_40;
export const COLOR_LIGHT_BORDER_TOOLTIP_REVENUE_NOPE = COLOR_RED_40;
export const COLOR_LIGHT_BORDER_TOOLTIP_REVENUE_LIKE = COLOR_GREEN_40;
export const COLOR_LIGHT_BORDER_TOOLTIP_REVENUE_SUPER_LIKE = COLOR_BLUE_40;
export const COLOR_LIGHT_BORDER_TOOLTIP_REVENUE_REWIND = COLOR_YELLOW_ORANGE_40;
export const COLOR_LIGHT_ACCENT_PRIMARY = COLOR_BRAND_PRIMARY;
export const COLOR_LIGHT_ACCENT_PRIMARY_A11Y = COLOR_BRAND_PRIMARY_A11Y;
export const COLOR_LIGHT_ACCENT_BRAND = COLOR_BRAND_PRIMARY;
export const COLOR_LIGHT_ACCENT_LIKE = COLOR_GREEN_60;
export const COLOR_LIGHT_ACCENT_NOPE = COLOR_RED_60;
export const COLOR_LIGHT_ACCENT_SUPER_LIKE = COLOR_BLUE_60;
export const COLOR_LIGHT_ACCENT_BOOST = COLOR_PURPLE_60;
export const COLOR_LIGHT_ACCENT_REWIND = COLOR_YELLOW_ORANGE_60;
export const COLOR_LIGHT_ACCENT_GOLD = COLOR_GOLD_60;
export const COLOR_LIGHT_ACCENT_PLATINUM = COLOR_GRAY_95;
export const COLOR_LIGHT_ACCENT_SELECT = COLOR_VAULT_PRIMARY;
export const COLOR_LIGHT_ACCENT_ERROR = COLOR_RED_60;
export const COLOR_LIGHT_ACCENT_SUCCESS = COLOR_GREEN_60;
export const COLOR_LIGHT_ACCENT_ACTIVE = COLOR_BLUE_60;
export const COLOR_LIGHT_ACCENT_LINK = COLOR_BLUE_60;
export const COLOR_LIGHT_ACCENT_CHAT = COLOR_BLUE_60;
export const COLOR_LIGHT_ACCENT_TRUST = COLOR_BLUE_60;
export const COLOR_LIGHT_ACCENT_BLUE = COLOR_BLUE_60;
export const COLOR_LIGHT_ACCENT_FUCHSIA = COLOR_FUCHSIA_60;
export const COLOR_LIGHT_ACCENT_GREEN = COLOR_GREEN_60;
export const COLOR_LIGHT_ACCENT_PURPLE = COLOR_PURPLE_60;
export const COLOR_LIGHT_ACCENT_RED = COLOR_RED_60;
export const COLOR_LIGHT_ACCENT_TEAL = COLOR_TEAL_60;
export const COLOR_LIGHT_ACCENT_YELLOW_ORANGE = COLOR_YELLOW_ORANGE_60;
export const COLOR_LIGHT_BACKGROUND_PRIMARY = COLOR_WHITE;
export const COLOR_LIGHT_BACKGROUND_PRIMARY_INVERSE = COLOR_BLACK;
export const COLOR_LIGHT_BACKGROUND_SECONDARY = COLOR_GRAY_10;
export const COLOR_LIGHT_BACKGROUND_SECONDARY_INVERSE = COLOR_GRAY_95;
export const COLOR_LIGHT_BACKGROUND_TERTIARY = COLOR_GRAY_15;
export const COLOR_LIGHT_BACKGROUND_TERTIARY_INVERSE = COLOR_GRAY_90;
export const COLOR_LIGHT_BACKGROUND_INACTIVE = COLOR_GRAY_50;
export const COLOR_LIGHT_BACKGROUND_PRIMARY_STATIC_LIGHT = COLOR_WHITE;
export const COLOR_LIGHT_BACKGROUND_PRIMARY_STATIC_DARK = COLOR_GRAY_95;
export const COLOR_LIGHT_BACKGROUND_SECONDARY_STATIC_LIGHT = COLOR_GRAY_10;
export const COLOR_LIGHT_BACKGROUND_SECONDARY_STATIC_DARK = COLOR_GRAY_90;
export const COLOR_LIGHT_BACKGROUND_GREEN = COLOR_GREEN_05;
export const COLOR_LIGHT_BACKGROUND_TEAL = COLOR_TEAL_05;
export const COLOR_LIGHT_BACKGROUND_BLUE = COLOR_BLUE_05;
export const COLOR_LIGHT_BACKGROUND_PURPLE = COLOR_PURPLE_05;
export const COLOR_LIGHT_BACKGROUND_FUCHSIA = COLOR_FUCHSIA_05;
export const COLOR_LIGHT_BACKGROUND_RED = COLOR_RED_05;
export const COLOR_LIGHT_BACKGROUND_YELLOW_ORANGE = COLOR_YELLOW_ORANGE_05;
export const COLOR_LIGHT_BACKGROUND_RIPPLE_DEFAULT = COLOR_GRAY_20;
export const COLOR_LIGHT_BACKGROUND_SPARKS_PROFILE = COLOR_SPARKS_GRAY_BLUE_30;
export const COLOR_LIGHT_BACKGROUND_SPARKS_BOTTOM_NAV = COLOR_SPARKS_GRAY_BLUE_15;
export const COLOR_LIGHT_BACKGROUND_SPARKS_PROMPT = COLOR_SPARKS_GRAY_BLUE_15;
export const COLOR_LIGHT_BACKGROUND_TRUST = COLOR_BLUE_10;
export const COLOR_LIGHT_BORDER_SPARKS_LIKE = COLOR_SPARKS_GREEN_40;
export const COLOR_LIGHT_BORDER_SPARKS_NOPE = COLOR_SPARKS_RED_60;
export const COLOR_LIGHT_BORDER_SPARKS_SUPER_LIKE = COLOR_SPARKS_BLUE_50;
export const COLOR_LIGHT_BORDER_SPARKS_BOOST = COLOR_SPARKS_PURPLE_60;
export const COLOR_LIGHT_BORDER_SPARKS_REWIND = COLOR_SPARKS_ORANGE_50;
export const COLOR_LIGHT_FOREGROUND_PRIMARY = COLOR_GRAY_90;
export const COLOR_LIGHT_FOREGROUND_PRIMARY_INVERSE = COLOR_GRAY_05;
export const COLOR_LIGHT_FOREGROUND_SECONDARY = COLOR_GRAY_70;
export const COLOR_LIGHT_FOREGROUND_SECONDARY_INVERSE = COLOR_GRAY_40;
export const COLOR_LIGHT_FOREGROUND_INACTIVE = COLOR_GRAY_60;
export const COLOR_LIGHT_FOREGROUND_DISABLED = COLOR_GRAY_40;
export const COLOR_LIGHT_FOREGROUND_PRIMARY_STATIC_LIGHT = COLOR_WHITE;
export const COLOR_LIGHT_FOREGROUND_PRIMARY_STATIC_DARK = COLOR_GRAY_90;
export const COLOR_LIGHT_FOREGROUND_SECONDARY_STATIC_LIGHT = COLOR_GRAY_30;
export const COLOR_LIGHT_FOREGROUND_SECONDARY_STATIC_DARK = COLOR_GRAY_70;
export const COLOR_LIGHT_FOREGROUND_BORDER_PRIMARY = COLOR_GRAY_50;
export const COLOR_LIGHT_FOREGROUND_BORDER_SECONDARY = COLOR_GRAY_20;
export const COLOR_LIGHT_ICON_SECONDARY = COLOR_GRAY_50;
export const COLOR_LIGHT_ICON_CHAT_DRAWER_SPOTIFY_FOREGROUND_ACTIVE =
  COLOR_THIRD_PARTY_SPOTIFY_PRIMARY_INVERSE;
export const COLOR_LIGHT_ICON_CHAT_DRAWER_SPOTIFY_BACKGROUND_ACTIVE =
  COLOR_THIRD_PARTY_SPOTIFY_PRIMARY;
export const COLOR_LIGHT_ICON_CHAT_DRAWER_NOONLIGHT_FOREGROUND_ACTIVE =
  COLOR_THIRD_PARTY_NOONLIGHT_PRIMARY;
export const COLOR_LIGHT_ICON_CHAT_DRAWER_NOONLIGHT_BACKGROUND_ACTIVE =
  COLOR_THIRD_PARTY_NOONLIGHT_SECONDARY;
export const COLOR_LIGHT_INTERACTIVE_PRIMARY: ThemeColor = alphaColor(COLOR_GRAY_95, 0.1608);
export const COLOR_LIGHT_INTERACTIVE_SECONDARY: ThemeColor = alphaColor(COLOR_GRAY_95, 0.0784);
export const COLOR_LIGHT_INTERACTIVE_ON_LIGHT: ThemeColor = alphaColor(COLOR_GRAY_10, 0.1608);
export const COLOR_LIGHT_LOADER_SHIMMER_BASE_DEFAULT = COLOR_GRAY_20;
export const COLOR_LIGHT_LOADER_SHIMMER_HIGHLIGHT_DEFAULT = COLOR_WHITE;
export const COLOR_LIGHT_OVERLAY_DEFAULT: ThemeColor = alphaColor(COLOR_BLACK, 0.5608);
export const COLOR_LIGHT_SHADOW_CONTAINER_ELEVATED: ThemeColor = alphaColor(COLOR_BLACK, 0.2196);
export const GRADIENT_DARK_BACKGROUND_CARD_SPARKS_HIGHLIGHT_COMMON_1: ThemeGradient = {
  angle: 135,
  colors: [COLOR_SPARKS_PURPLE_60, COLOR_SPARKS_PINK_45],
  positions: [0, 1],
};
export const GRADIENT_DARK_BACKGROUND_CARD_SPARKS_HIGHLIGHT_COMMON_2: ThemeGradient = {
  angle: 135,
  colors: [COLOR_BLUE_50, COLOR_PURPLE_50],
  positions: [0, 1],
};
export const GRADIENT_DARK_BACKGROUND_CARD_SPARKS_HIGHLIGHT_COMMON_3: ThemeGradient = {
  angle: 135,
  colors: [COLOR_RED_50, COLOR_FUCHSIA_50],
  positions: [0, 1],
};
export const GRADIENT_DARK_BACKGROUND_CARD_SPARKS_HIGHLIGHT_UNCOMMON_1: ThemeGradient = {
  angle: 135,
  colors: [alphaColor(COLOR_SPARKS_BLUE_70, 0.5608), alphaColor(COLOR_SPARKS_PINK_45, 0.2784)],
  positions: [0, 1],
};
export const GRADIENT_DARK_BACKGROUND_CARD_SPARKS_HIGHLIGHT_UNCOMMON_2: ThemeGradient = {
  angle: 135,
  colors: [alphaColor(COLOR_SPARKS_PINK_45, 0.5608), alphaColor(COLOR_SPARKS_YELLOW_20, 0.2784)],
  positions: [0, 1],
};
export const GRADIENT_DARK_BACKGROUND_CARD_SPARKS_HIGHLIGHT_UNCOMMON_3: ThemeGradient = {
  angle: 135,
  colors: [alphaColor(COLOR_SPARKS_PURPLE_60, 0.5608), alphaColor(COLOR_SPARKS_GREEN_40, 0.2784)],
  positions: [0, 1],
};
export const GRADIENT_DARK_BACKGROUND_CARD_SPARKS_ICEBREAKER: ThemeGradient = {
  angle: 135,
  colors: [COLOR_SPARKS_BLUE_50, COLOR_SPARKS_TEAL_20],
  positions: [0, 1],
};
export const GRADIENT_DARK_BACKGROUND_CARD_SPARKS_PROMPT: ThemeGradient = {
  angle: 135,
  colors: [COLOR_SPARKS_PINK_45, COLOR_SPARKS_RED_60],
  positions: [0, 1],
};
export const GRADIENT_DARK_BACKGROUND_CARD_SPARKS_QUIZ: ThemeGradient = {
  angle: 135,
  colors: [COLOR_SPARKS_PURPLE_60, COLOR_SPARKS_PINK_45],
  positions: [0, 1],
};
export const GRADIENT_DARK_OVERLAY_CARD: ThemeGradient = {
  angle: 180,
  colors: [alphaColor(COLOR_BLACK, 0), COLOR_BLACK],
  positions: [0, 1],
};
export const GRADIENT_DARK_OVERLAY_SUBTLE_CARD: ThemeGradient = {
  angle: 180,
  colors: [alphaColor(COLOR_BLACK, 0), alphaColor(COLOR_BLACK, 0.5608)],
  positions: [0, 1],
};
export const GRADIENT_DARK_BACKGROUND_PASSIONS_SPARKS_SHARED_OVERLAY: ThemeGradient = {
  angle: 45,
  colors: [COLOR_RED_50, COLOR_FUCHSIA_50],
  positions: [0, 1],
};
export const GRADIENT_DARK_BACKGROUND_REC_CARD_BOTTOM_AI_GRADIENT: ThemeGradient = {
  angle: 180,
  colors: [COLOR_BLACK, COLOR_BRAND_GRADIENT_START],
  positions: [0, 1],
};
export const GRADIENT_DARK_OVERLAY_REC_CARD_DEFAULT: ThemeGradient = {
  angle: 180,
  colors: [
    alphaColor(COLOR_BLACK, 0),
    alphaColor(COLOR_BLACK, 0.3294),
    alphaColor(COLOR_BLACK, 0.5882),
    alphaColor(COLOR_BLACK, 0.7686),
    COLOR_BLACK,
  ],
  positions: [0, 0.25, 0.5, 0.75, 1],
};
export const GRADIENT_DARK_OVERLAY_REC_CARD_SUPER_LIKE: ThemeGradient = {
  angle: 180,
  colors: [
    alphaColor(COLOR_BLUE_90, 0),
    alphaColor(COLOR_BLUE_90, 0.6),
    alphaColor(COLOR_BLUE_80, 0.7608),
    COLOR_BLUE_60,
    COLOR_BLUE_60,
  ],
  positions: [0, 0.25, 0.5, 0.75, 1],
};
export const GRADIENT_DARK_OVERLAY_REC_CARD_VAULT: ThemeGradient = {
  angle: 180,
  colors: [
    alphaColor(COLOR_PURPLE_90, 0),
    alphaColor(COLOR_PURPLE_90, 0.6),
    alphaColor(COLOR_PURPLE_80, 0.8),
    COLOR_VAULT_PRIMARY,
    COLOR_BLUE_60,
  ],
  positions: [0, 0.25, 0.5, 0.75, 1],
};
export const GRADIENT_DARK_OVERLAY_REC_CARD_HIGHLIGHT: ThemeGradient = {
  angle: 180,
  colors: [
    alphaColor(COLOR_BLACK, 0),
    alphaColor(COLOR_BLACK, 0.5765),
    alphaColor(COLOR_BLACK, 0.7294),
    alphaColor(COLOR_BLACK, 0.8667),
    COLOR_BLACK,
  ],
  positions: [0, 0.25, 0.5, 0.75, 1],
};
export const GRADIENT_DARK_OVERLAY_REC_CARD_INTENT_A: ThemeGradient = {
  angle: 180,
  colors: [
    alphaColor(COLOR_BLUE_90, 0),
    alphaColor(COLOR_BLUE_70, 0.6),
    alphaColor(COLOR_BLUE_80, 0.7294),
    alphaColor(COLOR_BLUE_90, 0.8667),
    COLOR_BLACK,
  ],
  positions: [0, 0.25, 0.5, 0.75, 1],
};
export const GRADIENT_DARK_OVERLAY_REC_CARD_INTENT_B: ThemeGradient = {
  angle: 180,
  colors: [
    alphaColor(COLOR_TEAL_90, 0),
    alphaColor(COLOR_TEAL_70, 0.6),
    alphaColor(COLOR_TEAL_80, 0.7294),
    alphaColor(COLOR_TEAL_90, 0.8667),
    COLOR_BLACK,
  ],
  positions: [0, 0.25, 0.5, 0.75, 1],
};
export const GRADIENT_DARK_OVERLAY_REC_CARD_INTENT_C: ThemeGradient = {
  angle: 180,
  colors: [
    alphaColor(COLOR_GREEN_90, 0),
    alphaColor(COLOR_GREEN_60, 0.6),
    alphaColor(COLOR_GREEN_80, 0.7294),
    alphaColor(COLOR_GREEN_90, 0.8667),
    COLOR_BLACK,
  ],
  positions: [0, 0.25, 0.5, 0.75, 1],
};
export const GRADIENT_DARK_OVERLAY_REC_CARD_INTENT_D: ThemeGradient = {
  angle: 180,
  colors: [
    alphaColor(COLOR_YELLOW_ORANGE_90, 0),
    alphaColor(COLOR_YELLOW_ORANGE_70, 0.6),
    alphaColor(COLOR_YELLOW_ORANGE_80, 0.7294),
    alphaColor(COLOR_YELLOW_ORANGE_90, 0.8667),
    COLOR_BLACK,
  ],
  positions: [0, 0.25, 0.5, 0.75, 1],
};
export const GRADIENT_DARK_OVERLAY_REC_CARD_INTENT_E: ThemeGradient = {
  angle: 180,
  colors: [
    alphaColor(COLOR_RED_90, 0),
    alphaColor(COLOR_RED_70, 0.6),
    alphaColor(COLOR_RED_80, 0.7294),
    alphaColor(COLOR_RED_90, 0.8667),
    COLOR_BLACK,
  ],
  positions: [0, 0.25, 0.5, 0.75, 1],
};
export const GRADIENT_DARK_OVERLAY_REC_CARD_INTENT_F: ThemeGradient = {
  angle: 180,
  colors: [
    alphaColor(COLOR_PURPLE_90, 0),
    alphaColor(COLOR_PURPLE_70, 0.6),
    alphaColor(COLOR_PURPLE_80, 0.7294),
    alphaColor(COLOR_PURPLE_90, 0.8667),
    COLOR_BLACK,
  ],
  positions: [0, 0.25, 0.5, 0.75, 1],
};
export const GRADIENT_DARK_BACKGROUND_SCRIPTED_ONBOARDING: ThemeGradient = {
  angle: 225,
  colors: [COLOR_BLUE_30, COLOR_FUCHSIA_30],
  positions: [0, 1],
};
export const GRADIENT_DARK_BACKGROUND_SWIPESURGE: ThemeGradient = {
  angle: 45,
  colors: [COLOR_GREEN_20, COLOR_TEAL_20],
  positions: [0, 1],
};
export const GRADIENT_DARK_BACKGROUND_TEAL_SUBTLE: ThemeGradient = {
  angle: 0,
  colors: [COLOR_GRAY_95, COLOR_TEAL_90],
  positions: [0, 1],
};
export const GRADIENT_DARK_OVERLAY_PRIMARY_GRADIENT: ThemeGradient = {
  angle: 180,
  colors: [alphaColor(COLOR_BLACK, 0), COLOR_BLACK],
  positions: [0, 1],
};
export const GRADIENT_DARK_OVERLAY_SECONDARY_GRADIENT: ThemeGradient = {
  angle: 180,
  colors: [alphaColor(COLOR_BLACK, 0), alphaColor(COLOR_BLACK, 0.5608)],
  positions: [0, 1],
};
export const GRADIENT_DARK_OVERLAY_PROFILE_BUTTON_GAMEPAD: ThemeGradient = {
  angle: 180,
  colors: [alphaColor(COLOR_GRAY_95, 0), COLOR_BLACK],
  positions: [0, 1],
};
export const GRADIENT_DARK_OVERLAY_PROFILE_SPARKS_SUPER_LIKE: ThemeGradient = {
  angle: 180,
  colors: [
    alphaColor(COLOR_BLUE_60, 0),
    alphaColor(COLOR_BLUE_60, 0.3098),
    alphaColor(COLOR_BLUE_60, 0.702),
    COLOR_BLUE_60,
    COLOR_BLUE_60,
  ],
  positions: [0, 0.25, 0.5, 0.75, 1],
};
export const GRADIENT_LIGHT_BACKGROUND_CARD_SPARKS_HIGHLIGHT_COMMON_1: ThemeGradient = {
  angle: 135,
  colors: [COLOR_SPARKS_PURPLE_60, COLOR_SPARKS_PINK_45],
  positions: [0, 1],
};
export const GRADIENT_LIGHT_BACKGROUND_CARD_SPARKS_HIGHLIGHT_COMMON_2: ThemeGradient = {
  angle: 135,
  colors: [COLOR_BLUE_50, COLOR_PURPLE_50],
  positions: [0, 1],
};
export const GRADIENT_LIGHT_BACKGROUND_CARD_SPARKS_HIGHLIGHT_COMMON_3: ThemeGradient = {
  angle: 135,
  colors: [COLOR_RED_50, COLOR_FUCHSIA_50],
  positions: [0, 1],
};
export const GRADIENT_LIGHT_BACKGROUND_CARD_SPARKS_HIGHLIGHT_UNCOMMON_1: ThemeGradient = {
  angle: 135,
  colors: [alphaColor(COLOR_SPARKS_BLUE_70, 0.5608), alphaColor(COLOR_SPARKS_PINK_45, 0.2784)],
  positions: [0, 1],
};
export const GRADIENT_LIGHT_BACKGROUND_CARD_SPARKS_HIGHLIGHT_UNCOMMON_2: ThemeGradient = {
  angle: 135,
  colors: [alphaColor(COLOR_SPARKS_PINK_45, 0.5608), alphaColor(COLOR_SPARKS_YELLOW_20, 0.2784)],
  positions: [0, 1],
};
export const GRADIENT_LIGHT_BACKGROUND_CARD_SPARKS_HIGHLIGHT_UNCOMMON_3: ThemeGradient = {
  angle: 135,
  colors: [alphaColor(COLOR_SPARKS_PURPLE_60, 0.5608), alphaColor(COLOR_SPARKS_GREEN_40, 0.2784)],
  positions: [0, 1],
};
export const GRADIENT_LIGHT_BACKGROUND_CARD_SPARKS_ICEBREAKER: ThemeGradient = {
  angle: 135,
  colors: [COLOR_SPARKS_BLUE_50, COLOR_SPARKS_TEAL_20],
  positions: [0, 1],
};
export const GRADIENT_LIGHT_BACKGROUND_CARD_SPARKS_PROMPT: ThemeGradient = {
  angle: 135,
  colors: [COLOR_SPARKS_PINK_45, COLOR_SPARKS_RED_60],
  positions: [0, 1],
};
export const GRADIENT_LIGHT_BACKGROUND_CARD_SPARKS_QUIZ: ThemeGradient = {
  angle: 135,
  colors: [COLOR_SPARKS_PURPLE_60, COLOR_SPARKS_PINK_45],
  positions: [0, 1],
};
export const GRADIENT_LIGHT_OVERLAY_CARD: ThemeGradient = {
  angle: 180,
  colors: [alphaColor(COLOR_BLACK, 0), COLOR_BLACK],
  positions: [0, 1],
};
export const GRADIENT_LIGHT_OVERLAY_SUBTLE_CARD: ThemeGradient = {
  angle: 180,
  colors: [alphaColor(COLOR_BLACK, 0), alphaColor(COLOR_BLACK, 0.5608)],
  positions: [0, 1],
};
export const GRADIENT_LIGHT_BACKGROUND_PASSIONS_SPARKS_SHARED_OVERLAY: ThemeGradient = {
  angle: 45,
  colors: [COLOR_RED_50, COLOR_FUCHSIA_50],
  positions: [0, 1],
};
export const GRADIENT_LIGHT_BACKGROUND_REC_CARD_BOTTOM_AI_GRADIENT: ThemeGradient = {
  angle: 180,
  colors: [COLOR_BLACK, COLOR_BRAND_GRADIENT_START],
  positions: [0, 1],
};
export const GRADIENT_LIGHT_OVERLAY_REC_CARD_DEFAULT: ThemeGradient = {
  angle: 180,
  colors: [
    alphaColor(COLOR_BLACK, 0),
    alphaColor(COLOR_BLACK, 0.3294),
    alphaColor(COLOR_BLACK, 0.5882),
    alphaColor(COLOR_BLACK, 0.7686),
    COLOR_BLACK,
  ],
  positions: [0, 0.25, 0.5, 0.75, 1],
};
export const GRADIENT_LIGHT_OVERLAY_REC_CARD_SUPER_LIKE: ThemeGradient = {
  angle: 180,
  colors: [
    alphaColor(COLOR_BLUE_90, 0),
    alphaColor(COLOR_BLUE_90, 0.6),
    alphaColor(COLOR_BLUE_80, 0.7608),
    COLOR_BLUE_60,
    COLOR_BLUE_60,
  ],
  positions: [0, 0.25, 0.5, 0.75, 1],
};
export const GRADIENT_LIGHT_OVERLAY_REC_CARD_VAULT: ThemeGradient = {
  angle: 180,
  colors: [
    alphaColor(COLOR_PURPLE_90, 0),
    alphaColor(COLOR_PURPLE_90, 0.6),
    alphaColor(COLOR_PURPLE_80, 0.8),
    COLOR_VAULT_PRIMARY,
    COLOR_BLUE_60,
  ],
  positions: [0, 0.25, 0.5, 0.75, 1],
};
export const GRADIENT_LIGHT_OVERLAY_REC_CARD_HIGHLIGHT: ThemeGradient = {
  angle: 180,
  colors: [
    alphaColor(COLOR_BLACK, 0),
    alphaColor(COLOR_BLACK, 0.5765),
    alphaColor(COLOR_BLACK, 0.7294),
    alphaColor(COLOR_BLACK, 0.8667),
    COLOR_BLACK,
  ],
  positions: [0, 0.25, 0.5, 0.75, 1],
};
export const GRADIENT_LIGHT_OVERLAY_REC_CARD_INTENT_A: ThemeGradient = {
  angle: 180,
  colors: [
    alphaColor(COLOR_BLUE_90, 0),
    alphaColor(COLOR_BLUE_70, 0.6),
    alphaColor(COLOR_BLUE_80, 0.7294),
    alphaColor(COLOR_BLUE_90, 0.8667),
    COLOR_BLACK,
  ],
  positions: [0, 0.25, 0.5, 0.75, 1],
};
export const GRADIENT_LIGHT_OVERLAY_REC_CARD_INTENT_B: ThemeGradient = {
  angle: 180,
  colors: [
    alphaColor(COLOR_TEAL_90, 0),
    alphaColor(COLOR_TEAL_70, 0.6),
    alphaColor(COLOR_TEAL_80, 0.7294),
    alphaColor(COLOR_TEAL_90, 0.8667),
    COLOR_BLACK,
  ],
  positions: [0, 0.25, 0.5, 0.75, 1],
};
export const GRADIENT_LIGHT_OVERLAY_REC_CARD_INTENT_C: ThemeGradient = {
  angle: 180,
  colors: [
    alphaColor(COLOR_GREEN_90, 0),
    alphaColor(COLOR_GREEN_60, 0.6),
    alphaColor(COLOR_GREEN_80, 0.7294),
    alphaColor(COLOR_GREEN_90, 0.8667),
    COLOR_BLACK,
  ],
  positions: [0, 0.25, 0.5, 0.75, 1],
};
export const GRADIENT_LIGHT_OVERLAY_REC_CARD_INTENT_D: ThemeGradient = {
  angle: 180,
  colors: [
    alphaColor(COLOR_YELLOW_ORANGE_90, 0),
    alphaColor(COLOR_YELLOW_ORANGE_70, 0.6),
    alphaColor(COLOR_YELLOW_ORANGE_80, 0.7294),
    alphaColor(COLOR_YELLOW_ORANGE_90, 0.8667),
    COLOR_BLACK,
  ],
  positions: [0, 0.25, 0.5, 0.75, 1],
};
export const GRADIENT_LIGHT_OVERLAY_REC_CARD_INTENT_E: ThemeGradient = {
  angle: 180,
  colors: [
    alphaColor(COLOR_RED_90, 0),
    alphaColor(COLOR_RED_70, 0.6),
    alphaColor(COLOR_RED_80, 0.7294),
    alphaColor(COLOR_RED_90, 0.8667),
    COLOR_BLACK,
  ],
  positions: [0, 0.25, 0.5, 0.75, 1],
};
export const GRADIENT_LIGHT_OVERLAY_REC_CARD_INTENT_F: ThemeGradient = {
  angle: 180,
  colors: [
    alphaColor(COLOR_PURPLE_90, 0),
    alphaColor(COLOR_PURPLE_70, 0.6),
    alphaColor(COLOR_PURPLE_80, 0.7294),
    alphaColor(COLOR_PURPLE_90, 0.8667),
    COLOR_BLACK,
  ],
  positions: [0, 0.25, 0.5, 0.75, 1],
};
export const GRADIENT_LIGHT_BACKGROUND_SCRIPTED_ONBOARDING: ThemeGradient = {
  angle: 225,
  colors: [COLOR_BLUE_30, COLOR_FUCHSIA_30],
  positions: [0, 1],
};
export const GRADIENT_LIGHT_BACKGROUND_SWIPESURGE: ThemeGradient = {
  angle: 45,
  colors: [COLOR_GREEN_20, COLOR_TEAL_20],
  positions: [0, 1],
};
export const GRADIENT_LIGHT_BACKGROUND_TEAL_SUBTLE: ThemeGradient = {
  angle: 0,
  colors: [COLOR_WHITE, COLOR_TEAL_10],
  positions: [0, 1],
};
export const GRADIENT_LIGHT_OVERLAY_PRIMARY_GRADIENT: ThemeGradient = {
  angle: 180,
  colors: [alphaColor(COLOR_BLACK, 0), COLOR_BLACK],
  positions: [0, 1],
};
export const GRADIENT_LIGHT_OVERLAY_SECONDARY_GRADIENT: ThemeGradient = {
  angle: 180,
  colors: [alphaColor(COLOR_BLACK, 0), alphaColor(COLOR_BLACK, 0.5608)],
  positions: [0, 1],
};
export const GRADIENT_LIGHT_OVERLAY_PROFILE_BUTTON_GAMEPAD: ThemeGradient = {
  angle: 180,
  colors: [alphaColor(COLOR_WHITE, 0), COLOR_GRAY_15],
  positions: [0, 1],
};
export const GRADIENT_LIGHT_OVERLAY_PROFILE_SPARKS_SUPER_LIKE: ThemeGradient = {
  angle: 180,
  colors: [
    alphaColor(COLOR_SPARKS_BLUE_50, 0),
    alphaColor(COLOR_SPARKS_BLUE_50, 0.3098),
    alphaColor(COLOR_SPARKS_BLUE_50, 0.702),
    COLOR_SPARKS_BLUE_50,
    COLOR_SPARKS_BLUE_50,
  ],
  positions: [0, 0.25, 0.5, 0.75, 1],
};
export const COLOR_DARK_BACKGROUND_BADGE_NOTIFICATION_INACTIVE = COLOR_DARK_BACKGROUND_TERTIARY;
export const COLOR_DARK_BACKGROUND_BANNER_DEFAULT = COLOR_DARK_BACKGROUND_SECONDARY;
export const COLOR_DARK_ICON_BANNER_DISMISS = COLOR_DARK_ICON_SECONDARY;
export const COLOR_DARK_BACKGROUND_BOTTOM_SHEET_DEFAULT = COLOR_DARK_BACKGROUND_PRIMARY;
export const COLOR_DARK_BACKGROUND_BUTTON_NEUTRAL = COLOR_DARK_BACKGROUND_PRIMARY_INVERSE;
export const COLOR_DARK_FOREGROUND_BUTTON_NEUTRAL = COLOR_DARK_FOREGROUND_PRIMARY_INVERSE;
export const COLOR_DARK_INTERACTIVE_BUTTON_PRIMARY = COLOR_DARK_INTERACTIVE_PRIMARY;
export const COLOR_DARK_INTERACTIVE_BUTTON_SECONDARY = COLOR_DARK_INTERACTIVE_SECONDARY;
export const COLOR_DARK_INTERACTIVE_BUTTON_TERTIARY = COLOR_DARK_INTERACTIVE_SECONDARY;
export const COLOR_DARK_INTERACTIVE_BUTTON_NEUTRAL = COLOR_DARK_INTERACTIVE_ON_LIGHT;
export const COLOR_DARK_BACKGROUND_CHAT_BUBBLE_RECEIVE = COLOR_DARK_BACKGROUND_TERTIARY;
export const COLOR_DARK_BACKGROUND_CHECKBOX_DISABLED = COLOR_DARK_BACKGROUND_DISABLED;
export const COLOR_DARK_ICON_FORM_DEFAULT = COLOR_DARK_ICON_SECONDARY;
export const COLOR_DARK_BACKGROUND_GAMEPAD_SECONDARY_DEFAULT = COLOR_DARK_BACKGROUND_PRIMARY;
export const COLOR_DARK_BACKGROUND_GAMEPAD_SECONDARY_DISABLED = COLOR_DARK_BACKGROUND_DISABLED;
export const COLOR_DARK_BORDER_GAMEPAD_SPARKS_REWIND_DEFAULT = COLOR_DARK_BORDER_SPARKS_REWIND;
export const COLOR_DARK_BORDER_GAMEPAD_SPARKS_NOPE_DEFAULT = COLOR_DARK_BORDER_SPARKS_NOPE;
export const COLOR_DARK_BORDER_GAMEPAD_SPARKS_SUPER_LIKE_DEFAULT =
  COLOR_DARK_BORDER_SPARKS_SUPER_LIKE;
export const COLOR_DARK_BORDER_GAMEPAD_SPARKS_LIKE_DEFAULT = COLOR_DARK_BORDER_SPARKS_LIKE;
export const COLOR_DARK_BORDER_GAMEPAD_SPARKS_BOOST_DEFAULT = COLOR_DARK_BORDER_SPARKS_BOOST;
export const COLOR_DARK_BACKGROUND_ICON_BUTTON_SECONDARY = COLOR_DARK_BACKGROUND_PRIMARY;
export const COLOR_DARK_BACKGROUND_ICON_BUTTON_DISABLED = COLOR_DARK_BACKGROUND_DISABLED;
export const COLOR_DARK_ICON_ICON_BUTTON_SECONDARY = COLOR_DARK_ICON_SECONDARY;
export const COLOR_DARK_INTERACTIVE_ICON_BUTTON_PRIMARY = COLOR_DARK_INTERACTIVE_PRIMARY;
export const COLOR_DARK_INTERACTIVE_ICON_BUTTON_SECONDARY = COLOR_DARK_INTERACTIVE_ON_LIGHT;
export const COLOR_DARK_INTERACTIVE_ICON_BUTTON_OVERLAY = COLOR_DARK_INTERACTIVE_PRIMARY;
export const COLOR_DARK_BACKGROUND_MODAL_CONTAINER_DEFAULT = COLOR_DARK_BACKGROUND_TERTIARY;
export const COLOR_DARK_ICON_NAVIGATION_SECONDARY_START = COLOR_DARK_ICON_SECONDARY;
export const COLOR_DARK_BACKGROUND_PASSIONS_SHARED = COLOR_DARK_BACKGROUND_PRIMARY;
export const COLOR_DARK_BACKGROUND_PROGRESS_INACTIVE = COLOR_DARK_BACKGROUND_SECONDARY;
export const COLOR_DARK_BACKGROUND_RADIO_UNSELECTED_DISABLED = COLOR_DARK_BACKGROUND_DISABLED;
export const COLOR_DARK_BACKGROUND_SEARCH_DEFAULT = COLOR_DARK_BACKGROUND_TERTIARY;
export const COLOR_DARK_ICON_SEARCH_START = COLOR_DARK_ICON_SECONDARY;
export const COLOR_DARK_ICON_SEARCH_END_ACTION = COLOR_DARK_ICON_SECONDARY;
export const COLOR_DARK_BACKGROUND_SLIDER_ALT_TRACK_ENABLED = COLOR_DARK_BACKGROUND_INACTIVE;
export const COLOR_DARK_BACKGROUND_SLIDER_ALT_TRACK_DISABLED = COLOR_DARK_BACKGROUND_DISABLED;
export const COLOR_DARK_BACKGROUND_SLIDER_DEFAULT_TRACK_ENABLED = COLOR_DARK_BACKGROUND_INACTIVE;
export const COLOR_DARK_BACKGROUND_SLIDER_DEFAULT_TRACK_DISABLED = COLOR_DARK_BACKGROUND_DISABLED;
export const COLOR_DARK_BACKGROUND_SWITCH_DEFAULT_TRACK_UNSELECTED = COLOR_DARK_BACKGROUND_INACTIVE;
export const COLOR_DARK_BACKGROUND_SWITCH_DEFAULT_TRACK_DISABLED = COLOR_DARK_BACKGROUND_DISABLED;
export const COLOR_DARK_BACKGROUND_SWITCH_DEFAULT_KNOB_DISABLED = COLOR_DARK_BACKGROUND_DISABLED;
export const COLOR_DARK_ICON_SWITCH_DEFAULT_UNSELECTED = COLOR_DARK_ICON_SECONDARY;
export const COLOR_DARK_BACKGROUND_TABLE_ROW_DEFAULT = COLOR_DARK_BACKGROUND_PRIMARY;
export const COLOR_DARK_BACKGROUND_TABLE_ROW_PRESSED = COLOR_DARK_INTERACTIVE_PRIMARY;
export const COLOR_DARK_BACKGROUND_TABLE_ROW_HOVER = COLOR_DARK_INTERACTIVE_SECONDARY;
export const COLOR_DARK_BACKGROUND_TEXT_FIELD_QUIET_DEFAULT = COLOR_DARK_BACKGROUND_PRIMARY;
export const COLOR_DARK_BACKGROUND_TEXT_FIELD_LOUD_DEFAULT = COLOR_DARK_BACKGROUND_SECONDARY;
export const COLOR_DARK_BACKGROUND_TOAST_DEFAULT = COLOR_DARK_BACKGROUND_SECONDARY_INVERSE;
export const COLOR_DARK_ACTION_ACTIVE = COLOR_DARK_ACCENT_ACTIVE;
export const COLOR_DARK_ACTION_INACTIVE = COLOR_DARK_FOREGROUND_INACTIVE;
export const COLOR_DARK_BACKGROUND_OVERLAY_PRIMARY = COLOR_DARK_BACKGROUND_PRIMARY_STATIC_DARK;
export const COLOR_DARK_BACKGROUND_OVERLAY_SECONDARY = COLOR_DARK_BACKGROUND_SECONDARY_STATIC_DARK;
export const COLOR_DARK_BACKGROUND_BRAND = COLOR_DARK_ACCENT_PRIMARY;
export const COLOR_DARK_BACKGROUND_ERROR = COLOR_DARK_ACCENT_ERROR;
export const COLOR_DARK_BACKGROUND_READ_RECEIPTS_BADGE = COLOR_DARK_ACCENT_CHAT;
export const COLOR_DARK_BACKGROUND_VAULT = COLOR_DARK_ACCENT_SELECT;
export const COLOR_DARK_BACKGROUND_ELEVATED = COLOR_DARK_BACKGROUND_TERTIARY;
export const COLOR_DARK_BACKGROUND_CARD_SPARKS = COLOR_DARK_BACKGROUND_PRIMARY;
export const COLOR_DARK_BACKGROUND_MENU_DEFAULT = COLOR_DARK_BACKGROUND_PRIMARY;
export const COLOR_DARK_BACKGROUND_HEADER_SPARKS = COLOR_DARK_BACKGROUND_PRIMARY;
export const COLOR_DARK_BACKGROUND_SPARKS_TOP_NAV = COLOR_DARK_BACKGROUND_PRIMARY;
export const COLOR_DARK_BORDER_PRIMARY = COLOR_DARK_FOREGROUND_BORDER_PRIMARY;
export const COLOR_DARK_BORDER_PRIMARY_INVERSE = COLOR_DARK_FOREGROUND_PRIMARY_INVERSE;
export const COLOR_DARK_BORDER_SECONDARY = COLOR_DARK_FOREGROUND_BORDER_SECONDARY;
export const COLOR_DARK_BORDER_SECONDARY_OVERLAY = COLOR_DARK_FOREGROUND_SECONDARY_STATIC_LIGHT;
export const COLOR_DARK_BORDER_DISABLED = COLOR_DARK_FOREGROUND_DISABLED;
export const COLOR_DARK_BORDER_OVERLAY = COLOR_DARK_FOREGROUND_PRIMARY_STATIC_LIGHT;
export const COLOR_DARK_BORDER_FOCUS_DEFAULT = COLOR_DARK_FOREGROUND_PRIMARY;
export const COLOR_DARK_BORDER_FOCUS_OVERLAY = COLOR_DARK_FOREGROUND_PRIMARY_STATIC_LIGHT;
export const COLOR_DARK_BORDER_FOCUS_INVERSE = COLOR_DARK_FOREGROUND_PRIMARY_INVERSE;
export const COLOR_DARK_BORDER_BRAND = COLOR_DARK_ACCENT_PRIMARY;
export const COLOR_DARK_BORDER_GOLD = COLOR_DARK_ACCENT_GOLD;
export const COLOR_DARK_BORDER_PLATINUM = COLOR_DARK_ACCENT_PLATINUM;
export const COLOR_DARK_BORDER_REWIND = COLOR_DARK_ACCENT_REWIND;
export const COLOR_DARK_BORDER_LIKE = COLOR_DARK_ACCENT_LIKE;
export const COLOR_DARK_BORDER_SUPER_LIKE = COLOR_DARK_ACCENT_SUPER_LIKE;
export const COLOR_DARK_BORDER_NOPE = COLOR_DARK_ACCENT_NOPE;
export const COLOR_DARK_BORDER_BOOST = COLOR_DARK_ACCENT_BOOST;
export const COLOR_DARK_BORDER_ERROR = COLOR_DARK_ACCENT_ERROR;
export const COLOR_DARK_BORDER_SUCCESS = COLOR_DARK_ACCENT_SUCCESS;
export const COLOR_DARK_BORDER_ACTIVE = COLOR_DARK_ACCENT_ACTIVE;
export const COLOR_DARK_BORDER_VAULT = COLOR_DARK_ACCENT_SELECT;
export const COLOR_DARK_BORDER_TIMER_EXPIRED = COLOR_DARK_FOREGROUND_BORDER_SECONDARY;
export const COLOR_DARK_CURSOR_DEFAULT = COLOR_DARK_ACCENT_ACTIVE;
export const COLOR_DARK_DEVICE_HOME_INDICATOR = COLOR_DARK_FOREGROUND_PRIMARY;
export const COLOR_DARK_DEVICE_STATUS_BAR_INVERSE = COLOR_DARK_FOREGROUND_PRIMARY_INVERSE;
export const COLOR_DARK_DEVICE_STATUS_BAR = COLOR_DARK_FOREGROUND_PRIMARY;
export const COLOR_DARK_DIVIDER_PRIMARY = COLOR_DARK_FOREGROUND_BORDER_SECONDARY;
export const COLOR_DARK_DIVIDER_SPARKS = COLOR_DARK_FOREGROUND_BORDER_SECONDARY;
export const COLOR_DARK_FOREGROUND_PRIMARY_STATIC_ON_DARK =
  COLOR_DARK_FOREGROUND_PRIMARY_STATIC_LIGHT;
export const COLOR_DARK_FOREGROUND_BORDER_ELEVATED = COLOR_DARK_FOREGROUND_BORDER_PRIMARY;
export const COLOR_DARK_FOREGROUND_READ_RECEIPTS_BADGE = COLOR_DARK_FOREGROUND_PRIMARY_STATIC_LIGHT;
export const COLOR_DARK_FOREGROUND_GREEN = COLOR_DARK_ACCENT_GREEN;
export const COLOR_DARK_FOREGROUND_TEAL = COLOR_DARK_ACCENT_TEAL;
export const COLOR_DARK_FOREGROUND_BLUE = COLOR_DARK_ACCENT_BLUE;
export const COLOR_DARK_FOREGROUND_PURPLE = COLOR_DARK_ACCENT_PURPLE;
export const COLOR_DARK_FOREGROUND_FUCHSIA = COLOR_DARK_ACCENT_FUCHSIA;
export const COLOR_DARK_FOREGROUND_RED = COLOR_DARK_ACCENT_RED;
export const COLOR_DARK_FOREGROUND_YELLOW_ORANGE = COLOR_DARK_ACCENT_YELLOW_ORANGE;
export const COLOR_DARK_ICON_PRIMARY = COLOR_DARK_FOREGROUND_PRIMARY;
export const COLOR_DARK_ICON_PRIMARY_INVERSE = COLOR_DARK_FOREGROUND_PRIMARY_INVERSE;
export const COLOR_DARK_ICON_SECONDARY_INVERSE = COLOR_DARK_FOREGROUND_SECONDARY_INVERSE;
export const COLOR_DARK_ICON_DISABLED = COLOR_DARK_FOREGROUND_DISABLED;
export const COLOR_DARK_ICON_PRIMARY_OVERLAY = COLOR_DARK_FOREGROUND_PRIMARY_STATIC_LIGHT;
export const COLOR_DARK_ICON_PRIMARY_OVERLAY_INVERSE = COLOR_DARK_FOREGROUND_PRIMARY_STATIC_DARK;
export const COLOR_DARK_ICON_BRAND = COLOR_DARK_ACCENT_PRIMARY;
export const COLOR_DARK_ICON_TRUST = COLOR_DARK_ACCENT_TRUST;
export const COLOR_DARK_ICON_SUCCESS = COLOR_DARK_ACCENT_SUCCESS;
export const COLOR_DARK_ICON_ERROR = COLOR_DARK_ACCENT_ERROR;
export const COLOR_DARK_ICON_CHAT_HEART_DEFAULT = COLOR_DARK_FOREGROUND_INACTIVE;
export const COLOR_DARK_ICON_CHAT_HEART_ACTIVE = COLOR_DARK_ACCENT_PRIMARY;
export const COLOR_DARK_ICON_CHAT_DRAWER_CONTACT_CARD_DEFAULT = COLOR_DARK_FOREGROUND_INACTIVE;
export const COLOR_DARK_ICON_CHAT_DRAWER_CONTACT_CARD_ACTIVE = COLOR_DARK_ACCENT_BLUE;
export const COLOR_DARK_ICON_CHAT_DRAWER_GIF_FOREGROUND_DEFAULT =
  COLOR_DARK_FOREGROUND_PRIMARY_INVERSE;
export const COLOR_DARK_ICON_CHAT_DRAWER_GIF_BACKGROUND_DEFAULT = COLOR_DARK_FOREGROUND_INACTIVE;
export const COLOR_DARK_ICON_CHAT_DRAWER_GIF_FOREGROUND_ACTIVE = COLOR_DARK_ACCENT_YELLOW_ORANGE;
export const COLOR_DARK_ICON_CHAT_DRAWER_GIF_BACKGROUND_ACTIVE = COLOR_DARK_FOREGROUND_PRIMARY;
export const COLOR_DARK_ICON_CHAT_DRAWER_STICKER_DEFAULT = COLOR_DARK_FOREGROUND_INACTIVE;
export const COLOR_DARK_ICON_CHAT_DRAWER_STICKER_ACTIVE = COLOR_DARK_ACCENT_PURPLE;
export const COLOR_DARK_ICON_CHAT_DRAWER_SPOTIFY_FOREGROUND_DEFAULT =
  COLOR_DARK_FOREGROUND_PRIMARY_INVERSE;
export const COLOR_DARK_ICON_CHAT_DRAWER_SPOTIFY_BACKGROUND_DEFAULT =
  COLOR_DARK_FOREGROUND_INACTIVE;
export const COLOR_DARK_ICON_CHAT_DRAWER_NOONLIGHT_FOREGROUND_DEFAULT =
  COLOR_DARK_FOREGROUND_INACTIVE;
export const COLOR_DARK_ICON_CHAT_DRAWER_NOONLIGHT_BACKGROUND_DEFAULT =
  COLOR_DARK_FOREGROUND_DISABLED;
export const COLOR_DARK_ICON_CHAT_DRAWER_VIBES_DEFAULT = COLOR_DARK_FOREGROUND_INACTIVE;
export const COLOR_DARK_ICON_VAULT = COLOR_DARK_ACCENT_SELECT;
export const COLOR_DARK_LOADER_SKELETON = COLOR_DARK_LOADER_SHIMMER_BASE_DEFAULT;
export const COLOR_DARK_TEXT_PRIMARY = COLOR_DARK_FOREGROUND_PRIMARY;
export const COLOR_DARK_TEXT_PRIMARY_INVERSE = COLOR_DARK_FOREGROUND_PRIMARY_INVERSE;
export const COLOR_DARK_TEXT_SECONDARY = COLOR_DARK_FOREGROUND_SECONDARY;
export const COLOR_DARK_TEXT_SECONDARY_INVERSE = COLOR_DARK_FOREGROUND_SECONDARY_INVERSE;
export const COLOR_DARK_TEXT_INACTIVE = COLOR_DARK_FOREGROUND_INACTIVE;
export const COLOR_DARK_TEXT_PRIMARY_OVERLAY = COLOR_DARK_FOREGROUND_PRIMARY_STATIC_LIGHT;
export const COLOR_DARK_TEXT_PRIMARY_OVERLAY_INVERSE = COLOR_DARK_FOREGROUND_PRIMARY_STATIC_DARK;
export const COLOR_DARK_TEXT_SECONDARY_OVERLAY = COLOR_DARK_FOREGROUND_SECONDARY_STATIC_LIGHT;
export const COLOR_DARK_TEXT_SECONDARY_OVERLAY_INVERSE =
  COLOR_DARK_FOREGROUND_SECONDARY_STATIC_DARK;
export const COLOR_DARK_TEXT_ERROR = COLOR_DARK_ACCENT_ERROR;
export const COLOR_DARK_TEXT_LINK = COLOR_DARK_ACCENT_LINK;
export const COLOR_DARK_TEXT_GOLD = COLOR_DARK_ACCENT_GOLD;
export const COLOR_DARK_TEXT_LIKE = COLOR_DARK_ACCENT_LIKE;
export const COLOR_DARK_TEXT_SUPER_LIKE = COLOR_DARK_ACCENT_SUPER_LIKE;
export const COLOR_DARK_TEXT_BOOST = COLOR_DARK_ACCENT_BOOST;
export const COLOR_DARK_TEXT_SUPER_BOOST = COLOR_DARK_ACCENT_BOOST;
export const COLOR_DARK_TEXT_SUCCESS = COLOR_DARK_ACCENT_SUCCESS;
export const COLOR_DARK_TEXT_DISABLED = COLOR_DARK_FOREGROUND_DISABLED;
export const COLOR_DARK_TEXT_LINK_OVERLAY = COLOR_DARK_FOREGROUND_PRIMARY_STATIC_LIGHT;
export const COLOR_DARK_TEXT_HIGHLIGHT_FOREGROUND = COLOR_DARK_FOREGROUND_PRIMARY_INVERSE;
export const COLOR_DARK_TEXT_HIGHLIGHT_BACKGROUND = COLOR_DARK_FOREGROUND_PRIMARY;
export const COLOR_DARK_TEXT_BRAND_NORMAL = COLOR_DARK_ACCENT_PRIMARY_A11Y;
export const COLOR_DARK_TEXT_BRAND_LARGE = COLOR_DARK_ACCENT_PRIMARY;
export const COLOR_DARK_TEXT_VAULT_NORMAL = COLOR_DARK_ACCENT_SELECT;
export const COLOR_DARK_TEXT_VAULT_LARGE = COLOR_DARK_ACCENT_SELECT;
export const COLOR_DARK_TEXT_TRUST = COLOR_DARK_ACCENT_TRUST;
export const COLOR_LIGHT_BACKGROUND_BADGE_NOTIFICATION_INACTIVE = COLOR_LIGHT_BACKGROUND_TERTIARY;
export const COLOR_LIGHT_BACKGROUND_BANNER_DEFAULT = COLOR_LIGHT_BACKGROUND_SECONDARY;
export const COLOR_LIGHT_ICON_BANNER_DISMISS = COLOR_LIGHT_ICON_SECONDARY;
export const COLOR_LIGHT_BACKGROUND_BOTTOM_SHEET_DEFAULT = COLOR_LIGHT_BACKGROUND_PRIMARY;
export const COLOR_LIGHT_BACKGROUND_BUTTON_NEUTRAL = COLOR_LIGHT_BACKGROUND_PRIMARY_INVERSE;
export const COLOR_LIGHT_BACKGROUND_BUTTON_DISABLED = COLOR_LIGHT_BACKGROUND_TERTIARY;
export const COLOR_LIGHT_FOREGROUND_BUTTON_NEUTRAL = COLOR_LIGHT_FOREGROUND_PRIMARY_INVERSE;
export const COLOR_LIGHT_INTERACTIVE_BUTTON_PRIMARY = COLOR_LIGHT_INTERACTIVE_PRIMARY;
export const COLOR_LIGHT_INTERACTIVE_BUTTON_SECONDARY = COLOR_LIGHT_INTERACTIVE_SECONDARY;
export const COLOR_LIGHT_INTERACTIVE_BUTTON_TERTIARY = COLOR_LIGHT_INTERACTIVE_SECONDARY;
export const COLOR_LIGHT_INTERACTIVE_BUTTON_NEUTRAL = COLOR_LIGHT_INTERACTIVE_ON_LIGHT;
export const COLOR_LIGHT_BACKGROUND_CHAT_BUBBLE_RECEIVE = COLOR_LIGHT_BACKGROUND_TERTIARY;
export const COLOR_LIGHT_BACKGROUND_DATEPICKER_SELECTED = COLOR_LIGHT_BACKGROUND_SECONDARY;
export const COLOR_LIGHT_ICON_FORM_DEFAULT = COLOR_LIGHT_ICON_SECONDARY;
export const COLOR_LIGHT_BACKGROUND_GAMEPAD_SECONDARY_DEFAULT = COLOR_LIGHT_BACKGROUND_PRIMARY;
export const COLOR_LIGHT_BORDER_GAMEPAD_SPARKS_REWIND_DEFAULT = COLOR_LIGHT_BORDER_SPARKS_REWIND;
export const COLOR_LIGHT_BORDER_GAMEPAD_SPARKS_NOPE_DEFAULT = COLOR_LIGHT_BORDER_SPARKS_NOPE;
export const COLOR_LIGHT_BORDER_GAMEPAD_SPARKS_SUPER_LIKE_DEFAULT =
  COLOR_LIGHT_BORDER_SPARKS_SUPER_LIKE;
export const COLOR_LIGHT_BORDER_GAMEPAD_SPARKS_LIKE_DEFAULT = COLOR_LIGHT_BORDER_SPARKS_LIKE;
export const COLOR_LIGHT_BORDER_GAMEPAD_SPARKS_BOOST_DEFAULT = COLOR_LIGHT_BORDER_SPARKS_BOOST;
export const COLOR_LIGHT_BACKGROUND_ICON_BUTTON_SECONDARY = COLOR_LIGHT_BACKGROUND_PRIMARY;
export const COLOR_LIGHT_ICON_ICON_BUTTON_SECONDARY = COLOR_LIGHT_ICON_SECONDARY;
export const COLOR_LIGHT_INTERACTIVE_ICON_BUTTON_PRIMARY = COLOR_LIGHT_INTERACTIVE_PRIMARY;
export const COLOR_LIGHT_INTERACTIVE_ICON_BUTTON_SECONDARY = COLOR_LIGHT_INTERACTIVE_ON_LIGHT;
export const COLOR_LIGHT_INTERACTIVE_ICON_BUTTON_OVERLAY = COLOR_LIGHT_INTERACTIVE_PRIMARY;
export const COLOR_LIGHT_BACKGROUND_MODAL_CONTAINER_DEFAULT = COLOR_LIGHT_BACKGROUND_PRIMARY;
export const COLOR_LIGHT_ICON_NAVIGATION_SECONDARY_START = COLOR_LIGHT_ICON_SECONDARY;
export const COLOR_LIGHT_BACKGROUND_PASSIONS_SHARED = COLOR_LIGHT_BACKGROUND_PRIMARY;
export const COLOR_LIGHT_BACKGROUND_PROGRESS_INACTIVE = COLOR_LIGHT_BACKGROUND_SECONDARY;
export const COLOR_LIGHT_BACKGROUND_SEARCH_DEFAULT = COLOR_LIGHT_BACKGROUND_TERTIARY;
export const COLOR_LIGHT_ICON_SEARCH_START = COLOR_LIGHT_ICON_SECONDARY;
export const COLOR_LIGHT_ICON_SEARCH_END_ACTION = COLOR_LIGHT_ICON_SECONDARY;
export const COLOR_LIGHT_BACKGROUND_SLIDER_ALT_TRACK_ENABLED = COLOR_LIGHT_BACKGROUND_INACTIVE;
export const COLOR_LIGHT_BACKGROUND_SLIDER_DEFAULT_TRACK_ENABLED = COLOR_LIGHT_BACKGROUND_INACTIVE;
export const COLOR_LIGHT_BACKGROUND_SWITCH_ALT_TRACK_UNSELECTED = COLOR_LIGHT_BACKGROUND_TERTIARY;
export const COLOR_LIGHT_BACKGROUND_SWITCH_DEFAULT_TRACK_UNSELECTED =
  COLOR_LIGHT_BACKGROUND_INACTIVE;
export const COLOR_LIGHT_ICON_SWITCH_DEFAULT_UNSELECTED = COLOR_LIGHT_ICON_SECONDARY;
export const COLOR_LIGHT_BACKGROUND_TABLE_ROW_DEFAULT = COLOR_LIGHT_BACKGROUND_PRIMARY;
export const COLOR_LIGHT_BACKGROUND_TABLE_ROW_PRESSED = COLOR_LIGHT_INTERACTIVE_PRIMARY;
export const COLOR_LIGHT_BACKGROUND_TABLE_ROW_HOVER = COLOR_LIGHT_INTERACTIVE_SECONDARY;
export const COLOR_LIGHT_BACKGROUND_TEXT_FIELD_QUIET_DEFAULT = COLOR_LIGHT_BACKGROUND_PRIMARY;
export const COLOR_LIGHT_BACKGROUND_TEXT_FIELD_LOUD_DEFAULT = COLOR_LIGHT_BACKGROUND_SECONDARY;
export const COLOR_LIGHT_BACKGROUND_TOAST_DEFAULT = COLOR_LIGHT_BACKGROUND_TERTIARY_INVERSE;
export const COLOR_LIGHT_ACTION_ACTIVE = COLOR_LIGHT_ACCENT_ACTIVE;
export const COLOR_LIGHT_ACTION_INACTIVE = COLOR_LIGHT_FOREGROUND_INACTIVE;
export const COLOR_LIGHT_BACKGROUND_OVERLAY_PRIMARY = COLOR_LIGHT_BACKGROUND_PRIMARY_STATIC_DARK;
export const COLOR_LIGHT_BACKGROUND_OVERLAY_SECONDARY =
  COLOR_LIGHT_BACKGROUND_SECONDARY_STATIC_DARK;
export const COLOR_LIGHT_BACKGROUND_BRAND = COLOR_LIGHT_ACCENT_PRIMARY;
export const COLOR_LIGHT_BACKGROUND_ERROR = COLOR_LIGHT_ACCENT_ERROR;
export const COLOR_LIGHT_BACKGROUND_DISABLED = COLOR_LIGHT_BACKGROUND_TERTIARY;
export const COLOR_LIGHT_BACKGROUND_READ_RECEIPTS_BADGE = COLOR_LIGHT_ACCENT_CHAT;
export const COLOR_LIGHT_BACKGROUND_VAULT = COLOR_LIGHT_ACCENT_SELECT;
export const COLOR_LIGHT_BACKGROUND_ELEVATED = COLOR_LIGHT_BACKGROUND_PRIMARY;
export const COLOR_LIGHT_BACKGROUND_CARD_SPARKS = COLOR_LIGHT_BACKGROUND_PRIMARY;
export const COLOR_LIGHT_BACKGROUND_MENU_DEFAULT = COLOR_LIGHT_BACKGROUND_PRIMARY;
export const COLOR_LIGHT_BACKGROUND_HEADER_SPARKS = COLOR_LIGHT_BACKGROUND_PRIMARY;
export const COLOR_LIGHT_BACKGROUND_SPARKS_TOP_NAV = COLOR_LIGHT_BACKGROUND_PRIMARY;
export const COLOR_LIGHT_BORDER_PRIMARY = COLOR_LIGHT_FOREGROUND_BORDER_PRIMARY;
export const COLOR_LIGHT_BORDER_PRIMARY_INVERSE = COLOR_LIGHT_FOREGROUND_PRIMARY_INVERSE;
export const COLOR_LIGHT_BORDER_SECONDARY = COLOR_LIGHT_FOREGROUND_BORDER_SECONDARY;
export const COLOR_LIGHT_BORDER_SECONDARY_OVERLAY = COLOR_LIGHT_FOREGROUND_SECONDARY_STATIC_LIGHT;
export const COLOR_LIGHT_BORDER_DISABLED = COLOR_LIGHT_FOREGROUND_DISABLED;
export const COLOR_LIGHT_BORDER_OVERLAY = COLOR_LIGHT_FOREGROUND_PRIMARY_STATIC_LIGHT;
export const COLOR_LIGHT_BORDER_BRAND = COLOR_LIGHT_ACCENT_PRIMARY;
export const COLOR_LIGHT_BORDER_GOLD = COLOR_LIGHT_ACCENT_GOLD;
export const COLOR_LIGHT_BORDER_PLATINUM = COLOR_LIGHT_ACCENT_PLATINUM;
export const COLOR_LIGHT_BORDER_REWIND = COLOR_LIGHT_ACCENT_REWIND;
export const COLOR_LIGHT_BORDER_LIKE = COLOR_LIGHT_ACCENT_LIKE;
export const COLOR_LIGHT_BORDER_SUPER_LIKE = COLOR_LIGHT_ACCENT_SUPER_LIKE;
export const COLOR_LIGHT_BORDER_BOOST = COLOR_LIGHT_ACCENT_BOOST;
export const COLOR_LIGHT_BORDER_NOPE = COLOR_LIGHT_ACCENT_NOPE;
export const COLOR_LIGHT_BORDER_FOCUS_DEFAULT = COLOR_LIGHT_FOREGROUND_PRIMARY;
export const COLOR_LIGHT_BORDER_FOCUS_OVERLAY = COLOR_LIGHT_FOREGROUND_PRIMARY_STATIC_LIGHT;
export const COLOR_LIGHT_BORDER_FOCUS_INVERSE = COLOR_LIGHT_FOREGROUND_PRIMARY_INVERSE;
export const COLOR_LIGHT_BORDER_ERROR = COLOR_LIGHT_ACCENT_ERROR;
export const COLOR_LIGHT_BORDER_SUCCESS = COLOR_LIGHT_ACCENT_SUCCESS;
export const COLOR_LIGHT_BORDER_ACTIVE = COLOR_LIGHT_ACCENT_ACTIVE;
export const COLOR_LIGHT_BORDER_VAULT = COLOR_LIGHT_ACCENT_SELECT;
export const COLOR_LIGHT_BORDER_TIMER_EXPIRED = COLOR_LIGHT_FOREGROUND_BORDER_SECONDARY;
export const COLOR_LIGHT_CURSOR_DEFAULT = COLOR_LIGHT_ACCENT_ACTIVE;
export const COLOR_LIGHT_DEVICE_HOME_INDICATOR = COLOR_LIGHT_FOREGROUND_PRIMARY;
export const COLOR_LIGHT_DEVICE_STATUS_BAR = COLOR_LIGHT_FOREGROUND_PRIMARY;
export const COLOR_LIGHT_DEVICE_STATUS_BAR_INVERSE = COLOR_LIGHT_FOREGROUND_PRIMARY_INVERSE;
export const COLOR_LIGHT_DIVIDER_PRIMARY = COLOR_LIGHT_FOREGROUND_BORDER_SECONDARY;
export const COLOR_LIGHT_DIVIDER_SPARKS = COLOR_LIGHT_FOREGROUND_BORDER_SECONDARY;
export const COLOR_LIGHT_FOREGROUND_PRIMARY_STATIC_ON_DARK =
  COLOR_LIGHT_FOREGROUND_PRIMARY_STATIC_LIGHT;
export const COLOR_LIGHT_FOREGROUND_BORDER_ELEVATED: ThemeColor = alphaColor(
  COLOR_LIGHT_FOREGROUND_BORDER_PRIMARY,
  0
);
export const COLOR_LIGHT_FOREGROUND_READ_RECEIPTS_BADGE =
  COLOR_LIGHT_FOREGROUND_PRIMARY_STATIC_LIGHT;
export const COLOR_LIGHT_FOREGROUND_GREEN = COLOR_LIGHT_ACCENT_GREEN;
export const COLOR_LIGHT_FOREGROUND_TEAL = COLOR_LIGHT_ACCENT_TEAL;
export const COLOR_LIGHT_FOREGROUND_BLUE = COLOR_LIGHT_ACCENT_BLUE;
export const COLOR_LIGHT_FOREGROUND_PURPLE = COLOR_LIGHT_ACCENT_PURPLE;
export const COLOR_LIGHT_FOREGROUND_FUCHSIA = COLOR_LIGHT_ACCENT_FUCHSIA;
export const COLOR_LIGHT_FOREGROUND_RED = COLOR_LIGHT_ACCENT_RED;
export const COLOR_LIGHT_FOREGROUND_YELLOW_ORANGE = COLOR_LIGHT_ACCENT_YELLOW_ORANGE;
export const COLOR_LIGHT_ICON_PRIMARY = COLOR_LIGHT_FOREGROUND_PRIMARY;
export const COLOR_LIGHT_ICON_PRIMARY_INVERSE = COLOR_LIGHT_FOREGROUND_PRIMARY_INVERSE;
export const COLOR_LIGHT_ICON_SECONDARY_INVERSE = COLOR_LIGHT_FOREGROUND_SECONDARY_INVERSE;
export const COLOR_LIGHT_ICON_DISABLED = COLOR_LIGHT_FOREGROUND_DISABLED;
export const COLOR_LIGHT_ICON_PRIMARY_OVERLAY = COLOR_LIGHT_FOREGROUND_PRIMARY_STATIC_LIGHT;
export const COLOR_LIGHT_ICON_PRIMARY_OVERLAY_INVERSE = COLOR_LIGHT_FOREGROUND_PRIMARY_STATIC_DARK;
export const COLOR_LIGHT_ICON_BRAND = COLOR_LIGHT_ACCENT_PRIMARY;
export const COLOR_LIGHT_ICON_TRUST = COLOR_LIGHT_ACCENT_TRUST;
export const COLOR_LIGHT_ICON_SUCCESS = COLOR_LIGHT_ACCENT_SUCCESS;
export const COLOR_LIGHT_ICON_ERROR = COLOR_LIGHT_ACCENT_ERROR;
export const COLOR_LIGHT_ICON_CHAT_HEART_DEFAULT = COLOR_LIGHT_FOREGROUND_INACTIVE;
export const COLOR_LIGHT_ICON_CHAT_HEART_ACTIVE = COLOR_LIGHT_ACCENT_PRIMARY;
export const COLOR_LIGHT_ICON_CHAT_DRAWER_CONTACT_CARD_DEFAULT = COLOR_LIGHT_FOREGROUND_INACTIVE;
export const COLOR_LIGHT_ICON_CHAT_DRAWER_CONTACT_CARD_ACTIVE = COLOR_LIGHT_ACCENT_BLUE;
export const COLOR_LIGHT_ICON_CHAT_DRAWER_GIF_FOREGROUND_DEFAULT =
  COLOR_LIGHT_FOREGROUND_PRIMARY_INVERSE;
export const COLOR_LIGHT_ICON_CHAT_DRAWER_GIF_BACKGROUND_DEFAULT = COLOR_LIGHT_FOREGROUND_INACTIVE;
export const COLOR_LIGHT_ICON_CHAT_DRAWER_GIF_FOREGROUND_ACTIVE = COLOR_LIGHT_ACCENT_YELLOW_ORANGE;
export const COLOR_LIGHT_ICON_CHAT_DRAWER_GIF_BACKGROUND_ACTIVE = COLOR_LIGHT_FOREGROUND_PRIMARY;
export const COLOR_LIGHT_ICON_CHAT_DRAWER_STICKER_DEFAULT = COLOR_LIGHT_FOREGROUND_INACTIVE;
export const COLOR_LIGHT_ICON_CHAT_DRAWER_STICKER_ACTIVE = COLOR_LIGHT_ACCENT_PURPLE;
export const COLOR_LIGHT_ICON_CHAT_DRAWER_SPOTIFY_FOREGROUND_DEFAULT =
  COLOR_LIGHT_FOREGROUND_PRIMARY_INVERSE;
export const COLOR_LIGHT_ICON_CHAT_DRAWER_SPOTIFY_BACKGROUND_DEFAULT =
  COLOR_LIGHT_FOREGROUND_INACTIVE;
export const COLOR_LIGHT_ICON_CHAT_DRAWER_NOONLIGHT_FOREGROUND_DEFAULT =
  COLOR_LIGHT_FOREGROUND_INACTIVE;
export const COLOR_LIGHT_ICON_CHAT_DRAWER_NOONLIGHT_BACKGROUND_DEFAULT =
  COLOR_LIGHT_FOREGROUND_DISABLED;
export const COLOR_LIGHT_ICON_CHAT_DRAWER_VIBES_DEFAULT = COLOR_LIGHT_FOREGROUND_INACTIVE;
export const COLOR_LIGHT_ICON_VAULT = COLOR_LIGHT_ACCENT_SELECT;
export const COLOR_LIGHT_LOADER_SKELETON = COLOR_LIGHT_LOADER_SHIMMER_BASE_DEFAULT;
export const COLOR_LIGHT_TEXT_PRIMARY = COLOR_LIGHT_FOREGROUND_PRIMARY;
export const COLOR_LIGHT_TEXT_PRIMARY_INVERSE = COLOR_LIGHT_FOREGROUND_PRIMARY_INVERSE;
export const COLOR_LIGHT_TEXT_SECONDARY = COLOR_LIGHT_FOREGROUND_SECONDARY;
export const COLOR_LIGHT_TEXT_SECONDARY_INVERSE = COLOR_LIGHT_FOREGROUND_SECONDARY_INVERSE;
export const COLOR_LIGHT_TEXT_INACTIVE = COLOR_LIGHT_FOREGROUND_INACTIVE;
export const COLOR_LIGHT_TEXT_PRIMARY_OVERLAY = COLOR_LIGHT_FOREGROUND_PRIMARY_STATIC_LIGHT;
export const COLOR_LIGHT_TEXT_PRIMARY_OVERLAY_INVERSE = COLOR_LIGHT_FOREGROUND_PRIMARY_STATIC_DARK;
export const COLOR_LIGHT_TEXT_SECONDARY_OVERLAY = COLOR_LIGHT_FOREGROUND_SECONDARY_STATIC_LIGHT;
export const COLOR_LIGHT_TEXT_SECONDARY_OVERLAY_INVERSE =
  COLOR_LIGHT_FOREGROUND_SECONDARY_STATIC_DARK;
export const COLOR_LIGHT_TEXT_ERROR = COLOR_LIGHT_ACCENT_ERROR;
export const COLOR_LIGHT_TEXT_LINK = COLOR_LIGHT_ACCENT_LINK;
export const COLOR_LIGHT_TEXT_GOLD = COLOR_LIGHT_ACCENT_GOLD;
export const COLOR_LIGHT_TEXT_LIKE = COLOR_LIGHT_ACCENT_LIKE;
export const COLOR_LIGHT_TEXT_SUPER_LIKE = COLOR_LIGHT_ACCENT_SUPER_LIKE;
export const COLOR_LIGHT_TEXT_BOOST = COLOR_LIGHT_ACCENT_BOOST;
export const COLOR_LIGHT_TEXT_SUPER_BOOST = COLOR_LIGHT_ACCENT_BOOST;
export const COLOR_LIGHT_TEXT_SUCCESS = COLOR_LIGHT_ACCENT_SUCCESS;
export const COLOR_LIGHT_TEXT_DISABLED = COLOR_LIGHT_FOREGROUND_DISABLED;
export const COLOR_LIGHT_TEXT_LINK_OVERLAY = COLOR_LIGHT_FOREGROUND_PRIMARY_STATIC_LIGHT;
export const COLOR_LIGHT_TEXT_HIGHLIGHT_FOREGROUND = COLOR_LIGHT_FOREGROUND_PRIMARY_INVERSE;
export const COLOR_LIGHT_TEXT_HIGHLIGHT_BACKGROUND = COLOR_LIGHT_FOREGROUND_PRIMARY;
export const COLOR_LIGHT_TEXT_BRAND_NORMAL = COLOR_LIGHT_ACCENT_PRIMARY_A11Y;
export const COLOR_LIGHT_TEXT_BRAND_LARGE = COLOR_LIGHT_ACCENT_PRIMARY;
export const COLOR_LIGHT_TEXT_VAULT_NORMAL = COLOR_LIGHT_ACCENT_SELECT;
export const COLOR_LIGHT_TEXT_VAULT_LARGE = COLOR_LIGHT_ACCENT_SELECT;
export const COLOR_LIGHT_TEXT_TRUST = COLOR_LIGHT_ACCENT_TRUST;
export const GRADIENT_DARK_ICON_CONTAINER_BANNER_DEFAULT = GRADIENT_BRAND_GRADIENT;
export const GRADIENT_DARK_BACKGROUND_BUTTON_PRIMARY = GRADIENT_BRAND_GRADIENT;
export const GRADIENT_DARK_BACKGROUND_GAMEPAD_REWIND_PRESSED = GRADIENT_GAMEPAD_REWIND;
export const GRADIENT_DARK_BACKGROUND_GAMEPAD_SUPER_LIKE_PRESSED =
  GRADIENT_GAMEPAD_SUPER_LIKE_ON_LIGHT;
export const GRADIENT_DARK_BACKGROUND_GAMEPAD_LIKE_PRESSED = GRADIENT_GAMEPAD_LIKE_ON_LIGHT;
export const GRADIENT_DARK_BACKGROUND_GAMEPAD_BOOST_PRESSED = GRADIENT_GAMEPAD_BOOST;
export const GRADIENT_DARK_BACKGROUND_GAMEPAD_SPARKS_REWIND_PRESSED =
  GRADIENT_GAMEPAD_SPARKS_REWIND;
export const GRADIENT_DARK_BACKGROUND_GAMEPAD_SPARKS_NOPE_PRESSED = GRADIENT_GAMEPAD_SPARKS_NOPE;
export const GRADIENT_DARK_BACKGROUND_GAMEPAD_SPARKS_SUPER_LIKE_PRESSED =
  GRADIENT_GAMEPAD_SPARKS_SUPER_LIKE;
export const GRADIENT_DARK_BACKGROUND_GAMEPAD_SPARKS_LIKE_PRESSED = GRADIENT_GAMEPAD_SPARKS_LIKE;
export const GRADIENT_DARK_BACKGROUND_GAMEPAD_SPARKS_BOOST_PRESSED = GRADIENT_GAMEPAD_SPARKS_BOOST;
export const GRADIENT_DARK_ICON_GAMEPAD_PRIMARY_REWIND_DEFAULT = GRADIENT_GAMEPAD_REWIND_ON_DARK;
export const GRADIENT_DARK_ICON_GAMEPAD_PRIMARY_SUPER_LIKE_DEFAULT =
  GRADIENT_GAMEPAD_SUPER_LIKE_ON_DARK;
export const GRADIENT_DARK_ICON_GAMEPAD_PRIMARY_LIKE_DEFAULT = GRADIENT_GAMEPAD_LIKE_ON_DARK;
export const GRADIENT_DARK_ICON_GAMEPAD_PRIMARY_BOOST_DEFAULT = GRADIENT_GAMEPAD_BOOST_ON_DARK;
export const GRADIENT_DARK_ICON_GAMEPAD_SECONDARY_REWIND_DEFAULT = GRADIENT_GAMEPAD_REWIND_ON_DARK;
export const GRADIENT_DARK_ICON_GAMEPAD_SECONDARY_SUPER_LIKE_DEFAULT =
  GRADIENT_GAMEPAD_SUPER_LIKE_ON_DARK;
export const GRADIENT_DARK_ICON_GAMEPAD_SECONDARY_LIKE_DEFAULT = GRADIENT_GAMEPAD_LIKE_ON_DARK;
export const GRADIENT_DARK_ICON_GAMEPAD_SECONDARY_BOOST_DEFAULT = GRADIENT_GAMEPAD_BOOST;
export const GRADIENT_DARK_ICON_GAMEPAD_SPARKS_REWIND_DEFAULT = GRADIENT_GAMEPAD_SPARKS_REWIND;
export const GRADIENT_DARK_ICON_GAMEPAD_SPARKS_NOPE_DEFAULT = GRADIENT_GAMEPAD_SPARKS_NOPE;
export const GRADIENT_DARK_ICON_GAMEPAD_SPARKS_SUPER_LIKE_DEFAULT =
  GRADIENT_GAMEPAD_SPARKS_SUPER_LIKE;
export const GRADIENT_DARK_ICON_GAMEPAD_SPARKS_LIKE_DEFAULT = GRADIENT_GAMEPAD_SPARKS_LIKE;
export const GRADIENT_DARK_ICON_GAMEPAD_SPARKS_BOOST_DEFAULT = GRADIENT_GAMEPAD_SPARKS_BOOST;
export const GRADIENT_DARK_ICON_NAVIGATION_PRIMARY_ACTIVE = GRADIENT_BRAND_GRADIENT;
export const GRADIENT_DARK_BACKGROUND_PASSIONS_SHARED_REC = GRADIENT_PASSIONS_GRADIENT;
export const GRADIENT_DARK_FOREGROUND_PROGRESS_ACTIVE = GRADIENT_PASSIONS_GRADIENT;
export const GRADIENT_DARK_SWIPE_OVERLAY_REC_CARD_SPARKS_LIKE = GRADIENT_GAMEPAD_SPARKS_LIKE;
export const GRADIENT_DARK_SWIPE_OVERLAY_REC_CARD_SPARKS_NOPE = GRADIENT_GAMEPAD_SPARKS_NOPE;
export const GRADIENT_DARK_SWIPE_OVERLAY_REC_CARD_SPARKS_SUPER_LIKE =
  GRADIENT_GAMEPAD_SPARKS_SUPER_LIKE;
export const GRADIENT_DARK_OVERLAY_REC_CARD_SPARKS_SUPER_LIKE =
  GRADIENT_DARK_OVERLAY_PROFILE_SPARKS_SUPER_LIKE;
export const GRADIENT_DARK_ACCENT_PRIMARY_GRADIENT = GRADIENT_BRAND_GRADIENT;
export const GRADIENT_DARK_ACCENT_BRAND_GRADIENT = GRADIENT_BRAND_GRADIENT;
export const GRADIENT_DARK_ACCENT_LIKE_GRADIENT = GRADIENT_GAMEPAD_LIKE_ON_DARK;
export const GRADIENT_DARK_ACCENT_SPARKS_LIKE_GRADIENT = GRADIENT_GAMEPAD_SPARKS_LIKE;
export const GRADIENT_DARK_ACCENT_NOPE_GRADIENT = GRADIENT_GAMEPAD_NOPE_ON_DARK;
export const GRADIENT_DARK_ACCENT_SPARKS_NOPE_GRADIENT = GRADIENT_GAMEPAD_SPARKS_NOPE;
export const GRADIENT_DARK_ACCENT_SUPER_LIKE_GRADIENT = GRADIENT_GAMEPAD_SUPER_LIKE_ON_DARK;
export const GRADIENT_DARK_ACCENT_SPARKS_SUPER_LIKE_GRADIENT = GRADIENT_GAMEPAD_SPARKS_SUPER_LIKE;
export const GRADIENT_DARK_ACCENT_BOOST_GRADIENT = GRADIENT_GAMEPAD_BOOST_ON_DARK;
export const GRADIENT_DARK_ACCENT_SPARKS_BOOST_GRADIENT = GRADIENT_GAMEPAD_SPARKS_BOOST;
export const GRADIENT_DARK_ACCENT_SUPER_BOOST_GRADIENT = GRADIENT_GAMEPAD_SUPER_BOOST_ON_DARK;
export const GRADIENT_DARK_ACCENT_REWIND_GRADIENT = GRADIENT_GAMEPAD_REWIND_ON_DARK;
export const GRADIENT_DARK_ACCENT_SPARKS_REWIND_GRADIENT = GRADIENT_GAMEPAD_SPARKS_REWIND;
export const GRADIENT_DARK_ACCENT_GOLD_GRADIENT = GRADIENT_REVENUE_GOLD_ON_DARK;
export const GRADIENT_DARK_ACCENT_GOLD_SHINE_GRADIENT = GRADIENT_REVENUE_GOLD_SHINE_ON_DARK;
export const GRADIENT_DARK_ACCENT_PLATINUM_GRADIENT = GRADIENT_REVENUE_PLATINUM_ON_DARK;
export const GRADIENT_DARK_ACCENT_PLATINUM_SHINE_GRADIENT = GRADIENT_REVENUE_PLATINUM_SHINE_ON_DARK;
export const GRADIENT_DARK_ACCENT_PLATINUM_GRADIENT_INVERSE = GRADIENT_REVENUE_PLATINUM;
export const GRADIENT_DARK_ACCENT_PLATINUM_SHINE_GRADIENT_INVERSE = GRADIENT_REVENUE_PLATINUM_SHINE;
export const GRADIENT_DARK_ACCENT_SELECT_GRADIENT = GRADIENT_VAULT_GRADIENT;
export const GRADIENT_DARK_ACCENT_EXPLORE_GRADIENT = GRADIENT_EXPLORE_ATTRIBUTION_GRADIENT;
export const GRADIENT_DARK_ACCENT_FESTIVAL_MODE_GRADIENT = GRADIENT_FESTIVAL_MODE_GRADIENT;
export const GRADIENT_DARK_ACCENT_SPOTIFY_MUSIC_MODE_GRADIENT =
  GRADIENT_SPOTIFY_MUSIC_MODE_GRADIENT;
export const GRADIENT_DARK_ACCENT_HOT_TAKES_GRADIENT = GRADIENT_HOT_TAKES_GRADIENT;
export const GRADIENT_DARK_ACCENT_MATCH_EXPIRATION_GRADIENT =
  GRADIENT_MATCH_EXPIRATION_GRADIENT_ON_DARK;
export const GRADIENT_DARK_ACCENT_PASSIONS_GRADIENT = GRADIENT_PASSIONS_GRADIENT;
export const GRADIENT_DARK_ACCENT_VIBES_GRADIENT = GRADIENT_VIBES_GRADIENT;
export const GRADIENT_DARK_ACCENT_MATCHMAKER_GRADIENT = GRADIENT_SPARKS_MATCHMAKER_ATTRIBUTION;
export const GRADIENT_DARK_BACKGROUND_PRIMARY_LINEAR: ThemeGradient = {
  angle: 180,
  colors: [COLOR_DARK_BACKGROUND_PRIMARY, COLOR_DARK_BACKGROUND_SECONDARY],
  positions: [0, 1],
};
export const GRADIENT_DARK_BACKGROUND_BRAND_SUBTLE = GRADIENT_BRAND_SUBTLE_ON_DARK;
export const GRADIENT_DARK_BACKGROUND_SUPER_LIKE = GRADIENT_GAMEPAD_SUPER_LIKE_ON_DARK;
export const GRADIENT_DARK_BACKGROUND_SUPER_LIKE_INVERSE = GRADIENT_GAMEPAD_SUPER_LIKE;
export const GRADIENT_DARK_BACKGROUND_SUPER_LIKE_SUBTLE =
  GRADIENT_GAMEPAD_SUPER_LIKE_SUBTLE_ON_DARK;
export const GRADIENT_DARK_BACKGROUND_LIKE = GRADIENT_GAMEPAD_LIKE_ON_DARK;
export const GRADIENT_DARK_BACKGROUND_LIKE_INVERSE = GRADIENT_GAMEPAD_LIKE;
export const GRADIENT_DARK_BACKGROUND_LIKE_SUBTLE = GRADIENT_GAMEPAD_LIKE_SUBTLE_ON_DARK;
export const GRADIENT_DARK_BACKGROUND_BOOST = GRADIENT_GAMEPAD_BOOST_ON_DARK;
export const GRADIENT_DARK_BACKGROUND_BOOST_INVERSE = GRADIENT_GAMEPAD_BOOST;
export const GRADIENT_DARK_BACKGROUND_BOOST_SUBTLE = GRADIENT_GAMEPAD_BOOST_SUBTLE_ON_DARK;
export const GRADIENT_DARK_BACKGROUND_SUPER_BOOST_SUBTLE =
  GRADIENT_GAMEPAD_SUPER_BOOST_SUBTLE_ON_DARK;
export const GRADIENT_DARK_BACKGROUND_PLUS_SUBTLE = GRADIENT_REVENUE_PLUS_SUBTLE_ON_DARK;
export const GRADIENT_DARK_BACKGROUND_GOLD_SUBTLE = GRADIENT_REVENUE_GOLD_SUBTLE_ON_DARK;
export const GRADIENT_DARK_BACKGROUND_PLATINUM_SUBTLE = GRADIENT_REVENUE_PLATINUM_SUBTLE_ON_DARK;
export const GRADIENT_DARK_BACKGROUND_SELECT_SUBTLE = GRADIENT_VAULT_SUBTLE_ON_DARK;
export const GRADIENT_DARK_BACKGROUND_SPARKS_PRIMARY = GRADIENT_SPARKS_BACKGROUND_GRADIENT_DARK;
export const GRADIENT_DARK_SHIMMER_GOLD = GRADIENT_REVENUE_GOLD_SHINE_ANIMATION_ON_DARK;
export const GRADIENT_DARK_SHIMMER_PLATINUM = GRADIENT_REVENUE_PLATINUM_SHINE_ANIMATION_ON_DARK;
export const GRADIENT_DARK_FADE_PRIMARY_BOTTOM_TO_TOP: ThemeGradient = {
  angle: 0,
  colors: [COLOR_DARK_BACKGROUND_PRIMARY, alphaColor(COLOR_DARK_BACKGROUND_PRIMARY, 0)],
  positions: [0, 1],
};
export const GRADIENT_DARK_FADE_PRIMARY_TOP_TO_BOTTOM: ThemeGradient = {
  angle: 180,
  colors: [COLOR_DARK_BACKGROUND_PRIMARY, alphaColor(COLOR_DARK_BACKGROUND_PRIMARY, 0)],
  positions: [0, 1],
};
export const GRADIENT_LIGHT_ICON_CONTAINER_BANNER_DEFAULT = GRADIENT_BRAND_GRADIENT;
export const GRADIENT_LIGHT_BACKGROUND_BUTTON_PRIMARY = GRADIENT_BRAND_GRADIENT;
export const GRADIENT_LIGHT_BACKGROUND_GAMEPAD_REWIND_PRESSED = GRADIENT_GAMEPAD_REWIND;
export const GRADIENT_LIGHT_BACKGROUND_GAMEPAD_SUPER_LIKE_PRESSED =
  GRADIENT_GAMEPAD_SUPER_LIKE_ON_LIGHT;
export const GRADIENT_LIGHT_BACKGROUND_GAMEPAD_LIKE_PRESSED = GRADIENT_GAMEPAD_LIKE_ON_LIGHT;
export const GRADIENT_LIGHT_BACKGROUND_GAMEPAD_BOOST_PRESSED = GRADIENT_GAMEPAD_BOOST;
export const GRADIENT_LIGHT_BACKGROUND_GAMEPAD_SPARKS_REWIND_PRESSED =
  GRADIENT_GAMEPAD_SPARKS_REWIND;
export const GRADIENT_LIGHT_BACKGROUND_GAMEPAD_SPARKS_NOPE_PRESSED = GRADIENT_GAMEPAD_SPARKS_NOPE;
export const GRADIENT_LIGHT_BACKGROUND_GAMEPAD_SPARKS_SUPER_LIKE_PRESSED =
  GRADIENT_GAMEPAD_SPARKS_SUPER_LIKE;
export const GRADIENT_LIGHT_BACKGROUND_GAMEPAD_SPARKS_LIKE_PRESSED = GRADIENT_GAMEPAD_SPARKS_LIKE;
export const GRADIENT_LIGHT_BACKGROUND_GAMEPAD_SPARKS_BOOST_PRESSED = GRADIENT_GAMEPAD_SPARKS_BOOST;
export const GRADIENT_LIGHT_ICON_GAMEPAD_PRIMARY_REWIND_DEFAULT = GRADIENT_GAMEPAD_REWIND_ON_DARK;
export const GRADIENT_LIGHT_ICON_GAMEPAD_PRIMARY_SUPER_LIKE_DEFAULT =
  GRADIENT_GAMEPAD_SUPER_LIKE_ON_DARK;
export const GRADIENT_LIGHT_ICON_GAMEPAD_PRIMARY_LIKE_DEFAULT = GRADIENT_GAMEPAD_LIKE_ON_DARK;
export const GRADIENT_LIGHT_ICON_GAMEPAD_PRIMARY_BOOST_DEFAULT = GRADIENT_GAMEPAD_BOOST;
export const GRADIENT_LIGHT_ICON_GAMEPAD_SECONDARY_REWIND_DEFAULT = GRADIENT_GAMEPAD_REWIND;
export const GRADIENT_LIGHT_ICON_GAMEPAD_SECONDARY_SUPER_LIKE_DEFAULT =
  GRADIENT_GAMEPAD_SUPER_LIKE_ON_LIGHT;
export const GRADIENT_LIGHT_ICON_GAMEPAD_SECONDARY_LIKE_DEFAULT = GRADIENT_GAMEPAD_LIKE_ON_LIGHT;
export const GRADIENT_LIGHT_ICON_GAMEPAD_SECONDARY_BOOST_DEFAULT = GRADIENT_GAMEPAD_BOOST;
export const GRADIENT_LIGHT_ICON_GAMEPAD_SPARKS_REWIND_DEFAULT = GRADIENT_GAMEPAD_SPARKS_REWIND;
export const GRADIENT_LIGHT_ICON_GAMEPAD_SPARKS_NOPE_DEFAULT = GRADIENT_GAMEPAD_SPARKS_NOPE;
export const GRADIENT_LIGHT_ICON_GAMEPAD_SPARKS_SUPER_LIKE_DEFAULT =
  GRADIENT_GAMEPAD_SPARKS_SUPER_LIKE;
export const GRADIENT_LIGHT_ICON_GAMEPAD_SPARKS_LIKE_DEFAULT = GRADIENT_GAMEPAD_SPARKS_LIKE;
export const GRADIENT_LIGHT_ICON_GAMEPAD_SPARKS_BOOST_DEFAULT = GRADIENT_GAMEPAD_SPARKS_BOOST;
export const GRADIENT_LIGHT_ICON_NAVIGATION_PRIMARY_ACTIVE = GRADIENT_BRAND_GRADIENT;
export const GRADIENT_LIGHT_BACKGROUND_PASSIONS_SHARED_REC = GRADIENT_PASSIONS_GRADIENT;
export const GRADIENT_LIGHT_FOREGROUND_PROGRESS_ACTIVE = GRADIENT_PASSIONS_GRADIENT;
export const GRADIENT_LIGHT_SWIPE_OVERLAY_REC_CARD_SPARKS_LIKE = GRADIENT_GAMEPAD_SPARKS_LIKE;
export const GRADIENT_LIGHT_SWIPE_OVERLAY_REC_CARD_SPARKS_NOPE = GRADIENT_GAMEPAD_SPARKS_NOPE;
export const GRADIENT_LIGHT_SWIPE_OVERLAY_REC_CARD_SPARKS_SUPER_LIKE =
  GRADIENT_GAMEPAD_SPARKS_SUPER_LIKE;
export const GRADIENT_LIGHT_OVERLAY_REC_CARD_SPARKS_SUPER_LIKE =
  GRADIENT_LIGHT_OVERLAY_PROFILE_SPARKS_SUPER_LIKE;
export const GRADIENT_LIGHT_ACCENT_PRIMARY_GRADIENT = GRADIENT_BRAND_GRADIENT;
export const GRADIENT_LIGHT_ACCENT_BRAND_GRADIENT = GRADIENT_BRAND_GRADIENT;
export const GRADIENT_LIGHT_ACCENT_LIKE_GRADIENT = GRADIENT_GAMEPAD_LIKE_ON_LIGHT;
export const GRADIENT_LIGHT_ACCENT_SPARKS_LIKE_GRADIENT = GRADIENT_GAMEPAD_SPARKS_LIKE;
export const GRADIENT_LIGHT_ACCENT_SPARKS_NOPE_GRADIENT = GRADIENT_GAMEPAD_SPARKS_NOPE;
export const GRADIENT_LIGHT_ACCENT_SUPER_LIKE_GRADIENT = GRADIENT_GAMEPAD_SUPER_LIKE_ON_LIGHT;
export const GRADIENT_LIGHT_ACCENT_SPARKS_SUPER_LIKE_GRADIENT = GRADIENT_GAMEPAD_SPARKS_SUPER_LIKE;
export const GRADIENT_LIGHT_ACCENT_BOOST_GRADIENT = GRADIENT_GAMEPAD_BOOST;
export const GRADIENT_LIGHT_ACCENT_SPARKS_BOOST_GRADIENT = GRADIENT_GAMEPAD_SPARKS_BOOST;
export const GRADIENT_LIGHT_ACCENT_SUPER_BOOST_GRADIENT = GRADIENT_GAMEPAD_SUPER_BOOST;
export const GRADIENT_LIGHT_ACCENT_REWIND_GRADIENT = GRADIENT_GAMEPAD_REWIND;
export const GRADIENT_LIGHT_ACCENT_SPARKS_REWIND_GRADIENT = GRADIENT_GAMEPAD_SPARKS_REWIND;
export const GRADIENT_LIGHT_ACCENT_GOLD_GRADIENT = GRADIENT_REVENUE_GOLD;
export const GRADIENT_LIGHT_ACCENT_GOLD_SHINE_GRADIENT = GRADIENT_REVENUE_GOLD_SHINE;
export const GRADIENT_LIGHT_ACCENT_PLATINUM_GRADIENT = GRADIENT_REVENUE_PLATINUM;
export const GRADIENT_LIGHT_ACCENT_PLATINUM_SHINE_GRADIENT = GRADIENT_REVENUE_PLATINUM_SHINE;
export const GRADIENT_LIGHT_ACCENT_PLATINUM_GRADIENT_INVERSE = GRADIENT_REVENUE_PLATINUM_ON_DARK;
export const GRADIENT_LIGHT_ACCENT_PLATINUM_SHINE_GRADIENT_INVERSE =
  GRADIENT_REVENUE_PLATINUM_SHINE_ON_DARK;
export const GRADIENT_LIGHT_ACCENT_SELECT_GRADIENT = GRADIENT_VAULT_GRADIENT;
export const GRADIENT_LIGHT_ACCENT_EXPLORE_GRADIENT = GRADIENT_EXPLORE_ATTRIBUTION_GRADIENT;
export const GRADIENT_LIGHT_ACCENT_FESTIVAL_MODE_GRADIENT = GRADIENT_FESTIVAL_MODE_GRADIENT;
export const GRADIENT_LIGHT_ACCENT_SPOTIFY_MUSIC_MODE_GRADIENT =
  GRADIENT_SPOTIFY_MUSIC_MODE_GRADIENT;
export const GRADIENT_LIGHT_ACCENT_HOT_TAKES_GRADIENT = GRADIENT_HOT_TAKES_GRADIENT;
export const GRADIENT_LIGHT_ACCENT_MATCH_EXPIRATION_GRADIENT = GRADIENT_MATCH_EXPIRATION_GRADIENT;
export const GRADIENT_LIGHT_ACCENT_PASSIONS_GRADIENT = GRADIENT_PASSIONS_GRADIENT;
export const GRADIENT_LIGHT_ACCENT_VIBES_GRADIENT = GRADIENT_VIBES_GRADIENT;
export const GRADIENT_LIGHT_ACCENT_MATCHMAKER_GRADIENT = GRADIENT_SPARKS_MATCHMAKER_ATTRIBUTION;
export const GRADIENT_LIGHT_BACKGROUND_PRIMARY_LINEAR: ThemeGradient = {
  angle: 180,
  colors: [COLOR_LIGHT_BACKGROUND_PRIMARY, COLOR_LIGHT_BACKGROUND_SECONDARY],
  positions: [0, 1],
};
export const GRADIENT_LIGHT_BACKGROUND_BRAND_SUBTLE = GRADIENT_BRAND_SUBTLE;
export const GRADIENT_LIGHT_BACKGROUND_SUPER_LIKE = GRADIENT_GAMEPAD_SUPER_LIKE;
export const GRADIENT_LIGHT_BACKGROUND_SUPER_LIKE_INVERSE = GRADIENT_GAMEPAD_SUPER_LIKE_ON_DARK;
export const GRADIENT_LIGHT_BACKGROUND_SUPER_LIKE_SUBTLE = GRADIENT_GAMEPAD_SUPER_LIKE_SUBTLE;
export const GRADIENT_LIGHT_BACKGROUND_LIKE = GRADIENT_GAMEPAD_LIKE;
export const GRADIENT_LIGHT_BACKGROUND_LIKE_INVERSE = GRADIENT_GAMEPAD_LIKE_ON_DARK;
export const GRADIENT_LIGHT_BACKGROUND_LIKE_SUBTLE = GRADIENT_GAMEPAD_LIKE_SUBTLE;
export const GRADIENT_LIGHT_BACKGROUND_BOOST = GRADIENT_GAMEPAD_BOOST;
export const GRADIENT_LIGHT_BACKGROUND_BOOST_INVERSE = GRADIENT_GAMEPAD_BOOST_ON_DARK;
export const GRADIENT_LIGHT_BACKGROUND_BOOST_SUBTLE = GRADIENT_GAMEPAD_BOOST_SUBTLE;
export const GRADIENT_LIGHT_BACKGROUND_SUPER_BOOST_SUBTLE = GRADIENT_GAMEPAD_SUPER_BOOST_SUBTLE;
export const GRADIENT_LIGHT_BACKGROUND_PLUS_SUBTLE = GRADIENT_REVENUE_PLUS_SUBTLE;
export const GRADIENT_LIGHT_BACKGROUND_GOLD_SUBTLE = GRADIENT_REVENUE_GOLD_SUBTLE;
export const GRADIENT_LIGHT_BACKGROUND_PLATINUM_SUBTLE = GRADIENT_REVENUE_PLATINUM_SUBTLE;
export const GRADIENT_LIGHT_BACKGROUND_SELECT_SUBTLE = GRADIENT_VAULT_SUBTLE_ON_LIGHT;
export const GRADIENT_LIGHT_BACKGROUND_SPARKS_PRIMARY = GRADIENT_SPARKS_BACKGROUND_GRADIENT;
export const GRADIENT_LIGHT_SHIMMER_GOLD = GRADIENT_REVENUE_GOLD_SHINE_ANIMATION;
export const GRADIENT_LIGHT_SHIMMER_PLATINUM = GRADIENT_REVENUE_PLATINUM_SHINE_ANIMATION;
export const GRADIENT_LIGHT_FADE_PRIMARY_BOTTOM_TO_TOP: ThemeGradient = {
  angle: 0,
  colors: [COLOR_LIGHT_BACKGROUND_PRIMARY, alphaColor(COLOR_LIGHT_BACKGROUND_PRIMARY, 0)],
  positions: [0, 1],
};
export const GRADIENT_LIGHT_FADE_PRIMARY_TOP_TO_BOTTOM: ThemeGradient = {
  angle: 180,
  colors: [COLOR_LIGHT_BACKGROUND_PRIMARY, alphaColor(COLOR_LIGHT_BACKGROUND_PRIMARY, 0)],
  positions: [0, 1],
};
export const COLOR_DARK_BACKGROUND_BADGE_BRAND_DEFAULT = COLOR_DARK_BACKGROUND_BRAND;
export const COLOR_DARK_BACKGROUND_BADGE_NOTIFICATION_ACTIVE = COLOR_DARK_BACKGROUND_BRAND;
export const COLOR_DARK_ICON_BADGE_VERIFIED = COLOR_DARK_ICON_PRIMARY_OVERLAY;
export const COLOR_DARK_TEXT_BADGE_NOTIFICATION_INACTIVE = COLOR_DARK_TEXT_INACTIVE;
export const COLOR_DARK_ICON_BANNER_DEFAULT = COLOR_DARK_ICON_PRIMARY_OVERLAY;
export const COLOR_DARK_TEXT_BANNER_HEADING = COLOR_DARK_TEXT_PRIMARY;
export const COLOR_DARK_TEXT_BANNER_BODY = COLOR_DARK_TEXT_SECONDARY;
export const COLOR_DARK_DIVIDER_BANNER_DEFAULT = COLOR_DARK_DIVIDER_PRIMARY;
export const COLOR_DARK_BORDER_BUTTON_SECONDARY = COLOR_DARK_BORDER_SECONDARY;
export const COLOR_DARK_BORDER_BUTTON_FOCUSED = COLOR_DARK_BORDER_FOCUS_DEFAULT;
export const COLOR_DARK_BORDER_BUTTON_FOCUSED_OVERLAY = COLOR_DARK_BORDER_FOCUS_OVERLAY;
export const COLOR_DARK_FOREGROUND_BUTTON_SECONDARY = COLOR_DARK_TEXT_PRIMARY;
export const COLOR_DARK_FOREGROUND_BUTTON_TERTIARY = COLOR_DARK_TEXT_PRIMARY;
export const COLOR_DARK_TEXT_CHAT_BUBBLE_SEND = COLOR_DARK_TEXT_PRIMARY_OVERLAY;
export const COLOR_DARK_TEXT_CHAT_BUBBLE_RECEIVE = COLOR_DARK_TEXT_PRIMARY;
export const COLOR_DARK_BACKGROUND_CHECKBOX_SELECTED_ENABLED = COLOR_DARK_BACKGROUND_BRAND;
export const COLOR_DARK_BORDER_CHECKBOX_UNSELECTED_ENABLED = COLOR_DARK_BORDER_PRIMARY;
export const COLOR_DARK_BORDER_CHECKBOX_UNSELECTED_DISABLED = COLOR_DARK_BORDER_DISABLED;
export const COLOR_DARK_BORDER_CHECKBOX_UNSELECTED_ERROR = COLOR_DARK_BORDER_ERROR;
export const COLOR_DARK_ICON_CHECKBOX_SELECTED_ENABLED = COLOR_DARK_ICON_PRIMARY_OVERLAY;
export const COLOR_DARK_ICON_CHECKBOX_SELECTED_DISABLED = COLOR_DARK_ICON_DISABLED;
export const COLOR_DARK_TEXT_DATEPICKER_INACTIVE = COLOR_DARK_TEXT_INACTIVE;
export const COLOR_DARK_TEXT_DATEPICKER_ACTIVE = COLOR_DARK_TEXT_PRIMARY;
export const COLOR_DARK_ICON_FORM_DISABLED = COLOR_DARK_ICON_DISABLED;
export const COLOR_DARK_ICON_FORM_ERROR = COLOR_DARK_ICON_ERROR;
export const COLOR_DARK_ICON_FORM_SUCCESS = COLOR_DARK_ICON_SUCCESS;
export const COLOR_DARK_TEXT_FORM_LABEL_DEFAULT = COLOR_DARK_TEXT_PRIMARY;
export const COLOR_DARK_TEXT_FORM_HELP_DEFAULT = COLOR_DARK_TEXT_SECONDARY;
export const COLOR_DARK_TEXT_FORM_HELP_SUCCESS = COLOR_DARK_TEXT_SUCCESS;
export const COLOR_DARK_TEXT_FORM_HELP_ERROR = COLOR_DARK_TEXT_ERROR;
export const COLOR_DARK_TEXT_FORM_HELP_DISABLED = COLOR_DARK_TEXT_DISABLED;
export const COLOR_DARK_BORDER_GAMEPAD_SECONDARY_DISABLED = COLOR_DARK_BORDER_DISABLED;
export const COLOR_DARK_BORDER_GAMEPAD_SUPER_LIKE_ACTIVE = COLOR_DARK_BORDER_OVERLAY;
export const COLOR_DARK_ICON_GAMEPAD_PRIMARY_PRESSED = COLOR_DARK_ICON_PRIMARY_OVERLAY;
export const COLOR_DARK_ICON_GAMEPAD_PRIMARY_SUPER_LIKE_ACTIVE = COLOR_DARK_BORDER_OVERLAY;
export const COLOR_DARK_ICON_GAMEPAD_SECONDARY_DISABLED = COLOR_DARK_ICON_DISABLED;
export const COLOR_DARK_ICON_GAMEPAD_SECONDARY_PRESSED = COLOR_DARK_ICON_PRIMARY_OVERLAY;
export const COLOR_DARK_ICON_GAMEPAD_SPARKS_REWIND_ACTIVE = COLOR_DARK_ICON_PRIMARY_INVERSE;
export const COLOR_DARK_ICON_GAMEPAD_SPARKS_NOPE_ACTIVE = COLOR_DARK_ICON_PRIMARY_INVERSE;
export const COLOR_DARK_ICON_GAMEPAD_SPARKS_SUPER_LIKE_ACTIVE = COLOR_DARK_ICON_PRIMARY_INVERSE;
export const COLOR_DARK_ICON_GAMEPAD_SPARKS_SUPER_LIKE_DISABLED = COLOR_DARK_ICON_DISABLED;
export const COLOR_DARK_ICON_GAMEPAD_SPARKS_LIKE_ACTIVE = COLOR_DARK_ICON_PRIMARY_INVERSE;
export const COLOR_DARK_ICON_GAMEPAD_SPARKS_BOOST_ACTIVE = COLOR_DARK_ICON_PRIMARY_INVERSE;
export const COLOR_DARK_LABEL_GAMEPAD_SECONDARY_COUNT_SUPER_LIKE = COLOR_DARK_TEXT_SUPER_LIKE;
export const COLOR_DARK_LABEL_GAMEPAD_SECONDARY_COUNT_BOOST = COLOR_DARK_TEXT_BOOST;
export const COLOR_DARK_ICON_ICON_BUTTON_PRIMARY = COLOR_DARK_ICON_PRIMARY_OVERLAY;
export const COLOR_DARK_ICON_ICON_BUTTON_DISABLED = COLOR_DARK_ICON_DISABLED;
export const COLOR_DARK_ICON_ICON_BUTTON_OVERLAY_DEFAULT = COLOR_DARK_ICON_PRIMARY_OVERLAY;
export const COLOR_DARK_LABEL_ICON_BUTTON_PRIMARY = COLOR_DARK_TEXT_SECONDARY;
export const COLOR_DARK_LABEL_ICON_BUTTON_SECONDARY = COLOR_DARK_TEXT_SECONDARY;
export const COLOR_DARK_LABEL_ICON_BUTTON_DISABLED = COLOR_DARK_TEXT_SECONDARY;
export const COLOR_DARK_LABEL_ICON_BUTTON_OVERLAY_DEFAULT = COLOR_DARK_TEXT_PRIMARY_OVERLAY;
export const COLOR_DARK_LABEL_ICON_BUTTON_OVERLAY_DISABLED = COLOR_DARK_TEXT_PRIMARY_OVERLAY;
export const COLOR_DARK_BORDER_ICON_BUTTON_PRIMARY = COLOR_DARK_BORDER_OVERLAY;
export const COLOR_DARK_BORDER_ICON_BUTTON_SECONDARY = COLOR_DARK_BORDER_SECONDARY;
export const COLOR_DARK_BORDER_ICON_BUTTON_DISABLED = COLOR_DARK_BORDER_DISABLED;
export const COLOR_DARK_FOREGROUND_MODAL_HEADING = COLOR_DARK_TEXT_PRIMARY;
export const COLOR_DARK_FOREGROUND_MODAL_BODY = COLOR_DARK_TEXT_SECONDARY;
export const COLOR_DARK_FOREGROUND_MODAL_ICON = COLOR_DARK_ICON_BRAND;
export const COLOR_DARK_ACTION_NAVIGATION_SECONDARY_DISABLED = COLOR_DARK_ICON_DISABLED;
export const COLOR_DARK_BORDER_PASSIONS_ACTIVE = COLOR_DARK_BORDER_BRAND;
export const COLOR_DARK_BORDER_PASSIONS_INACTIVE = COLOR_DARK_BORDER_SECONDARY;
export const COLOR_DARK_BORDER_PASSIONS_SHARED = COLOR_DARK_BORDER_BRAND;
export const COLOR_DARK_BORDER_PASSIONS_SHARED_OVERLAY = COLOR_DARK_BORDER_OVERLAY;
export const COLOR_DARK_TEXT_PASSIONS_ACTIVE = COLOR_DARK_TEXT_PRIMARY;
export const COLOR_DARK_TEXT_PASSIONS_INACTIVE = COLOR_DARK_TEXT_INACTIVE;
export const COLOR_DARK_TEXT_PASSIONS_SHARED = COLOR_DARK_TEXT_PRIMARY;
export const COLOR_DARK_TEXT_PASSIONS_SHARED_REC = COLOR_DARK_TEXT_PRIMARY_OVERLAY;
export const COLOR_DARK_TEXT_PASSIONS_INACTIVE_OVERLAY = COLOR_DARK_TEXT_PRIMARY_OVERLAY;
export const COLOR_DARK_TEXT_PASSIONS_SHARED_OVERLAY = COLOR_DARK_TEXT_PRIMARY_OVERLAY;
export const COLOR_DARK_BACKGROUND_RADIO_SELECTED_ENABLED = COLOR_DARK_BACKGROUND_BRAND;
export const COLOR_DARK_BORDER_RADIO_SELECTED_ENABLED = COLOR_DARK_BORDER_BRAND;
export const COLOR_DARK_BORDER_RADIO_SELECTED_DISABLED = COLOR_DARK_BORDER_DISABLED;
export const COLOR_DARK_BORDER_RADIO_UNSELECTED_ENABLED = COLOR_DARK_BORDER_PRIMARY;
export const COLOR_DARK_BORDER_RADIO_UNSELECTED_DISABLED = COLOR_DARK_BORDER_DISABLED;
export const COLOR_DARK_ICON_RADIO_SELECTED_ENABLED = COLOR_DARK_ICON_PRIMARY_INVERSE;
export const COLOR_DARK_BORDER_REC_CARD_CONTENT_HIDDEN = COLOR_DARK_BORDER_OVERLAY;
export const COLOR_DARK_ICON_REC_CARD_CONTENT_HIDDEN = COLOR_DARK_ICON_PRIMARY_OVERLAY;
export const COLOR_DARK_TEXT_REC_CARD_CONTENT_HIDDEN = COLOR_DARK_TEXT_PRIMARY_OVERLAY;
export const COLOR_DARK_CURSOR_SEARCH_INPUT = COLOR_DARK_CURSOR_DEFAULT;
export const COLOR_DARK_TEXT_SEARCH_PLACEHOLDER_INACTIVE = COLOR_DARK_TEXT_INACTIVE;
export const COLOR_DARK_TEXT_SEARCH_INPUT_ACTIVE = COLOR_DARK_TEXT_PRIMARY;
export const COLOR_DARK_TEXT_SEARCH_INPUT_INACTIVE = COLOR_DARK_TEXT_PRIMARY;
export const COLOR_DARK_ICON_SELECTOR_SELECTED_ENABLED = COLOR_DARK_ICON_BRAND;
export const COLOR_DARK_ICON_SELECTOR_SELECTED_DISABLED = COLOR_DARK_ICON_DISABLED;
export const COLOR_DARK_BACKGROUND_SLIDER_ALT_KNOB_ENABLED = COLOR_DARK_BACKGROUND_BRAND;
export const COLOR_DARK_BACKGROUND_SLIDER_ALT_KNOB_DISABLED = COLOR_DARK_BORDER_DISABLED;
export const COLOR_DARK_BACKGROUND_SLIDER_ALT_FILL_ENABLED = COLOR_DARK_BACKGROUND_BRAND;
export const COLOR_DARK_BACKGROUND_SLIDER_ALT_FILL_DISABLED = COLOR_DARK_BORDER_DISABLED;
export const COLOR_DARK_BACKGROUND_SLIDER_DEFAULT_FILL_ENABLED = COLOR_DARK_BACKGROUND_BRAND;
export const COLOR_DARK_BACKGROUND_SLIDER_DEFAULT_FILL_DISABLED = COLOR_DARK_BORDER_DISABLED;
export const COLOR_DARK_BORDER_SLIDER_ALT_KNOB_ENABLED = COLOR_DARK_BORDER_BRAND;
export const COLOR_DARK_BORDER_SLIDER_ALT_KNOB_DISABLED = COLOR_DARK_BORDER_DISABLED;
export const COLOR_DARK_BORDER_SLIDER_DEFAULT_KNOB_ENABLED = COLOR_DARK_BORDER_PRIMARY;
export const COLOR_DARK_BORDER_SLIDER_DEFAULT_KNOB_DISABLED = COLOR_DARK_BORDER_DISABLED;
export const COLOR_DARK_BACKGROUND_SWITCH_ALT_KNOB_SELECTED = COLOR_DARK_BACKGROUND_BRAND;
export const COLOR_DARK_BACKGROUND_SWITCH_ALT_KNOB_DISABLED = COLOR_DARK_ICON_DISABLED;
export const COLOR_DARK_BACKGROUND_SWITCH_DEFAULT_TRACK_SELECTED = COLOR_DARK_BACKGROUND_BRAND;
export const COLOR_DARK_BACKGROUND_SWITCH_DEFAULT_KNOB_SELECTED = COLOR_DARK_ICON_PRIMARY_OVERLAY;
export const COLOR_DARK_BACKGROUND_SWITCH_DEFAULT_KNOB_UNSELECTED = COLOR_DARK_ICON_PRIMARY_OVERLAY;
export const COLOR_DARK_BORDER_SWITCH_ALT_TRACK_SELECTED = COLOR_DARK_BORDER_BRAND;
export const COLOR_DARK_BORDER_SWITCH_ALT_TRACK_UNSELECTED = COLOR_DARK_BORDER_PRIMARY;
export const COLOR_DARK_BORDER_SWITCH_ALT_TRACK_DISABLED = COLOR_DARK_BORDER_DISABLED;
export const COLOR_DARK_BORDER_SWITCH_ALT_KNOB_SELECTED = COLOR_DARK_BORDER_BRAND;
export const COLOR_DARK_BORDER_SWITCH_ALT_KNOB_UNSELECTED = COLOR_DARK_BORDER_PRIMARY;
export const COLOR_DARK_BORDER_SWITCH_ALT_KNOB_DISABLED = COLOR_DARK_BORDER_DISABLED;
export const COLOR_DARK_BORDER_SWITCH_DEFAULT_TRACK_SELECTED = COLOR_DARK_BORDER_BRAND;
export const COLOR_DARK_BORDER_SWITCH_DEFAULT_TRACK_UNSELECTED = COLOR_DARK_BORDER_PRIMARY;
export const COLOR_DARK_BORDER_SWITCH_DEFAULT_TRACK_DISABLED = COLOR_DARK_BORDER_DISABLED;
export const COLOR_DARK_BORDER_SWITCH_DEFAULT_KNOB_SELECTED = COLOR_DARK_BORDER_BRAND;
export const COLOR_DARK_BORDER_SWITCH_DEFAULT_KNOB_UNSELECTED = COLOR_DARK_BORDER_PRIMARY;
export const COLOR_DARK_BORDER_SWITCH_DEFAULT_KNOB_DISABLED = COLOR_DARK_BORDER_DISABLED;
export const COLOR_DARK_ICON_SWITCH_ALT_SELECTED = COLOR_DARK_ICON_PRIMARY_OVERLAY;
export const COLOR_DARK_ICON_SWITCH_ALT_UNSELECTED = COLOR_DARK_ICON_PRIMARY_OVERLAY;
export const COLOR_DARK_ICON_SWITCH_ALT_DISABLED = COLOR_DARK_ICON_PRIMARY_OVERLAY;
export const COLOR_DARK_ICON_SWITCH_DEFAULT_SELECTED = COLOR_DARK_ICON_BRAND;
export const COLOR_DARK_ICON_SWITCH_DEFAULT_DISABLED = COLOR_DARK_ICON_DISABLED;
export const COLOR_DARK_DIVIDER_TABLE_ROW_DEFAULT = COLOR_DARK_DIVIDER_PRIMARY;
export const COLOR_DARK_DIVIDER_TABLE_ROW_SPARKS = COLOR_DARK_DIVIDER_SPARKS;
export const COLOR_DARK_BORDER_TAPPY_INDICATOR_INACTIVE = COLOR_DARK_BORDER_PRIMARY;
export const COLOR_DARK_ACTION_TEXT_FIELD_QUIET_INACTIVE = COLOR_DARK_ACTION_INACTIVE;
export const COLOR_DARK_ACTION_TEXT_FIELD_QUIET_ACTIVE = COLOR_DARK_ACTION_ACTIVE;
export const COLOR_DARK_ACTION_TEXT_FIELD_LOUD_INACTIVE = COLOR_DARK_ACTION_INACTIVE;
export const COLOR_DARK_ACTION_TEXT_FIELD_LOUD_ACTIVE = COLOR_DARK_ACTION_ACTIVE;
export const COLOR_DARK_BORDER_TEXT_FIELD_QUIET_DEFAULT = COLOR_DARK_BORDER_PRIMARY;
export const COLOR_DARK_BORDER_TEXT_FIELD_QUIET_ERROR = COLOR_DARK_BORDER_ERROR;
export const COLOR_DARK_BORDER_TEXT_FIELD_QUIET_FOCUS = COLOR_DARK_BORDER_ACTIVE;
export const COLOR_DARK_BORDER_TEXT_FIELD_QUIET_DISABLED = COLOR_DARK_BORDER_DISABLED;
export const COLOR_DARK_BORDER_TEXT_FIELD_LOUD_DEFAULT = COLOR_DARK_BORDER_DISABLED;
export const COLOR_DARK_BORDER_TEXT_FIELD_LOUD_ERROR = COLOR_DARK_BORDER_ERROR;
export const COLOR_DARK_BORDER_TEXT_FIELD_LOUD_FOCUS = COLOR_DARK_BORDER_ACTIVE;
export const COLOR_DARK_BORDER_TEXT_FIELD_LOUD_DISABLED = COLOR_DARK_BORDER_DISABLED;
export const COLOR_DARK_CURSOR_TEXT_FIELD_QUIET_DEFAULT = COLOR_DARK_CURSOR_DEFAULT;
export const COLOR_DARK_CURSOR_TEXT_FIELD_LOUD_DEFAULT = COLOR_DARK_CURSOR_DEFAULT;
export const COLOR_DARK_TEXT_TEXT_FIELD_QUIET_CHARACTERCOUNT_DEFAULT = COLOR_DARK_TEXT_INACTIVE;
export const COLOR_DARK_TEXT_TEXT_FIELD_LOUD_CHARACTERCOUNT_DEFAULT = COLOR_DARK_TEXT_INACTIVE;
export const COLOR_DARK_TEXT_TEXT_FIELD_QUIET_LABEL_OPTIONAL = COLOR_DARK_TEXT_SECONDARY;
export const COLOR_DARK_TEXT_TEXT_FIELD_QUIET_LABEL_ERROR = COLOR_DARK_TEXT_ERROR;
export const COLOR_DARK_TEXT_TEXT_FIELD_LOUD_LABEL_OPTIONAL = COLOR_DARK_TEXT_SECONDARY;
export const COLOR_DARK_TEXT_TEXT_FIELD_LOUD_LABEL_ERROR = COLOR_DARK_TEXT_ERROR;
export const COLOR_DARK_TEXT_TEXT_FIELD_QUIET_PLACEHOLDER_DEFAULT = COLOR_DARK_TEXT_INACTIVE;
export const COLOR_DARK_TEXT_TEXT_FIELD_LOUD_PLACEHOLDER_DEFAULT = COLOR_DARK_TEXT_INACTIVE;
export const COLOR_DARK_TEXT_TEXT_FIELD_QUIET_INPUT_DEFAULT = COLOR_DARK_TEXT_PRIMARY;
export const COLOR_DARK_TEXT_TEXT_FIELD_QUIET_INPUT_DISABLED = COLOR_DARK_TEXT_DISABLED;
export const COLOR_DARK_TEXT_TEXT_FIELD_LOUD_INPUT_DEFAULT = COLOR_DARK_TEXT_PRIMARY;
export const COLOR_DARK_TEXT_TEXT_FIELD_LOUD_INPUT_DISABLED = COLOR_DARK_TEXT_DISABLED;
export const COLOR_DARK_ICON_TOOLTIP_DISMISS = COLOR_DARK_ICON_PRIMARY_INVERSE;
export const COLOR_DARK_TEXT_TOOLTIP_DEFAULT = COLOR_DARK_TEXT_PRIMARY_INVERSE;
export const COLOR_DARK_TEXT_TOOLTIP_REVENUE_DEFAULT = COLOR_DARK_TEXT_PRIMARY_INVERSE;
export const COLOR_DARK_TEXT_TOOLTIP_TRUST_DEFAULT = COLOR_DARK_TEXT_PRIMARY_OVERLAY;
export const COLOR_DARK_BACKGROUND_CARD_DEFAULT = COLOR_DARK_BACKGROUND_ELEVATED;
export const COLOR_DARK_BORDER_CONTAINER_ELEVATED = COLOR_DARK_FOREGROUND_BORDER_ELEVATED;
export const COLOR_LIGHT_BACKGROUND_BADGE_BRAND_DEFAULT = COLOR_LIGHT_BACKGROUND_BRAND;
export const COLOR_LIGHT_BACKGROUND_BADGE_NOTIFICATION_ACTIVE = COLOR_LIGHT_BACKGROUND_BRAND;
export const COLOR_LIGHT_ICON_BADGE_VERIFIED = COLOR_LIGHT_ICON_PRIMARY_OVERLAY;
export const COLOR_LIGHT_TEXT_BADGE_NOTIFICATION_INACTIVE = COLOR_LIGHT_TEXT_INACTIVE;
export const COLOR_LIGHT_ICON_BANNER_DEFAULT = COLOR_LIGHT_ICON_PRIMARY_OVERLAY;
export const COLOR_LIGHT_TEXT_BANNER_HEADING = COLOR_LIGHT_TEXT_PRIMARY;
export const COLOR_LIGHT_TEXT_BANNER_BODY = COLOR_LIGHT_TEXT_SECONDARY;
export const COLOR_LIGHT_DIVIDER_BANNER_DEFAULT = COLOR_LIGHT_DIVIDER_PRIMARY;
export const COLOR_LIGHT_BORDER_BUTTON_SECONDARY = COLOR_LIGHT_BORDER_SECONDARY;
export const COLOR_LIGHT_BORDER_BUTTON_FOCUSED = COLOR_LIGHT_BORDER_FOCUS_DEFAULT;
export const COLOR_LIGHT_BORDER_BUTTON_FOCUSED_OVERLAY = COLOR_LIGHT_BORDER_FOCUS_OVERLAY;
export const COLOR_LIGHT_FOREGROUND_BUTTON_SECONDARY = COLOR_LIGHT_TEXT_PRIMARY;
export const COLOR_LIGHT_FOREGROUND_BUTTON_TERTIARY = COLOR_LIGHT_TEXT_PRIMARY;
export const COLOR_LIGHT_TEXT_CHAT_BUBBLE_SEND = COLOR_LIGHT_TEXT_PRIMARY_OVERLAY;
export const COLOR_LIGHT_TEXT_CHAT_BUBBLE_RECEIVE = COLOR_LIGHT_TEXT_PRIMARY;
export const COLOR_LIGHT_BACKGROUND_CHECKBOX_SELECTED_ENABLED = COLOR_LIGHT_BACKGROUND_BRAND;
export const COLOR_LIGHT_BORDER_CHECKBOX_UNSELECTED_ENABLED = COLOR_LIGHT_BORDER_PRIMARY;
export const COLOR_LIGHT_BORDER_CHECKBOX_UNSELECTED_DISABLED = COLOR_LIGHT_BORDER_DISABLED;
export const COLOR_LIGHT_BORDER_CHECKBOX_UNSELECTED_ERROR = COLOR_LIGHT_BORDER_ERROR;
export const COLOR_LIGHT_ICON_CHECKBOX_SELECTED_ENABLED = COLOR_LIGHT_ICON_PRIMARY_OVERLAY;
export const COLOR_LIGHT_ICON_CHECKBOX_SELECTED_DISABLED = COLOR_LIGHT_ICON_DISABLED;
export const COLOR_LIGHT_TEXT_DATEPICKER_INACTIVE = COLOR_LIGHT_TEXT_INACTIVE;
export const COLOR_LIGHT_TEXT_DATEPICKER_ACTIVE = COLOR_LIGHT_TEXT_PRIMARY;
export const COLOR_LIGHT_ICON_FORM_DISABLED = COLOR_LIGHT_ICON_DISABLED;
export const COLOR_LIGHT_ICON_FORM_ERROR = COLOR_LIGHT_ICON_ERROR;
export const COLOR_LIGHT_ICON_FORM_SUCCESS = COLOR_LIGHT_ICON_SUCCESS;
export const COLOR_LIGHT_TEXT_FORM_LABEL_DEFAULT = COLOR_LIGHT_TEXT_PRIMARY;
export const COLOR_LIGHT_TEXT_FORM_HELP_DEFAULT = COLOR_LIGHT_TEXT_SECONDARY;
export const COLOR_LIGHT_TEXT_FORM_HELP_SUCCESS = COLOR_LIGHT_TEXT_SUCCESS;
export const COLOR_LIGHT_TEXT_FORM_HELP_ERROR = COLOR_LIGHT_TEXT_ERROR;
export const COLOR_LIGHT_TEXT_FORM_HELP_DISABLED = COLOR_LIGHT_TEXT_DISABLED;
export const COLOR_LIGHT_BACKGROUND_GAMEPAD_SECONDARY_DISABLED = COLOR_LIGHT_BACKGROUND_DISABLED;
export const COLOR_LIGHT_BORDER_GAMEPAD_SECONDARY_DISABLED = COLOR_LIGHT_BORDER_DISABLED;
export const COLOR_LIGHT_BORDER_GAMEPAD_SUPER_LIKE_ACTIVE = COLOR_LIGHT_BORDER_OVERLAY;
export const COLOR_LIGHT_ICON_GAMEPAD_PRIMARY_PRESSED = COLOR_LIGHT_ICON_PRIMARY_OVERLAY;
export const COLOR_LIGHT_ICON_GAMEPAD_PRIMARY_SUPER_LIKE_ACTIVE = COLOR_LIGHT_BORDER_OVERLAY;
export const COLOR_LIGHT_ICON_GAMEPAD_SECONDARY_DISABLED = COLOR_LIGHT_ICON_DISABLED;
export const COLOR_LIGHT_ICON_GAMEPAD_SECONDARY_PRESSED = COLOR_LIGHT_ICON_PRIMARY_OVERLAY;
export const COLOR_LIGHT_ICON_GAMEPAD_SPARKS_REWIND_ACTIVE = COLOR_LIGHT_ICON_PRIMARY_INVERSE;
export const COLOR_LIGHT_ICON_GAMEPAD_SPARKS_NOPE_ACTIVE = COLOR_LIGHT_ICON_PRIMARY_INVERSE;
export const COLOR_LIGHT_ICON_GAMEPAD_SPARKS_SUPER_LIKE_ACTIVE = COLOR_LIGHT_ICON_PRIMARY_INVERSE;
export const COLOR_LIGHT_ICON_GAMEPAD_SPARKS_SUPER_LIKE_DISABLED = COLOR_LIGHT_ICON_DISABLED;
export const COLOR_LIGHT_ICON_GAMEPAD_SPARKS_LIKE_ACTIVE = COLOR_LIGHT_ICON_PRIMARY_INVERSE;
export const COLOR_LIGHT_ICON_GAMEPAD_SPARKS_BOOST_ACTIVE = COLOR_LIGHT_ICON_PRIMARY_INVERSE;
export const COLOR_LIGHT_LABEL_GAMEPAD_SECONDARY_COUNT_SUPER_LIKE = COLOR_LIGHT_TEXT_SUPER_LIKE;
export const COLOR_LIGHT_LABEL_GAMEPAD_SECONDARY_COUNT_BOOST = COLOR_LIGHT_TEXT_BOOST;
export const COLOR_LIGHT_BACKGROUND_ICON_BUTTON_DISABLED = COLOR_LIGHT_BACKGROUND_DISABLED;
export const COLOR_LIGHT_ICON_ICON_BUTTON_PRIMARY = COLOR_LIGHT_ICON_PRIMARY_OVERLAY;
export const COLOR_LIGHT_ICON_ICON_BUTTON_DISABLED = COLOR_LIGHT_ICON_DISABLED;
export const COLOR_LIGHT_ICON_ICON_BUTTON_OVERLAY_DEFAULT = COLOR_LIGHT_ICON_PRIMARY_OVERLAY;
export const COLOR_LIGHT_LABEL_ICON_BUTTON_PRIMARY = COLOR_LIGHT_TEXT_SECONDARY;
export const COLOR_LIGHT_LABEL_ICON_BUTTON_SECONDARY = COLOR_LIGHT_TEXT_SECONDARY;
export const COLOR_LIGHT_LABEL_ICON_BUTTON_DISABLED = COLOR_LIGHT_TEXT_SECONDARY;
export const COLOR_LIGHT_LABEL_ICON_BUTTON_OVERLAY_DEFAULT = COLOR_LIGHT_TEXT_PRIMARY_OVERLAY;
export const COLOR_LIGHT_LABEL_ICON_BUTTON_OVERLAY_DISABLED = COLOR_LIGHT_TEXT_PRIMARY_OVERLAY;
export const COLOR_LIGHT_BORDER_ICON_BUTTON_PRIMARY = COLOR_LIGHT_BORDER_OVERLAY;
export const COLOR_LIGHT_BORDER_ICON_BUTTON_SECONDARY = COLOR_LIGHT_BORDER_SECONDARY;
export const COLOR_LIGHT_BORDER_ICON_BUTTON_DISABLED = COLOR_LIGHT_BORDER_DISABLED;
export const COLOR_LIGHT_FOREGROUND_MODAL_HEADING = COLOR_LIGHT_TEXT_PRIMARY;
export const COLOR_LIGHT_FOREGROUND_MODAL_BODY = COLOR_LIGHT_TEXT_SECONDARY;
export const COLOR_LIGHT_FOREGROUND_MODAL_ICON = COLOR_LIGHT_ICON_BRAND;
export const COLOR_LIGHT_ACTION_NAVIGATION_SECONDARY_DISABLED = COLOR_LIGHT_ICON_DISABLED;
export const COLOR_LIGHT_BORDER_PASSIONS_ACTIVE = COLOR_LIGHT_BORDER_BRAND;
export const COLOR_LIGHT_BORDER_PASSIONS_INACTIVE = COLOR_LIGHT_BORDER_SECONDARY;
export const COLOR_LIGHT_BORDER_PASSIONS_SHARED = COLOR_LIGHT_BORDER_BRAND;
export const COLOR_LIGHT_BORDER_PASSIONS_SHARED_OVERLAY = COLOR_LIGHT_BORDER_OVERLAY;
export const COLOR_LIGHT_TEXT_PASSIONS_ACTIVE = COLOR_LIGHT_TEXT_PRIMARY;
export const COLOR_LIGHT_TEXT_PASSIONS_INACTIVE = COLOR_LIGHT_TEXT_INACTIVE;
export const COLOR_LIGHT_TEXT_PASSIONS_SHARED = COLOR_LIGHT_TEXT_PRIMARY;
export const COLOR_LIGHT_TEXT_PASSIONS_SHARED_REC = COLOR_LIGHT_TEXT_PRIMARY_OVERLAY;
export const COLOR_LIGHT_TEXT_PASSIONS_INACTIVE_OVERLAY = COLOR_LIGHT_TEXT_PRIMARY_OVERLAY;
export const COLOR_LIGHT_TEXT_PASSIONS_SHARED_OVERLAY = COLOR_LIGHT_TEXT_PRIMARY_OVERLAY;
export const COLOR_LIGHT_BACKGROUND_RADIO_SELECTED_ENABLED = COLOR_LIGHT_BACKGROUND_BRAND;
export const COLOR_LIGHT_BACKGROUND_RADIO_UNSELECTED_DISABLED = COLOR_LIGHT_BACKGROUND_DISABLED;
export const COLOR_LIGHT_BORDER_RADIO_SELECTED_ENABLED = COLOR_LIGHT_BORDER_BRAND;
export const COLOR_LIGHT_BORDER_RADIO_SELECTED_DISABLED = COLOR_LIGHT_BORDER_DISABLED;
export const COLOR_LIGHT_BORDER_RADIO_UNSELECTED_ENABLED = COLOR_LIGHT_BORDER_PRIMARY;
export const COLOR_LIGHT_BORDER_RADIO_UNSELECTED_DISABLED = COLOR_LIGHT_BORDER_DISABLED;
export const COLOR_LIGHT_ICON_RADIO_SELECTED_ENABLED = COLOR_LIGHT_ICON_PRIMARY_INVERSE;
export const COLOR_LIGHT_BORDER_REC_CARD_CONTENT_HIDDEN = COLOR_LIGHT_BORDER_OVERLAY;
export const COLOR_LIGHT_ICON_REC_CARD_CONTENT_HIDDEN = COLOR_LIGHT_ICON_PRIMARY_OVERLAY;
export const COLOR_LIGHT_TEXT_REC_CARD_CONTENT_HIDDEN = COLOR_LIGHT_TEXT_PRIMARY_OVERLAY;
export const COLOR_LIGHT_CURSOR_SEARCH_INPUT = COLOR_LIGHT_CURSOR_DEFAULT;
export const COLOR_LIGHT_TEXT_SEARCH_PLACEHOLDER_INACTIVE = COLOR_LIGHT_TEXT_INACTIVE;
export const COLOR_LIGHT_TEXT_SEARCH_INPUT_ACTIVE = COLOR_LIGHT_TEXT_PRIMARY;
export const COLOR_LIGHT_TEXT_SEARCH_INPUT_INACTIVE = COLOR_LIGHT_TEXT_PRIMARY;
export const COLOR_LIGHT_ICON_SELECTOR_SELECTED_ENABLED = COLOR_LIGHT_ICON_BRAND;
export const COLOR_LIGHT_ICON_SELECTOR_SELECTED_DISABLED = COLOR_LIGHT_ICON_DISABLED;
export const COLOR_LIGHT_BACKGROUND_SLIDER_ALT_TRACK_DISABLED = COLOR_LIGHT_BACKGROUND_DISABLED;
export const COLOR_LIGHT_BACKGROUND_SLIDER_ALT_KNOB_ENABLED = COLOR_LIGHT_BACKGROUND_BRAND;
export const COLOR_LIGHT_BACKGROUND_SLIDER_ALT_KNOB_DISABLED = COLOR_LIGHT_BORDER_DISABLED;
export const COLOR_LIGHT_BACKGROUND_SLIDER_ALT_FILL_ENABLED = COLOR_LIGHT_BACKGROUND_BRAND;
export const COLOR_LIGHT_BACKGROUND_SLIDER_ALT_FILL_DISABLED = COLOR_LIGHT_BORDER_DISABLED;
export const COLOR_LIGHT_BACKGROUND_SLIDER_DEFAULT_TRACK_DISABLED = COLOR_LIGHT_BACKGROUND_DISABLED;
export const COLOR_LIGHT_BACKGROUND_SLIDER_DEFAULT_FILL_ENABLED = COLOR_LIGHT_BACKGROUND_BRAND;
export const COLOR_LIGHT_BACKGROUND_SLIDER_DEFAULT_FILL_DISABLED = COLOR_LIGHT_BORDER_DISABLED;
export const COLOR_LIGHT_BORDER_SLIDER_ALT_KNOB_ENABLED = COLOR_LIGHT_BORDER_BRAND;
export const COLOR_LIGHT_BORDER_SLIDER_ALT_KNOB_DISABLED = COLOR_LIGHT_BORDER_DISABLED;
export const COLOR_LIGHT_BORDER_SLIDER_DEFAULT_KNOB_ENABLED = COLOR_LIGHT_BORDER_PRIMARY;
export const COLOR_LIGHT_BORDER_SLIDER_DEFAULT_KNOB_DISABLED = COLOR_LIGHT_BORDER_DISABLED;
export const COLOR_LIGHT_BACKGROUND_SWITCH_ALT_TRACK_DISABLED = COLOR_LIGHT_BACKGROUND_DISABLED;
export const COLOR_LIGHT_BACKGROUND_SWITCH_ALT_KNOB_SELECTED = COLOR_LIGHT_BACKGROUND_BRAND;
export const COLOR_LIGHT_BACKGROUND_SWITCH_DEFAULT_TRACK_SELECTED = COLOR_LIGHT_BACKGROUND_BRAND;
export const COLOR_LIGHT_BACKGROUND_SWITCH_DEFAULT_TRACK_DISABLED = COLOR_LIGHT_BACKGROUND_DISABLED;
export const COLOR_LIGHT_BACKGROUND_SWITCH_DEFAULT_KNOB_SELECTED = COLOR_LIGHT_ICON_PRIMARY_OVERLAY;
export const COLOR_LIGHT_BACKGROUND_SWITCH_DEFAULT_KNOB_DISABLED = COLOR_LIGHT_ICON_PRIMARY_OVERLAY;
export const COLOR_LIGHT_BORDER_SWITCH_ALT_TRACK_SELECTED = COLOR_LIGHT_BORDER_BRAND;
export const COLOR_LIGHT_BORDER_SWITCH_ALT_TRACK_UNSELECTED = COLOR_LIGHT_BORDER_PRIMARY;
export const COLOR_LIGHT_BORDER_SWITCH_ALT_TRACK_DISABLED = COLOR_LIGHT_BORDER_DISABLED;
export const COLOR_LIGHT_BORDER_SWITCH_ALT_KNOB_SELECTED = COLOR_LIGHT_BORDER_BRAND;
export const COLOR_LIGHT_BORDER_SWITCH_ALT_KNOB_UNSELECTED = COLOR_LIGHT_BORDER_PRIMARY;
export const COLOR_LIGHT_BORDER_SWITCH_DEFAULT_TRACK_SELECTED = COLOR_LIGHT_BORDER_BRAND;
export const COLOR_LIGHT_BORDER_SWITCH_DEFAULT_TRACK_UNSELECTED = COLOR_LIGHT_BORDER_PRIMARY;
export const COLOR_LIGHT_BORDER_SWITCH_DEFAULT_TRACK_DISABLED = COLOR_LIGHT_BORDER_DISABLED;
export const COLOR_LIGHT_BORDER_SWITCH_DEFAULT_KNOB_SELECTED = COLOR_LIGHT_BORDER_BRAND;
export const COLOR_LIGHT_BORDER_SWITCH_DEFAULT_KNOB_UNSELECTED = COLOR_LIGHT_BORDER_PRIMARY;
export const COLOR_LIGHT_BORDER_SWITCH_DEFAULT_KNOB_DISABLED = COLOR_LIGHT_BORDER_DISABLED;
export const COLOR_LIGHT_ICON_SWITCH_ALT_SELECTED = COLOR_LIGHT_ICON_PRIMARY_OVERLAY;
export const COLOR_LIGHT_ICON_SWITCH_ALT_UNSELECTED = COLOR_LIGHT_ICON_PRIMARY_OVERLAY;
export const COLOR_LIGHT_ICON_SWITCH_ALT_DISABLED = COLOR_LIGHT_ICON_PRIMARY_OVERLAY;
export const COLOR_LIGHT_ICON_SWITCH_DEFAULT_SELECTED = COLOR_LIGHT_ICON_BRAND;
export const COLOR_LIGHT_ICON_SWITCH_DEFAULT_DISABLED = COLOR_LIGHT_ICON_DISABLED;
export const COLOR_LIGHT_DIVIDER_TABLE_ROW_DEFAULT = COLOR_LIGHT_DIVIDER_PRIMARY;
export const COLOR_LIGHT_DIVIDER_TABLE_ROW_SPARKS = COLOR_LIGHT_DIVIDER_SPARKS;
export const COLOR_LIGHT_BORDER_TAPPY_INDICATOR_INACTIVE = COLOR_LIGHT_BORDER_PRIMARY;
export const COLOR_LIGHT_ACTION_TEXT_FIELD_QUIET_INACTIVE = COLOR_LIGHT_ACTION_INACTIVE;
export const COLOR_LIGHT_ACTION_TEXT_FIELD_QUIET_ACTIVE = COLOR_LIGHT_ACTION_ACTIVE;
export const COLOR_LIGHT_ACTION_TEXT_FIELD_LOUD_INACTIVE = COLOR_LIGHT_ACTION_INACTIVE;
export const COLOR_LIGHT_ACTION_TEXT_FIELD_LOUD_ACTIVE = COLOR_LIGHT_ACTION_ACTIVE;
export const COLOR_LIGHT_BORDER_TEXT_FIELD_QUIET_DEFAULT = COLOR_LIGHT_BORDER_PRIMARY;
export const COLOR_LIGHT_BORDER_TEXT_FIELD_QUIET_ERROR = COLOR_LIGHT_BORDER_ERROR;
export const COLOR_LIGHT_BORDER_TEXT_FIELD_QUIET_FOCUS = COLOR_LIGHT_BORDER_ACTIVE;
export const COLOR_LIGHT_BORDER_TEXT_FIELD_QUIET_DISABLED = COLOR_LIGHT_BORDER_DISABLED;
export const COLOR_LIGHT_BORDER_TEXT_FIELD_LOUD_ERROR = COLOR_LIGHT_BORDER_ERROR;
export const COLOR_LIGHT_BORDER_TEXT_FIELD_LOUD_FOCUS = COLOR_LIGHT_BORDER_ACTIVE;
export const COLOR_LIGHT_BORDER_TEXT_FIELD_LOUD_DISABLED = COLOR_LIGHT_BORDER_DISABLED;
export const COLOR_LIGHT_CURSOR_TEXT_FIELD_QUIET_DEFAULT = COLOR_LIGHT_CURSOR_DEFAULT;
export const COLOR_LIGHT_CURSOR_TEXT_FIELD_LOUD_DEFAULT = COLOR_LIGHT_CURSOR_DEFAULT;
export const COLOR_LIGHT_TEXT_TEXT_FIELD_QUIET_CHARACTERCOUNT_DEFAULT = COLOR_LIGHT_TEXT_INACTIVE;
export const COLOR_LIGHT_TEXT_TEXT_FIELD_LOUD_CHARACTERCOUNT_DEFAULT = COLOR_LIGHT_TEXT_INACTIVE;
export const COLOR_LIGHT_TEXT_TEXT_FIELD_QUIET_LABEL_OPTIONAL = COLOR_LIGHT_TEXT_SECONDARY;
export const COLOR_LIGHT_TEXT_TEXT_FIELD_QUIET_LABEL_ERROR = COLOR_LIGHT_TEXT_ERROR;
export const COLOR_LIGHT_TEXT_TEXT_FIELD_LOUD_LABEL_OPTIONAL = COLOR_LIGHT_TEXT_SECONDARY;
export const COLOR_LIGHT_TEXT_TEXT_FIELD_LOUD_LABEL_ERROR = COLOR_LIGHT_TEXT_ERROR;
export const COLOR_LIGHT_TEXT_TEXT_FIELD_QUIET_PLACEHOLDER_DEFAULT = COLOR_LIGHT_TEXT_INACTIVE;
export const COLOR_LIGHT_TEXT_TEXT_FIELD_LOUD_PLACEHOLDER_DEFAULT = COLOR_LIGHT_TEXT_INACTIVE;
export const COLOR_LIGHT_TEXT_TEXT_FIELD_QUIET_INPUT_DEFAULT = COLOR_LIGHT_TEXT_PRIMARY;
export const COLOR_LIGHT_TEXT_TEXT_FIELD_QUIET_INPUT_DISABLED = COLOR_LIGHT_TEXT_DISABLED;
export const COLOR_LIGHT_TEXT_TEXT_FIELD_LOUD_INPUT_DEFAULT = COLOR_LIGHT_TEXT_PRIMARY;
export const COLOR_LIGHT_TEXT_TEXT_FIELD_LOUD_INPUT_DISABLED = COLOR_LIGHT_TEXT_DISABLED;
export const COLOR_LIGHT_ICON_TOOLTIP_DISMISS = COLOR_LIGHT_ICON_PRIMARY_INVERSE;
export const COLOR_LIGHT_TEXT_TOOLTIP_DEFAULT = COLOR_LIGHT_TEXT_PRIMARY_INVERSE;
export const COLOR_LIGHT_TEXT_TOOLTIP_REVENUE_DEFAULT = COLOR_LIGHT_TEXT_PRIMARY_INVERSE;
export const COLOR_LIGHT_TEXT_TOOLTIP_TRUST_DEFAULT = COLOR_LIGHT_TEXT_PRIMARY_OVERLAY;
export const COLOR_LIGHT_BACKGROUND_CARD_DEFAULT = COLOR_LIGHT_BACKGROUND_ELEVATED;
export const COLOR_LIGHT_BORDER_CONTAINER_ELEVATED = COLOR_LIGHT_FOREGROUND_BORDER_ELEVATED;
export const GRADIENT_DARK_BACKGROUND_GAMEPAD_NOPE_PRESSED = GRADIENT_GAMEPAD_NOPE;
export const GRADIENT_DARK_ICON_GAMEPAD_PRIMARY_NOPE_DEFAULT = GRADIENT_GAMEPAD_NOPE;
export const GRADIENT_DARK_ICON_GAMEPAD_SECONDARY_NOPE_DEFAULT = GRADIENT_GAMEPAD_NOPE;
export const GRADIENT_DARK_BACKGROUND_BRAND_GRADIENT = GRADIENT_DARK_ACCENT_PRIMARY_GRADIENT;
export const GRADIENT_DARK_BACKGROUND_REWIND = GRADIENT_DARK_ACCENT_REWIND_GRADIENT;
export const GRADIENT_DARK_BACKGROUND_REWIND_INVERSE = GRADIENT_DARK_ACCENT_REWIND_GRADIENT;
export const GRADIENT_DARK_BACKGROUND_NOPE = GRADIENT_DARK_ACCENT_NOPE_GRADIENT;
export const GRADIENT_DARK_BACKGROUND_NOPE_INVERSE = GRADIENT_DARK_ACCENT_NOPE_GRADIENT;
export const GRADIENT_DARK_BACKGROUND_SUPER_BOOST = GRADIENT_DARK_ACCENT_SUPER_BOOST_GRADIENT;
export const GRADIENT_DARK_BACKGROUND_SUPER_BOOST_INVERSE =
  GRADIENT_DARK_ACCENT_SUPER_BOOST_GRADIENT;
export const GRADIENT_DARK_BACKGROUND_GOLD = GRADIENT_DARK_ACCENT_GOLD_GRADIENT;
export const GRADIENT_DARK_BACKGROUND_GOLD_INVERSE = GRADIENT_DARK_ACCENT_GOLD_GRADIENT;
export const GRADIENT_DARK_BACKGROUND_GOLD_SHINE = GRADIENT_DARK_ACCENT_GOLD_SHINE_GRADIENT;
export const GRADIENT_DARK_BACKGROUND_GOLD_SHINE_INVERSE = GRADIENT_DARK_ACCENT_GOLD_SHINE_GRADIENT;
export const GRADIENT_DARK_BACKGROUND_PLATINUM = GRADIENT_DARK_ACCENT_PLATINUM_GRADIENT;
export const GRADIENT_DARK_BACKGROUND_PLATINUM_INVERSE =
  GRADIENT_DARK_ACCENT_PLATINUM_GRADIENT_INVERSE;
export const GRADIENT_DARK_BACKGROUND_PLATINUM_SHINE = GRADIENT_DARK_ACCENT_PLATINUM_SHINE_GRADIENT;
export const GRADIENT_DARK_BACKGROUND_PLATINUM_SHINE_INVERSE =
  GRADIENT_DARK_ACCENT_PLATINUM_SHINE_GRADIENT_INVERSE;
export const GRADIENT_DARK_BACKGROUND_VAULT_GRADIENT = GRADIENT_DARK_ACCENT_SELECT_GRADIENT;
export const GRADIENT_DARK_BACKGROUND_VAULT_SUBTLE = GRADIENT_DARK_BACKGROUND_SELECT_SUBTLE;
export const GRADIENT_DARK_BACKGROUND_MATCH_EXPIRATION =
  GRADIENT_DARK_ACCENT_MATCH_EXPIRATION_GRADIENT;
export const GRADIENT_DARK_BACKGROUND_EXPLORE_ATTRIBUTION = GRADIENT_DARK_ACCENT_EXPLORE_GRADIENT;
export const GRADIENT_DARK_BACKGROUND_FESTIVAL_MODE = GRADIENT_DARK_ACCENT_FESTIVAL_MODE_GRADIENT;
export const GRADIENT_DARK_BACKGROUND_HOT_TAKES = GRADIENT_DARK_ACCENT_HOT_TAKES_GRADIENT;
export const GRADIENT_DARK_BACKGROUND_SPOTIFY_MUSIC_MODE =
  GRADIENT_DARK_ACCENT_SPOTIFY_MUSIC_MODE_GRADIENT;
export const GRADIENT_DARK_BACKGROUND_SPARKS_LIKE = GRADIENT_DARK_ACCENT_SPARKS_LIKE_GRADIENT;
export const GRADIENT_DARK_BACKGROUND_SPARKS_NOPE = GRADIENT_DARK_ACCENT_SPARKS_NOPE_GRADIENT;
export const GRADIENT_DARK_BACKGROUND_SPARKS_SUPER_LIKE =
  GRADIENT_DARK_ACCENT_SPARKS_SUPER_LIKE_GRADIENT;
export const GRADIENT_DARK_BACKGROUND_SPARKS_BOOST = GRADIENT_DARK_ACCENT_SPARKS_BOOST_GRADIENT;
export const GRADIENT_DARK_BACKGROUND_SPARKS_REWIND = GRADIENT_DARK_ACCENT_SPARKS_REWIND_GRADIENT;
export const GRADIENT_DARK_BORDER_BRAND_GRADIENT = GRADIENT_DARK_ACCENT_PRIMARY_GRADIENT;
export const GRADIENT_DARK_BORDER_VAULT_GRADIENT = GRADIENT_DARK_ACCENT_SELECT_GRADIENT;
export const GRADIENT_DARK_BORDER_MATCH_EXPIRATION = GRADIENT_DARK_ACCENT_MATCH_EXPIRATION_GRADIENT;
export const GRADIENT_DARK_BORDER_SPARKS_PROMPT_SELECTED = GRADIENT_DARK_ACCENT_PASSIONS_GRADIENT;
export const GRADIENT_DARK_ICON_BRAND_GRADIENT = GRADIENT_DARK_ACCENT_PRIMARY_GRADIENT;
export const GRADIENT_DARK_ICON_LIKE = GRADIENT_DARK_ACCENT_LIKE_GRADIENT;
export const GRADIENT_DARK_ICON_NOPE = GRADIENT_DARK_ACCENT_NOPE_GRADIENT;
export const GRADIENT_DARK_ICON_SUPERLIKE = GRADIENT_DARK_ACCENT_SUPER_LIKE_GRADIENT;
export const GRADIENT_DARK_ICON_BOOST = GRADIENT_DARK_ACCENT_BOOST_GRADIENT;
export const GRADIENT_DARK_ICON_REWIND = GRADIENT_DARK_ACCENT_REWIND_GRADIENT;
export const GRADIENT_DARK_ICON_GOLD = GRADIENT_DARK_ACCENT_GOLD_GRADIENT;
export const GRADIENT_DARK_ICON_PLATINUM = GRADIENT_DARK_ACCENT_PLATINUM_GRADIENT;
export const GRADIENT_DARK_ICON_CHAT_DRAWER_VIBES_ACTIVE = GRADIENT_DARK_ACCENT_VIBES_GRADIENT;
export const GRADIENT_DARK_ICON_VAULT_GRADIENT = GRADIENT_DARK_ACCENT_SELECT_GRADIENT;
export const GRADIENT_DARK_ICON_MATCH_EXPIRATION = GRADIENT_DARK_ACCENT_MATCH_EXPIRATION_GRADIENT;
export const GRADIENT_DARK_ICON_SPARKS_LIKE = GRADIENT_DARK_ACCENT_SPARKS_LIKE_GRADIENT;
export const GRADIENT_DARK_ICON_SPARKS_NOPE = GRADIENT_DARK_ACCENT_SPARKS_NOPE_GRADIENT;
export const GRADIENT_DARK_ICON_SPARKS_SUPER_LIKE = GRADIENT_DARK_ACCENT_SPARKS_SUPER_LIKE_GRADIENT;
export const GRADIENT_DARK_ICON_SPARKS_BOOST = GRADIENT_DARK_ACCENT_SPARKS_BOOST_GRADIENT;
export const GRADIENT_DARK_ICON_SPARKS_REWIND = GRADIENT_DARK_ACCENT_SPARKS_REWIND_GRADIENT;
export const GRADIENT_DARK_ICON_SPARKS_MATCHMAKER_ATTRIBUTION =
  GRADIENT_DARK_ACCENT_MATCHMAKER_GRADIENT;
export const GRADIENT_DARK_TEXT_MATCH_EXPIRATION = GRADIENT_DARK_ACCENT_MATCH_EXPIRATION_GRADIENT;
export const GRADIENT_DARK_TEXT_SPARKS_MATCHMAKER_ATTRIBUTION =
  GRADIENT_DARK_ACCENT_MATCHMAKER_GRADIENT;
export const GRADIENT_LIGHT_BACKGROUND_GAMEPAD_NOPE_PRESSED = GRADIENT_GAMEPAD_NOPE;
export const GRADIENT_LIGHT_ICON_GAMEPAD_PRIMARY_NOPE_DEFAULT = GRADIENT_GAMEPAD_NOPE;
export const GRADIENT_LIGHT_ICON_GAMEPAD_SECONDARY_NOPE_DEFAULT = GRADIENT_GAMEPAD_NOPE;
export const GRADIENT_LIGHT_ACCENT_NOPE_GRADIENT = GRADIENT_GAMEPAD_NOPE;
export const GRADIENT_LIGHT_BACKGROUND_BRAND_GRADIENT = GRADIENT_LIGHT_ACCENT_PRIMARY_GRADIENT;
export const GRADIENT_LIGHT_BACKGROUND_REWIND = GRADIENT_LIGHT_ACCENT_REWIND_GRADIENT;
export const GRADIENT_LIGHT_BACKGROUND_REWIND_INVERSE = GRADIENT_LIGHT_ACCENT_REWIND_GRADIENT;
export const GRADIENT_LIGHT_BACKGROUND_SUPER_BOOST = GRADIENT_LIGHT_ACCENT_SUPER_BOOST_GRADIENT;
export const GRADIENT_LIGHT_BACKGROUND_SUPER_BOOST_INVERSE =
  GRADIENT_LIGHT_ACCENT_SUPER_BOOST_GRADIENT;
export const GRADIENT_LIGHT_BACKGROUND_GOLD = GRADIENT_LIGHT_ACCENT_GOLD_GRADIENT;
export const GRADIENT_LIGHT_BACKGROUND_GOLD_INVERSE = GRADIENT_LIGHT_ACCENT_GOLD_GRADIENT;
export const GRADIENT_LIGHT_BACKGROUND_GOLD_SHINE = GRADIENT_LIGHT_ACCENT_GOLD_SHINE_GRADIENT;
export const GRADIENT_LIGHT_BACKGROUND_GOLD_SHINE_INVERSE =
  GRADIENT_LIGHT_ACCENT_GOLD_SHINE_GRADIENT;
export const GRADIENT_LIGHT_BACKGROUND_PLATINUM = GRADIENT_LIGHT_ACCENT_PLATINUM_GRADIENT;
export const GRADIENT_LIGHT_BACKGROUND_PLATINUM_INVERSE =
  GRADIENT_LIGHT_ACCENT_PLATINUM_GRADIENT_INVERSE;
export const GRADIENT_LIGHT_BACKGROUND_PLATINUM_SHINE =
  GRADIENT_LIGHT_ACCENT_PLATINUM_SHINE_GRADIENT;
export const GRADIENT_LIGHT_BACKGROUND_PLATINUM_SHINE_INVERSE =
  GRADIENT_LIGHT_ACCENT_PLATINUM_SHINE_GRADIENT_INVERSE;
export const GRADIENT_LIGHT_BACKGROUND_VAULT_GRADIENT = GRADIENT_LIGHT_ACCENT_SELECT_GRADIENT;
export const GRADIENT_LIGHT_BACKGROUND_VAULT_SUBTLE = GRADIENT_LIGHT_BACKGROUND_SELECT_SUBTLE;
export const GRADIENT_LIGHT_BACKGROUND_MATCH_EXPIRATION =
  GRADIENT_LIGHT_ACCENT_MATCH_EXPIRATION_GRADIENT;
export const GRADIENT_LIGHT_BACKGROUND_EXPLORE_ATTRIBUTION = GRADIENT_LIGHT_ACCENT_EXPLORE_GRADIENT;
export const GRADIENT_LIGHT_BACKGROUND_FESTIVAL_MODE = GRADIENT_LIGHT_ACCENT_FESTIVAL_MODE_GRADIENT;
export const GRADIENT_LIGHT_BACKGROUND_HOT_TAKES = GRADIENT_LIGHT_ACCENT_HOT_TAKES_GRADIENT;
export const GRADIENT_LIGHT_BACKGROUND_SPOTIFY_MUSIC_MODE =
  GRADIENT_LIGHT_ACCENT_SPOTIFY_MUSIC_MODE_GRADIENT;
export const GRADIENT_LIGHT_BACKGROUND_SPARKS_LIKE = GRADIENT_LIGHT_ACCENT_SPARKS_LIKE_GRADIENT;
export const GRADIENT_LIGHT_BACKGROUND_SPARKS_NOPE = GRADIENT_LIGHT_ACCENT_SPARKS_NOPE_GRADIENT;
export const GRADIENT_LIGHT_BACKGROUND_SPARKS_SUPER_LIKE =
  GRADIENT_LIGHT_ACCENT_SPARKS_SUPER_LIKE_GRADIENT;
export const GRADIENT_LIGHT_BACKGROUND_SPARKS_BOOST = GRADIENT_LIGHT_ACCENT_SPARKS_BOOST_GRADIENT;
export const GRADIENT_LIGHT_BACKGROUND_SPARKS_REWIND = GRADIENT_LIGHT_ACCENT_SPARKS_REWIND_GRADIENT;
export const GRADIENT_LIGHT_BORDER_BRAND_GRADIENT = GRADIENT_LIGHT_ACCENT_PRIMARY_GRADIENT;
export const GRADIENT_LIGHT_BORDER_VAULT_GRADIENT = GRADIENT_LIGHT_ACCENT_SELECT_GRADIENT;
export const GRADIENT_LIGHT_BORDER_MATCH_EXPIRATION =
  GRADIENT_LIGHT_ACCENT_MATCH_EXPIRATION_GRADIENT;
export const GRADIENT_LIGHT_BORDER_SPARKS_PROMPT_SELECTED = GRADIENT_LIGHT_ACCENT_PASSIONS_GRADIENT;
export const GRADIENT_LIGHT_ICON_BRAND_GRADIENT = GRADIENT_LIGHT_ACCENT_PRIMARY_GRADIENT;
export const GRADIENT_LIGHT_ICON_LIKE = GRADIENT_LIGHT_ACCENT_LIKE_GRADIENT;
export const GRADIENT_LIGHT_ICON_SUPERLIKE = GRADIENT_LIGHT_ACCENT_SUPER_LIKE_GRADIENT;
export const GRADIENT_LIGHT_ICON_BOOST = GRADIENT_LIGHT_ACCENT_BOOST_GRADIENT;
export const GRADIENT_LIGHT_ICON_REWIND = GRADIENT_LIGHT_ACCENT_REWIND_GRADIENT;
export const GRADIENT_LIGHT_ICON_GOLD = GRADIENT_LIGHT_ACCENT_GOLD_GRADIENT;
export const GRADIENT_LIGHT_ICON_PLATINUM = GRADIENT_LIGHT_ACCENT_PLATINUM_GRADIENT;
export const GRADIENT_LIGHT_ICON_CHAT_DRAWER_VIBES_ACTIVE = GRADIENT_LIGHT_ACCENT_VIBES_GRADIENT;
export const GRADIENT_LIGHT_ICON_VAULT_GRADIENT = GRADIENT_LIGHT_ACCENT_SELECT_GRADIENT;
export const GRADIENT_LIGHT_ICON_MATCH_EXPIRATION = GRADIENT_LIGHT_ACCENT_MATCH_EXPIRATION_GRADIENT;
export const GRADIENT_LIGHT_ICON_SPARKS_LIKE = GRADIENT_LIGHT_ACCENT_SPARKS_LIKE_GRADIENT;
export const GRADIENT_LIGHT_ICON_SPARKS_NOPE = GRADIENT_LIGHT_ACCENT_SPARKS_NOPE_GRADIENT;
export const GRADIENT_LIGHT_ICON_SPARKS_SUPER_LIKE =
  GRADIENT_LIGHT_ACCENT_SPARKS_SUPER_LIKE_GRADIENT;
export const GRADIENT_LIGHT_ICON_SPARKS_BOOST = GRADIENT_LIGHT_ACCENT_SPARKS_BOOST_GRADIENT;
export const GRADIENT_LIGHT_ICON_SPARKS_REWIND = GRADIENT_LIGHT_ACCENT_SPARKS_REWIND_GRADIENT;
export const GRADIENT_LIGHT_ICON_SPARKS_MATCHMAKER_ATTRIBUTION =
  GRADIENT_LIGHT_ACCENT_MATCHMAKER_GRADIENT;
export const GRADIENT_LIGHT_TEXT_MATCH_EXPIRATION = GRADIENT_LIGHT_ACCENT_MATCH_EXPIRATION_GRADIENT;
export const GRADIENT_LIGHT_TEXT_SPARKS_MATCHMAKER_ATTRIBUTION =
  GRADIENT_LIGHT_ACCENT_MATCHMAKER_GRADIENT;
export const COLOR_DARK_BORDER_CARD = COLOR_DARK_BORDER_CONTAINER_ELEVATED;
export const COLOR_LIGHT_BORDER_CARD = COLOR_LIGHT_BORDER_CONTAINER_ELEVATED;
export const GRADIENT_DARK_BACKGROUND_ICON_BUTTON_PRIMARY = GRADIENT_DARK_BACKGROUND_BRAND_GRADIENT;
export const GRADIENT_LIGHT_BACKGROUND_ICON_BUTTON_PRIMARY =
  GRADIENT_LIGHT_BACKGROUND_BRAND_GRADIENT;
export const GRADIENT_LIGHT_BACKGROUND_NOPE = GRADIENT_LIGHT_ACCENT_NOPE_GRADIENT;
export const GRADIENT_LIGHT_BACKGROUND_NOPE_INVERSE = GRADIENT_LIGHT_ACCENT_NOPE_GRADIENT;
export const GRADIENT_LIGHT_ICON_NOPE = GRADIENT_LIGHT_ACCENT_NOPE_GRADIENT;
